export const bigIconList = {
    SMILEYS: [
        {
            "no": 1,
            "code": "1F600",
            "flagged": false,
            "keywords": [
                "face",
                "grin"
            ]
        },
        {
            "no": 2,
            "code": "1F601",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "grin",
                "smile"
            ]
        },
        {
            "no": 3,
            "code": "1F602",
            "flagged": false,
            "keywords": [
                "face",
                "joy",
                "laugh",
                "tear"
            ]
        },
        {
            "no": 4,
            "code": "1F923",
            "flagged": true,
            "keywords": [
                "face",
                "floor",
                "laugh",
                "lol",
                "rofl",
                "rolling"
            ]
        },
        {
            "no": 5,
            "code": "1F603",
            "flagged": false,
            "keywords": [
                "face",
                "mouth",
                "open",
                "smile"
            ]
        },
        {
            "no": 6,
            "code": "1F604",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "mouth",
                "open",
                "smile"
            ]
        },
        {
            "no": 7,
            "code": "1F605",
            "flagged": false,
            "keywords": [
                "cold",
                "face",
                "open",
                "smile",
                "sweat"
            ]
        },
        {
            "no": 8,
            "code": "1F606",
            "flagged": false,
            "keywords": [
                "face",
                "laugh",
                "mouth",
                "open",
                "satisfied",
                "smile"
            ]
        },
        {
            "no": 9,
            "code": "1F609",
            "flagged": false,
            "keywords": [
                "face",
                "wink"
            ]
        },
        {
            "no": 10,
            "code": "1F60A",
            "flagged": false,
            "keywords": [
                "blush",
                "eye",
                "face",
                "smile"
            ]
        },
        {
            "no": 11,
            "code": "1F60B",
            "flagged": false,
            "keywords": [
                "delicious",
                "face",
                "savouring",
                "smile",
                "um",
                "yum"
            ]
        },
        {
            "no": 12,
            "code": "1F60E",
            "flagged": false,
            "keywords": [
                "bright",
                "cool",
                "eye",
                "eyewear",
                "face",
                "glasses",
                "smile",
                "sun",
                "sunglasses",
                "weather"
            ]
        },
        {
            "no": 13,
            "code": "1F60D",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "heart",
                "love",
                "smile"
            ]
        },
        {
            "no": 14,
            "code": "1F618",
            "flagged": false,
            "keywords": [
                "face",
                "heart",
                "kiss"
            ]
        },
        {
            "no": 15,
            "code": "1F617",
            "flagged": false,
            "keywords": [
                "face",
                "kiss"
            ]
        },
        {
            "no": 16,
            "code": "1F619",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "kiss",
                "smile"
            ]
        },
        {
            "no": 17,
            "code": "1F61A",
            "flagged": false,
            "keywords": [
                "closed",
                "eye",
                "face",
                "kiss"
            ]
        },
        {
            "no": 18,
            "code": "263A",
            "flagged": false,
            "keywords": [
                "face",
                "outlined",
                "relaxed",
                "smile"
            ]
        },
        {
            "no": 19,
            "code": "1F642",
            "flagged": false,
            "keywords": [
                "face",
                "smile"
            ]
        },
        {
            "no": 20,
            "code": "1F917",
            "flagged": false,
            "keywords": [
                "face",
                "hug",
                "hugging"
            ]
        },
        {
            "no": 21,
            "code": "1F914",
            "flagged": false,
            "keywords": [
                "face",
                "thinking"
            ]
        },
        {
            "no": 22,
            "code": "1F610",
            "flagged": false,
            "keywords": [
                "deadpan",
                "face",
                "neutral"
            ]
        },
        {
            "no": 23,
            "code": "1F611",
            "flagged": false,
            "keywords": [
                "expressionless",
                "face",
                "inexpressive",
                "unexpressive"
            ]
        },
        {
            "no": 24,
            "code": "1F636",
            "flagged": false,
            "keywords": [
                "face",
                "mouth",
                "quiet",
                "silent"
            ]
        },
        {
            "no": 25,
            "code": "1F644",
            "flagged": false,
            "keywords": [
                "eyes",
                "face",
                "rolling"
            ]
        },
        {
            "no": 26,
            "code": "1F60F",
            "flagged": false,
            "keywords": [
                "face",
                "smirk"
            ]
        },
        {
            "no": 27,
            "code": "1F623",
            "flagged": false,
            "keywords": [
                "face",
                "persevere"
            ]
        },
        {
            "no": 28,
            "code": "1F625",
            "flagged": false,
            "keywords": [
                "disappointed",
                "face",
                "relieved",
                "whew"
            ]
        },
        {
            "no": 29,
            "code": "1F62E",
            "flagged": false,
            "keywords": [
                "face",
                "mouth",
                "open",
                "sympathy"
            ]
        },
        {
            "no": 30,
            "code": "1F910",
            "flagged": false,
            "keywords": [
                "face",
                "mouth",
                "zipper"
            ]
        },
        {
            "no": 31,
            "code": "1F62F",
            "flagged": false,
            "keywords": [
                "face",
                "hushed",
                "stunned",
                "surprised"
            ]
        },
        {
            "no": 32,
            "code": "1F62A",
            "flagged": false,
            "keywords": [
                "face",
                "sleep"
            ]
        },
        {
            "no": 33,
            "code": "1F62B",
            "flagged": false,
            "keywords": [
                "face",
                "tired"
            ]
        },
        {
            "no": 34,
            "code": "1F634",
            "flagged": false,
            "keywords": [
                "face",
                "sleep",
                "zzz"
            ]
        },
        {
            "no": 35,
            "code": "1F60C",
            "flagged": false,
            "keywords": [
                "face",
                "relieved"
            ]
        },
        {
            "no": 36,
            "code": "1F913",
            "flagged": false,
            "keywords": [
                "face",
                "geek",
                "nerd"
            ]
        },
        {
            "no": 37,
            "code": "1F61B",
            "flagged": false,
            "keywords": [
                "face",
                "tongue"
            ]
        },
        {
            "no": 38,
            "code": "1F61C",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "joke",
                "tongue",
                "wink"
            ]
        },
        {
            "no": 39,
            "code": "1F61D",
            "flagged": false,
            "keywords": [
                "eye",
                "face",
                "horrible",
                "taste",
                "tongue"
            ]
        },
        {
            "no": 40,
            "code": "1F924",
            "flagged": true,
            "keywords": [
                "drooling",
                "face"
            ]
        },
        {
            "no": 41,
            "code": "1F612",
            "flagged": false,
            "keywords": [
                "face",
                "unamused",
                "unhappy"
            ]
        },
        {
            "no": 42,
            "code": "1F613",
            "flagged": false,
            "keywords": [
                "cold",
                "face",
                "sweat"
            ]
        },
        {
            "no": 43,
            "code": "1F614",
            "flagged": false,
            "keywords": [
                "dejected",
                "face",
                "pensive"
            ]
        },
        {
            "no": 44,
            "code": "1F615",
            "flagged": false,
            "keywords": [
                "confused",
                "face"
            ]
        },
        {
            "no": 45,
            "code": "1F643",
            "flagged": false,
            "keywords": [
                "face",
                "upside-down"
            ]
        },
        {
            "no": 46,
            "code": "1F911",
            "flagged": false,
            "keywords": [
                "face",
                "money",
                "mouth"
            ]
        },
        {
            "no": 47,
            "code": "1F632",
            "flagged": false,
            "keywords": [
                "astonished",
                "face",
                "shocked",
                "totally"
            ]
        },
        {
            "no": 48,
            "code": "2639",
            "flagged": false,
            "keywords": [
                "face",
                "frown"
            ]
        },
        {
            "no": 49,
            "code": "1F641",
            "flagged": false,
            "keywords": [
                "face",
                "frown"
            ]
        },
        {
            "no": 50,
            "code": "1F616",
            "flagged": false,
            "keywords": [
                "confounded",
                "face"
            ]
        },
        {
            "no": 51,
            "code": "1F61E",
            "flagged": false,
            "keywords": [
                "disappointed",
                "face"
            ]
        },
        {
            "no": 52,
            "code": "1F61F",
            "flagged": false,
            "keywords": [
                "face",
                "worried"
            ]
        },
        {
            "no": 53,
            "code": "1F624",
            "flagged": false,
            "keywords": [
                "face",
                "triumph",
                "won"
            ]
        },
        {
            "no": 54,
            "code": "1F622",
            "flagged": false,
            "keywords": [
                "cry",
                "face",
                "sad",
                "tear"
            ]
        },
        {
            "no": 55,
            "code": "1F62D",
            "flagged": false,
            "keywords": [
                "cry",
                "face",
                "sad",
                "sob",
                "tear"
            ]
        },
        {
            "no": 56,
            "code": "1F626",
            "flagged": false,
            "keywords": [
                "face",
                "frown",
                "mouth",
                "open"
            ]
        },
        {
            "no": 57,
            "code": "1F627",
            "flagged": false,
            "keywords": [
                "anguished",
                "face"
            ]
        },
        {
            "no": 58,
            "code": "1F628",
            "flagged": false,
            "keywords": [
                "face",
                "fear",
                "fearful",
                "scared"
            ]
        },
        {
            "no": 59,
            "code": "1F629",
            "flagged": false,
            "keywords": [
                "face",
                "tired",
                "weary"
            ]
        },
        {
            "no": 60,
            "code": "1F62C",
            "flagged": false,
            "keywords": [
                "face",
                "grimace"
            ]
        },
        {
            "no": 61,
            "code": "1F630",
            "flagged": false,
            "keywords": [
                "blue",
                "cold",
                "face",
                "mouth",
                "open",
                "rushed",
                "sweat"
            ]
        },
        {
            "no": 62,
            "code": "1F631",
            "flagged": false,
            "keywords": [
                "face",
                "fear",
                "fearful",
                "munch",
                "scared",
                "scream"
            ]
        },
        {
            "no": 63,
            "code": "1F633",
            "flagged": false,
            "keywords": [
                "dazed",
                "face",
                "flushed"
            ]
        },
        {
            "no": 64,
            "code": "1F635",
            "flagged": false,
            "keywords": [
                "dizzy",
                "face"
            ]
        },
        {
            "no": 65,
            "code": "1F621",
            "flagged": false,
            "keywords": [
                "angry",
                "face",
                "mad",
                "pouting",
                "rage",
                "red"
            ]
        },
        {
            "no": 66,
            "code": "1F620",
            "flagged": false,
            "keywords": [
                "angry",
                "face",
                "mad"
            ]
        },
        {
            "no": 67,
            "code": "1F607",
            "flagged": false,
            "keywords": [
                "angel",
                "face",
                "fairy tale",
                "fantasy",
                "halo",
                "innocent",
                "smile"
            ]
        },
        {
            "no": 68,
            "code": "1F920",
            "flagged": true,
            "keywords": [
                "cowboy",
                "cowgirl",
                "face",
                "hat"
            ]
        },
        {
            "no": 69,
            "code": "1F921",
            "flagged": true,
            "keywords": [
                "clown",
                "face"
            ]
        },
        {
            "no": 70,
            "code": "1F925",
            "flagged": true,
            "keywords": [
                "face",
                "lie",
                "pinocchio"
            ]
        },
        {
            "no": 71,
            "code": "1F637",
            "flagged": false,
            "keywords": [
                "cold",
                "doctor",
                "face",
                "mask",
                "medicine",
                "sick"
            ]
        },
        {
            "no": 72,
            "code": "1F912",
            "flagged": false,
            "keywords": [
                "face",
                "ill",
                "sick",
                "thermometer"
            ]
        },
        {
            "no": 73,
            "code": "1F915",
            "flagged": false,
            "keywords": [
                "bandage",
                "face",
                "hurt",
                "injury"
            ]
        },
        {
            "no": 74,
            "code": "1F922",
            "flagged": true,
            "keywords": [
                "face",
                "nauseated",
                "vomit"
            ]
        },
        {
            "no": 75,
            "code": "1F927",
            "flagged": true,
            "keywords": [
                "face",
                "gesundheit",
                "sneeze"
            ]
        },
        {
            "no": 76,
            "code": "1F608",
            "flagged": false,
            "keywords": [
                "face",
                "fairy tale",
                "fantasy",
                "horns",
                "smile"
            ]
        },
        {
            "no": 77,
            "code": "1F47F",
            "flagged": false,
            "keywords": [
                "demon",
                "devil",
                "face",
                "fairy tale",
                "fantasy",
                "imp"
            ]
        },
        {
            "no": 78,
            "code": "1F479",
            "flagged": false,
            "keywords": [
                "creature",
                "face",
                "fairy tale",
                "fantasy",
                "japanese",
                "monster",
                "ogre"
            ]
        },
        {
            "no": 79,
            "code": "1F47A",
            "flagged": false,
            "keywords": [
                "creature",
                "face",
                "fairy tale",
                "fantasy",
                "goblin",
                "japanese",
                "monster"
            ]
        },
        {
            "no": 80,
            "code": "1F480",
            "flagged": false,
            "keywords": [
                "body",
                "death",
                "face",
                "fairy tale",
                "monster",
                "skull"
            ]
        },
        {
            "no": 81,
            "code": "2620",
            "flagged": false,
            "keywords": [
                "body",
                "crossbones",
                "death",
                "face",
                "monster",
                "skull"
            ]
        },
        {
            "no": 82,
            "code": "1F47B",
            "flagged": false,
            "keywords": [
                "creature",
                "face",
                "fairy tale",
                "fantasy",
                "ghost",
                "monster"
            ]
        },
        {
            "no": 83,
            "code": "1F47D",
            "flagged": false,
            "keywords": [
                "alien",
                "creature",
                "extraterrestrial",
                "face",
                "fairy tale",
                "fantasy",
                "monster",
                "space",
                "ufo"
            ]
        },
        {
            "no": 84,
            "code": "1F47E",
            "flagged": false,
            "keywords": [
                "alien",
                "creature",
                "extraterrestrial",
                "face",
                "fairy tale",
                "fantasy",
                "monster",
                "space",
                "ufo"
            ]
        },
        {
            "no": 85,
            "code": "1F916",
            "flagged": false,
            "keywords": [
                "face",
                "monster",
                "robot"
            ]
        },
        {
            "no": 86,
            "code": "1F4A9",
            "flagged": false,
            "keywords": [
                "comic",
                "dung",
                "face",
                "monster",
                "poo",
                "poop"
            ]
        },
        {
            "no": 87,
            "code": "1F63A",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "mouth",
                "open",
                "smile"
            ]
        },
        {
            "no": 88,
            "code": "1F638",
            "flagged": false,
            "keywords": [
                "cat",
                "eye",
                "face",
                "grin",
                "smile"
            ]
        },
        {
            "no": 89,
            "code": "1F639",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "joy",
                "tear"
            ]
        },
        {
            "no": 90,
            "code": "1F63B",
            "flagged": false,
            "keywords": [
                "cat",
                "eye",
                "face",
                "heart",
                "love",
                "smile"
            ]
        },
        {
            "no": 91,
            "code": "1F63C",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "ironic",
                "smile",
                "wry"
            ]
        },
        {
            "no": 92,
            "code": "1F63D",
            "flagged": false,
            "keywords": [
                "cat",
                "eye",
                "face",
                "kiss"
            ]
        },
        {
            "no": 93,
            "code": "1F640",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "oh",
                "surprised",
                "weary"
            ]
        },
        {
            "no": 94,
            "code": "1F63F",
            "flagged": false,
            "keywords": [
                "cat",
                "cry",
                "face",
                "sad",
                "tear"
            ]
        },
        {
            "no": 95,
            "code": "1F63E",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "pouting"
            ]
        },
        {
            "no": 96,
            "code": "1F648",
            "flagged": false,
            "keywords": [
                "evil",
                "face",
                "forbidden",
                "gesture",
                "monkey",
                "no",
                "not",
                "prohibited",
                "see"
            ]
        },
        {
            "no": 97,
            "code": "1F649",
            "flagged": false,
            "keywords": [
                "evil",
                "face",
                "forbidden",
                "gesture",
                "hear",
                "monkey",
                "no",
                "not",
                "prohibited"
            ]
        },
        {
            "no": 98,
            "code": "1F64A",
            "flagged": false,
            "keywords": [
                "evil",
                "face",
                "forbidden",
                "gesture",
                "monkey",
                "no",
                "not",
                "prohibited",
                "speak"
            ]
        },
        {
            "no": 99,
            "code": "1F466",
            "flagged": false,
            "keywords": [
                "boy"
            ],
            "types": [
                "1F466-1F3FF",
                "1F466-1F3FE",
                "1F466-1F3FD",
                "1F466-1F3FC",
                "1F466-1F3FB"
            ]
        },
        {
            "no": 105,
            "code": "1F467",
            "flagged": false,
            "keywords": [
                "girl",
                "maiden",
                "virgin",
                "virgo",
                "zodiac"
            ],
            "types": [
                "1F467-1F3FF",
                "1F467-1F3FE",
                "1F467-1F3FD",
                "1F467-1F3FC",
                "1F467-1F3FB"
            ]
        },
        {
            "no": 111,
            "code": "1F468",
            "flagged": false,
            "keywords": [
                "man"
            ],
            "types": [
                "1F468-1F3FF",
                "1F468-1F3FE",
                "1F468-1F3FD",
                "1F468-1F3FC",
                "1F468-1F3FB"
            ]
        },
        {
            "no": 117,
            "code": "1F469",
            "flagged": false,
            "keywords": [
                "woman"
            ],
            "types": [
                "1F469-1F3FF",
                "1F469-1F3FE",
                "1F469-1F3FD",
                "1F469-1F3FC",
                "1F469-1F3FB"
            ]
        },
        {
            "no": 123,
            "code": "1F474",
            "flagged": false,
            "keywords": [
                "man",
                "old"
            ],
            "types": [
                "1F474-1F3FF",
                "1F474-1F3FE",
                "1F474-1F3FD",
                "1F474-1F3FC",
                "1F474-1F3FB"
            ]
        },
        {
            "no": 129,
            "code": "1F475",
            "flagged": false,
            "keywords": [
                "old",
                "woman"
            ],
            "types": [
                "1F475-1F3FF",
                "1F475-1F3FE",
                "1F475-1F3FD",
                "1F475-1F3FC",
                "1F475-1F3FB"
            ]
        },
        {
            "no": 135,
            "code": "1F476",
            "flagged": false,
            "keywords": [
                "baby"
            ],
            "types": [
                "1F476-1F3FF",
                "1F476-1F3FE",
                "1F476-1F3FD",
                "1F476-1F3FC",
                "1F476-1F3FB"
            ]
        },
        {
            "no": 141,
            "code": "1F47C",
            "flagged": false,
            "keywords": [
                "angel",
                "baby",
                "face",
                "fairy tale",
                "fantasy"
            ],
            "types": [
                "1F47C-1F3FF",
                "1F47C-1F3FE",
                "1F47C-1F3FD",
                "1F47C-1F3FC",
                "1F47C-1F3FB"
            ]
        },
        {
            "no": 147,
            "code": "1F471",
            "flagged": false,
            "keywords": [
                "blond"
            ],
            "types": [
                "1F471-1F3FF",
                "1F471-1F3FE",
                "1F471-1F3FD",
                "1F471-1F3FC",
                "1F471-1F3FB"
            ]
        },
        {
            "no": 153,
            "code": "1F46E",
            "flagged": false,
            "keywords": [
                "cop",
                "officer",
                "police"
            ],
            "types": [
                "1F46E-1F3FF",
                "1F46E-1F3FE",
                "1F46E-1F3FD",
                "1F46E-1F3FC",
                "1F46E-1F3FB"
            ]
        },
        {
            "no": 159,
            "code": "1F472",
            "flagged": false,
            "keywords": [
                "gua pi mao",
                "hat",
                "man"
            ],
            "types": [
                "1F472-1F3FF",
                "1F472-1F3FE",
                "1F472-1F3FD",
                "1F472-1F3FC",
                "1F472-1F3FB"
            ]
        },
        {
            "no": 165,
            "code": "1F473",
            "flagged": false,
            "keywords": [
                "man",
                "turban"
            ],
            "types": [
                "1F473-1F3FF",
                "1F473-1F3FE",
                "1F473-1F3FD",
                "1F473-1F3FC",
                "1F473-1F3FB"
            ]
        },
        {
            "no": 171,
            "code": "1F477",
            "flagged": false,
            "keywords": [
                "construction",
                "hat",
                "worker"
            ],
            "types": [
                "1F477-1F3FF",
                "1F477-1F3FE",
                "1F477-1F3FD",
                "1F477-1F3FC",
                "1F477-1F3FB"
            ]
        },
        {
            "no": 177,
            "code": "1F478",
            "flagged": false,
            "keywords": [
                "fairy tale",
                "fantasy",
                "princess"
            ],
            "types": [
                "1F478-1F3FF",
                "1F478-1F3FE",
                "1F478-1F3FD",
                "1F478-1F3FC",
                "1F478-1F3FB"
            ]
        },
        {
            "no": 183,
            "code": "1F934",
            "flagged": true,
            "keywords": [
                "prince"
            ],
            "types": [
                "1F934-1F3FF",
                "1F934-1F3FE",
                "1F934-1F3FD",
                "1F934-1F3FC",
                "1F934-1F3FB"
            ]
        },
        {
            "no": 189,
            "code": "1F482",
            "flagged": false,
            "keywords": [
                "guard",
                "guardsman"
            ],
            "types": [
                "1F482-1F3FF",
                "1F482-1F3FE",
                "1F482-1F3FD",
                "1F482-1F3FC",
                "1F482-1F3FB"
            ]
        },
        {
            "no": 195,
            "code": "1F575",
            "flagged": false,
            "keywords": [
                "detective",
                "sleuth",
                "spy"
            ],
            "types": [
                "1F575-1F3FF",
                "1F575-1F3FE",
                "1F575-1F3FD",
                "1F575-1F3FC",
                "1F575-1F3FB"
            ]
        },
        {
            "no": 201,
            "code": "1F385",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "christmas",
                "fairy tale",
                "fantasy",
                "father",
                "santa"
            ],
            "types": [
                "1F385-1F3FF",
                "1F385-1F3FE",
                "1F385-1F3FD",
                "1F385-1F3FC",
                "1F385-1F3FB"
            ]
        },
        {
            "no": 207,
            "code": "1F936",
            "flagged": true,
            "keywords": [
                "christmas",
                "mother",
                "mrs. claus"
            ],
            "types": [
                "1F936-1F3FF",
                "1F936-1F3FE",
                "1F936-1F3FD",
                "1F936-1F3FC",
                "1F936-1F3FB"
            ]
        },
        {
            "no": 213,
            "code": "1F470",
            "flagged": false,
            "keywords": [
                "bride",
                "veil",
                "wedding"
            ],
            "types": [
                "1F470-1F3FF",
                "1F470-1F3FE",
                "1F470-1F3FD",
                "1F470-1F3FC",
                "1F470-1F3FB"
            ]
        },
        {
            "no": 219,
            "code": "1F935",
            "flagged": true,
            "keywords": [
                "groom",
                "man",
                "tuxedo"
            ],
            "types": [
                "1F935-1F3FF",
                "1F935-1F3FE",
                "1F935-1F3FD",
                "1F935-1F3FC",
                "1F935-1F3FB"
            ]
        },
        {
            "no": 225,
            "code": "1F486",
            "flagged": false,
            "keywords": [
                "massage",
                "salon"
            ],
            "types": [
                "1F486-1F3FF",
                "1F486-1F3FE",
                "1F486-1F3FD",
                "1F486-1F3FC",
                "1F486-1F3FB"
            ]
        },
        {
            "no": 231,
            "code": "1F487",
            "flagged": false,
            "keywords": [
                "barber",
                "beauty",
                "haircut",
                "parlor"
            ],
            "types": [
                "1F487-1F3FF",
                "1F487-1F3FE",
                "1F487-1F3FD",
                "1F487-1F3FC",
                "1F487-1F3FB"
            ]
        },
        {
            "no": 237,
            "code": "1F64D",
            "flagged": false,
            "keywords": [
                "frown",
                "gesture"
            ],
            "types": [
                "1F64D-1F3FF",
                "1F64D-1F3FE",
                "1F64D-1F3FD",
                "1F64D-1F3FC",
                "1F64D-1F3FB"
            ]
        },
        {
            "no": 243,
            "code": "1F64E",
            "flagged": false,
            "keywords": [
                "gesture",
                "pouting"
            ],
            "types": [
                "1F64E-1F3FF",
                "1F64E-1F3FE",
                "1F64E-1F3FD",
                "1F64E-1F3FC",
                "1F64E-1F3FB"
            ]
        },
        {
            "no": 249,
            "code": "1F645",
            "flagged": false,
            "keywords": [
                "forbidden",
                "gesture",
                "hand",
                "no",
                "not",
                "prohibited"
            ],
            "types": [
                "1F645-1F3FF",
                "1F645-1F3FE",
                "1F645-1F3FD",
                "1F645-1F3FC",
                "1F645-1F3FB"
            ]
        },
        {
            "no": 255,
            "code": "1F646",
            "flagged": false,
            "keywords": [
                "gesture",
                "hand",
                "ok"
            ],
            "types": [
                "1F646-1F3FF",
                "1F646-1F3FE",
                "1F646-1F3FD",
                "1F646-1F3FC",
                "1F646-1F3FB"
            ]
        },
        {
            "no": 261,
            "code": "1F481",
            "flagged": false,
            "keywords": [
                "hand",
                "help",
                "information",
                "sassy"
            ],
            "types": [
                "1F481-1F3FF",
                "1F481-1F3FE",
                "1F481-1F3FD",
                "1F481-1F3FC",
                "1F481-1F3FB"
            ]
        },
        {
            "no": 267,
            "code": "1F937",
            "flagged": true,
            "keywords": [
                "doubt",
                "ignorance",
                "indifference",
                "shrug"
            ],
            "types": [
                "1F937-1F3FF",
                "1F937-1F3FE",
                "1F937-1F3FD",
                "1F937-1F3FC",
                "1F937-1F3FB"
            ]
        },
        {
            "no": 273,
            "code": "1F64B",
            "flagged": false,
            "keywords": [
                "gesture",
                "hand",
                "happy",
                "raised"
            ],
            "types": [
                "1F64B-1F3FF",
                "1F64B-1F3FE",
                "1F64B-1F3FD",
                "1F64B-1F3FC",
                "1F64B-1F3FB"
            ]
        },
        {
            "no": 279,
            "code": "1F926",
            "flagged": true,
            "keywords": [
                "disbelief",
                "exasperation",
                "face",
                "palm"
            ],
            "types": [
                "1F926-1F3FF",
                "1F926-1F3FE",
                "1F926-1F3FD",
                "1F926-1F3FC",
                "1F926-1F3FB"
            ]
        },
        {
            "no": 285,
            "code": "1F647",
            "flagged": false,
            "keywords": [
                "apology",
                "bow",
                "gesture",
                "sorry"
            ],
            "types": [
                "1F647-1F3FF",
                "1F647-1F3FE",
                "1F647-1F3FD",
                "1F647-1F3FC",
                "1F647-1F3FB"
            ]
        },
        {
            "no": 291,
            "code": "1F6B6",
            "flagged": false,
            "keywords": [
                "hike",
                "pedestrian",
                "walk",
                "walking"
            ],
            "types": [
                "1F6B6-1F3FF",
                "1F6B6-1F3FE",
                "1F6B6-1F3FD",
                "1F6B6-1F3FC",
                "1F6B6-1F3FB"
            ]
        },
        {
            "no": 297,
            "code": "1F3C3",
            "flagged": false,
            "keywords": [
                "marathon",
                "runner",
                "running"
            ],
            "types": [
                "1F3C3-1F3FF",
                "1F3C3-1F3FE",
                "1F3C3-1F3FD",
                "1F3C3-1F3FC",
                "1F3C3-1F3FB"
            ]
        },
        {
            "no": 303,
            "code": "1F483",
            "flagged": false,
            "keywords": [
                "dancer"
            ],
            "types": [
                "1F483-1F3FF",
                "1F483-1F3FE",
                "1F483-1F3FD",
                "1F483-1F3FC",
                "1F483-1F3FB"
            ]
        },
        {
            "no": 309,
            "code": "1F57A",
            "flagged": true,
            "keywords": [
                "dance",
                "man"
            ],
            "types": [
                "1F57A-1F3FF",
                "1F57A-1F3FE",
                "1F57A-1F3FD",
                "1F57A-1F3FC",
                "1F57A-1F3FB"
            ]
        },
        {
            "no": 315,
            "code": "1F930",
            "flagged": true,
            "keywords": [
                "pregnant",
                "woman"
            ],
            "types": [
                "1F930-1F3FF",
                "1F930-1F3FE",
                "1F930-1F3FD",
                "1F930-1F3FC",
                "1F930-1F3FB"
            ]
        },
        {
            "no": 321,
            "code": "1F46F",
            "flagged": false,
            "keywords": [
                "bunny",
                "dancer",
                "ear",
                "girl",
                "woman"
            ]
        },
        {
            "no": 322,
            "code": "1F574",
            "flagged": false,
            "keywords": [
                "business",
                "man",
                "suit"
            ]
        },
        {
            "no": 323,
            "code": "1F5E3",
            "flagged": false,
            "keywords": [
                "face",
                "head",
                "silhouette",
                "speak",
                "speaking"
            ]
        },
        {
            "no": 324,
            "code": "1F464",
            "flagged": false,
            "keywords": [
                "bust",
                "silhouette"
            ]
        },
        {
            "no": 325,
            "code": "1F465",
            "flagged": false,
            "keywords": [
                "bust",
                "silhouette"
            ]
        },
        {
            "no": 326,
            "code": "1F46B",
            "flagged": false,
            "keywords": [
                "couple",
                "hand",
                "hold",
                "man",
                "woman"
            ]
        },
        {
            "no": 327,
            "code": "1F46C",
            "flagged": false,
            "keywords": [
                "couple",
                "gemini",
                "hand",
                "hold",
                "man",
                "twins",
                "zodiac"
            ]
        },
        {
            "no": 328,
            "code": "1F46D",
            "flagged": false,
            "keywords": [
                "couple",
                "hand",
                "hold",
                "woman"
            ]
        },
        {
            "no": 329,
            "code": "1F48F",
            "flagged": false,
            "keywords": [
                "couple",
                "kiss",
                "romance"
            ]
        },
        {
            "no": 330,
            "code": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
            "flagged": false,
            "keywords": [
                "kiss",
                "man",
                "woman"
            ]
        },
        {
            "no": 331,
            "code": "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
            "flagged": false,
            "keywords": [
                "kiss",
                "man"
            ]
        },
        {
            "no": 332,
            "code": "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
            "flagged": false,
            "keywords": [
                "kiss",
                "woman"
            ]
        },
        {
            "no": 333,
            "code": "1F491",
            "flagged": false,
            "keywords": [
                "couple",
                "heart",
                "love",
                "romance"
            ]
        },
        {
            "no": 334,
            "code": "1F469-200D-2764-FE0F-200D-1F468",
            "flagged": false,
            "keywords": [
                "couple",
                "man",
                "woman"
            ]
        },
        {
            "no": 335,
            "code": "1F468-200D-2764-FE0F-200D-1F468",
            "flagged": false,
            "keywords": [
                "couple",
                "man"
            ]
        },
        {
            "no": 336,
            "code": "1F469-200D-2764-FE0F-200D-1F469",
            "flagged": false,
            "keywords": [
                "couple",
                "woman"
            ]
        },
        {
            "no": 337,
            "code": "1F46A",
            "flagged": false,
            "keywords": [
                "child",
                "family",
                "father",
                "mother"
            ]
        },
        {
            "no": 338,
            "code": "1F468-200D-1F469-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "man",
                "woman"
            ]
        },
        {
            "no": 339,
            "code": "1F468-200D-1F469-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "man",
                "woman"
            ]
        },
        {
            "no": 340,
            "code": "1F468-200D-1F469-200D-1F467-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "girl",
                "man",
                "woman"
            ]
        },
        {
            "no": 341,
            "code": "1F468-200D-1F469-200D-1F466-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "man",
                "woman"
            ]
        },
        {
            "no": 342,
            "code": "1F468-200D-1F469-200D-1F467-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "man",
                "woman"
            ]
        },
        {
            "no": 343,
            "code": "1F468-200D-1F468-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "man"
            ]
        },
        {
            "no": 344,
            "code": "1F468-200D-1F468-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "man"
            ]
        },
        {
            "no": 345,
            "code": "1F468-200D-1F468-200D-1F467-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "girl",
                "man"
            ]
        },
        {
            "no": 346,
            "code": "1F468-200D-1F468-200D-1F466-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "man"
            ]
        },
        {
            "no": 347,
            "code": "1F468-200D-1F468-200D-1F467-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "man"
            ]
        },
        {
            "no": 348,
            "code": "1F469-200D-1F469-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "woman"
            ]
        },
        {
            "no": 349,
            "code": "1F469-200D-1F469-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "woman"
            ]
        },
        {
            "no": 350,
            "code": "1F469-200D-1F469-200D-1F467-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "girl",
                "woman"
            ]
        },
        {
            "no": 351,
            "code": "1F469-200D-1F469-200D-1F466-200D-1F466",
            "flagged": false,
            "keywords": [
                "boy",
                "family",
                "woman"
            ]
        },
        {
            "no": 352,
            "code": "1F469-200D-1F469-200D-1F467-200D-1F467",
            "flagged": false,
            "keywords": [
                "family",
                "girl",
                "woman"
            ]
        },
        {
            "no": 353,
            "code": "1F3FB",
            "flagged": true,
            "keywords": [
                "emoji modifier",
                "fitzpatrick",
                "skin",
                "tone"
            ]
        },
        {
            "no": 354,
            "code": "1F3FC",
            "flagged": true,
            "keywords": [
                "emoji modifier",
                "fitzpatrick",
                "skin",
                "tone"
            ]
        },
        {
            "no": 355,
            "code": "1F3FD",
            "flagged": true,
            "keywords": [
                "emoji modifier",
                "fitzpatrick",
                "skin",
                "tone"
            ]
        },
        {
            "no": 356,
            "code": "1F3FE",
            "flagged": true,
            "keywords": [
                "emoji modifier",
                "fitzpatrick",
                "skin",
                "tone"
            ]
        },
        {
            "no": 357,
            "code": "1F3FF",
            "flagged": true,
            "keywords": [
                "emoji modifier",
                "fitzpatrick",
                "skin",
                "tone"
            ]
        },
        {
            "no": 358,
            "code": "1F4AA",
            "flagged": false,
            "keywords": [
                "biceps",
                "body",
                "comic",
                "flex",
                "muscle"
            ],
            "types": [
                "1F4AA-1F3FF",
                "1F4AA-1F3FE",
                "1F4AA-1F3FD",
                "1F4AA-1F3FC",
                "1F4AA-1F3FB"
            ]
        },
        {
            "no": 364,
            "code": "1F933",
            "flagged": true,
            "keywords": [
                "camera",
                "phone",
                "selfie"
            ],
            "types": [
                "1F933-1F3FF",
                "1F933-1F3FE",
                "1F933-1F3FD",
                "1F933-1F3FC",
                "1F933-1F3FB"
            ]
        },
        {
            "no": 370,
            "code": "1F448",
            "flagged": false,
            "keywords": [
                "backhand",
                "body",
                "finger",
                "hand",
                "index",
                "point"
            ],
            "types": [
                "1F448-1F3FF",
                "1F448-1F3FE",
                "1F448-1F3FD",
                "1F448-1F3FC",
                "1F448-1F3FB"
            ]
        },
        {
            "no": 376,
            "code": "1F449",
            "flagged": false,
            "keywords": [
                "backhand",
                "body",
                "finger",
                "hand",
                "index",
                "point"
            ],
            "types": [
                "1F449-1F3FF",
                "1F449-1F3FE",
                "1F449-1F3FD",
                "1F449-1F3FC",
                "1F449-1F3FB"
            ]
        },
        {
            "no": 382,
            "code": "261D",
            "flagged": false,
            "keywords": [
                "body",
                "finger",
                "hand",
                "index",
                "point",
                "up"
            ],
            "types": [
                "261D-1F3FF",
                "261D-1F3FE",
                "261D-1F3FD",
                "261D-1F3FC",
                "261D-1F3FB"
            ]
        },
        {
            "no": 388,
            "code": "1F446",
            "flagged": false,
            "keywords": [
                "backhand",
                "body",
                "finger",
                "hand",
                "index",
                "point",
                "up"
            ],
            "types": [
                "1F446-1F3FF",
                "1F446-1F3FE",
                "1F446-1F3FD",
                "1F446-1F3FC",
                "1F446-1F3FB"
            ]
        },
        {
            "no": 394,
            "code": "1F595",
            "flagged": false,
            "keywords": [
                "body",
                "finger",
                "hand",
                "middle finger"
            ],
            "types": [
                "1F595-1F3FF",
                "1F595-1F3FE",
                "1F595-1F3FD",
                "1F595-1F3FC",
                "1F595-1F3FB"
            ]
        },
        {
            "no": 400,
            "code": "1F447",
            "flagged": false,
            "keywords": [
                "backhand",
                "body",
                "down",
                "finger",
                "hand",
                "index",
                "point"
            ],
            "types": [
                "1F447-1F3FF",
                "1F447-1F3FE",
                "1F447-1F3FD",
                "1F447-1F3FC",
                "1F447-1F3FB"
            ]
        },
        {
            "no": 406,
            "code": "270C",
            "flagged": false,
            "keywords": [
                "body",
                "hand",
                "v",
                "victory"
            ],
            "types": [
                "270C-1F3FF",
                "270C-1F3FE",
                "270C-1F3FD",
                "270C-1F3FC",
                "270C-1F3FB"
            ]
        },
        {
            "no": 412,
            "code": "1F91E",
            "flagged": true,
            "keywords": [
                "cross",
                "finger",
                "hand",
                "luck"
            ],
            "types": [
                "1F91E-1F3FF",
                "1F91E-1F3FE",
                "1F91E-1F3FD",
                "1F91E-1F3FC",
                "1F91E-1F3FB"
            ]
        },
        {
            "no": 418,
            "code": "1F596",
            "flagged": false,
            "keywords": [
                "body",
                "finger",
                "hand",
                "spock",
                "vulcan"
            ],
            "types": [
                "1F596-1F3FF",
                "1F596-1F3FE",
                "1F596-1F3FD",
                "1F596-1F3FC",
                "1F596-1F3FB"
            ]
        },
        {
            "no": 424,
            "code": "1F918",
            "flagged": false,
            "keywords": [
                "body",
                "finger",
                "hand",
                "horns",
                "rock-on"
            ],
            "types": [
                "1F918-1F3FF",
                "1F918-1F3FE",
                "1F918-1F3FD",
                "1F918-1F3FC",
                "1F918-1F3FB"
            ]
        },
        {
            "no": 430,
            "code": "1F919",
            "flagged": true,
            "keywords": [
                "call",
                "hand"
            ],
            "types": [
                "1F919-1F3FF",
                "1F919-1F3FE",
                "1F919-1F3FD",
                "1F919-1F3FC",
                "1F919-1F3FB"
            ]
        },
        {
            "no": 436,
            "code": "1F590",
            "flagged": false,
            "keywords": [
                "body",
                "finger",
                "hand",
                "splayed"
            ],
            "types": [
                "1F590-1F3FF",
                "1F590-1F3FE",
                "1F590-1F3FD",
                "1F590-1F3FC",
                "1F590-1F3FB"
            ]
        },
        {
            "no": 442,
            "code": "270B",
            "flagged": false,
            "keywords": [
                "body",
                "hand"
            ],
            "types": [
                "270B-1F3FF",
                "270B-1F3FE",
                "270B-1F3FD",
                "270B-1F3FC",
                "270B-1F3FB"
            ]
        },
        {
            "no": 448,
            "code": "1F44C",
            "flagged": false,
            "keywords": [
                "body",
                "hand",
                "ok"
            ],
            "types": [
                "1F44C-1F3FF",
                "1F44C-1F3FE",
                "1F44C-1F3FD",
                "1F44C-1F3FC",
                "1F44C-1F3FB"
            ]
        },
        {
            "no": 454,
            "code": "1F44D",
            "flagged": false,
            "keywords": [
                "+1",
                "body",
                "hand",
                "thumb",
                "thumbs up",
                "up"
            ],
            "types": [
                "1F44D-1F3FF",
                "1F44D-1F3FE",
                "1F44D-1F3FD",
                "1F44D-1F3FC",
                "1F44D-1F3FB"
            ]
        },
        {
            "no": 460,
            "code": "1F44E",
            "flagged": false,
            "keywords": [
                "-1",
                "body",
                "down",
                "hand",
                "thumb",
                "thumbs down"
            ],
            "types": [
                "1F44E-1F3FF",
                "1F44E-1F3FE",
                "1F44E-1F3FD",
                "1F44E-1F3FC",
                "1F44E-1F3FB"
            ]
        },
        {
            "no": 466,
            "code": "270A",
            "flagged": false,
            "keywords": [
                "body",
                "clenched",
                "fist",
                "hand",
                "punch"
            ],
            "types": [
                "270A-1F3FF",
                "270A-1F3FE",
                "270A-1F3FD",
                "270A-1F3FC",
                "270A-1F3FB"
            ]
        },
        {
            "no": 472,
            "code": "1F44A",
            "flagged": false,
            "keywords": [
                "body",
                "clenched",
                "fist",
                "hand",
                "punch"
            ],
            "types": [
                "1F44A-1F3FF",
                "1F44A-1F3FE",
                "1F44A-1F3FD",
                "1F44A-1F3FC",
                "1F44A-1F3FB"
            ]
        },
        {
            "no": 478,
            "code": "1F91B",
            "flagged": true,
            "keywords": [
                "fist",
                "leftwards"
            ],
            "types": [
                "1F91B-1F3FF",
                "1F91B-1F3FE",
                "1F91B-1F3FD",
                "1F91B-1F3FC",
                "1F91B-1F3FB"
            ]
        },
        {
            "no": 484,
            "code": "1F91C",
            "flagged": true,
            "keywords": [
                "fist",
                "rightwards"
            ],
            "types": [
                "1F91C-1F3FF",
                "1F91C-1F3FE",
                "1F91C-1F3FD",
                "1F91C-1F3FC",
                "1F91C-1F3FB"
            ]
        },
        {
            "no": 490,
            "code": "1F91A",
            "flagged": true,
            "keywords": [
                "backhand",
                "raised"
            ],
            "types": [
                "1F91A-1F3FF",
                "1F91A-1F3FE",
                "1F91A-1F3FD",
                "1F91A-1F3FC",
                "1F91A-1F3FB"
            ]
        },
        {
            "no": 496,
            "code": "1F44B",
            "flagged": false,
            "keywords": [
                "body",
                "hand",
                "wave",
                "waving"
            ],
            "types": [
                "1F44B-1F3FF",
                "1F44B-1F3FE",
                "1F44B-1F3FD",
                "1F44B-1F3FC",
                "1F44B-1F3FB"
            ]
        },
        {
            "no": 502,
            "code": "1F44F",
            "flagged": false,
            "keywords": [
                "body",
                "clap",
                "hand"
            ],
            "types": [
                "1F44F-1F3FF",
                "1F44F-1F3FE",
                "1F44F-1F3FD",
                "1F44F-1F3FC",
                "1F44F-1F3FB"
            ]
        },
        {
            "no": 508,
            "code": "270D",
            "flagged": false,
            "keywords": [
                "body",
                "hand",
                "write"
            ],
            "types": [
                "270D-1F3FF",
                "270D-1F3FE",
                "270D-1F3FD",
                "270D-1F3FC",
                "270D-1F3FB"
            ]
        },
        {
            "no": 514,
            "code": "1F450",
            "flagged": false,
            "keywords": [
                "body",
                "hand",
                "open"
            ],
            "types": [
                "1F450-1F3FF",
                "1F450-1F3FE",
                "1F450-1F3FD",
                "1F450-1F3FC",
                "1F450-1F3FB"
            ]
        },
        {
            "no": 520,
            "code": "1F64C",
            "flagged": false,
            "keywords": [
                "body",
                "celebration",
                "gesture",
                "hand",
                "hooray",
                "raised"
            ],
            "types": [
                "1F64C-1F3FF",
                "1F64C-1F3FE",
                "1F64C-1F3FD",
                "1F64C-1F3FC",
                "1F64C-1F3FB"
            ]
        },
        {
            "no": 526,
            "code": "1F64F",
            "flagged": false,
            "keywords": [
                "ask",
                "body",
                "bow",
                "folded",
                "gesture",
                "hand",
                "please",
                "pray",
                "thanks"
            ],
            "types": [
                "1F64F-1F3FF",
                "1F64F-1F3FE",
                "1F64F-1F3FD",
                "1F64F-1F3FC",
                "1F64F-1F3FB"
            ]
        },
        {
            "no": 532,
            "code": "1F91D",
            "flagged": true,
            "keywords": [
                "agreement",
                "hand",
                "handshake",
                "meeting",
                "shake"
            ],
            "types": [
                "1F91D-1F3FF",
                "1F91D-1F3FE",
                "1F91D-1F3FD",
                "1F91D-1F3FC",
                "1F91D-1F3FB"
            ]
        },
        {
            "no": 538,
            "code": "1F485",
            "flagged": false,
            "keywords": [
                "body",
                "care",
                "cosmetics",
                "manicure",
                "nail",
                "polish"
            ],
            "types": [
                "1F485-1F3FF",
                "1F485-1F3FE",
                "1F485-1F3FD",
                "1F485-1F3FC",
                "1F485-1F3FB"
            ]
        },
        {
            "no": 544,
            "code": "1F442",
            "flagged": false,
            "keywords": [
                "body",
                "ear"
            ],
            "types": [
                "1F442-1F3FF",
                "1F442-1F3FE",
                "1F442-1F3FD",
                "1F442-1F3FC",
                "1F442-1F3FB"
            ]
        },
        {
            "no": 550,
            "code": "1F443",
            "flagged": false,
            "keywords": [
                "body",
                "nose"
            ],
            "types": [
                "1F443-1F3FF",
                "1F443-1F3FE",
                "1F443-1F3FD",
                "1F443-1F3FC",
                "1F443-1F3FB"
            ]
        },
        {
            "no": 556,
            "code": "1F463",
            "flagged": false,
            "keywords": [
                "body",
                "clothing",
                "footprint",
                "print"
            ]
        },
        {
            "no": 557,
            "code": "1F440",
            "flagged": false,
            "keywords": [
                "body",
                "eye",
                "face"
            ]
        },
        {
            "no": 558,
            "code": "1F441",
            "flagged": false,
            "keywords": [
                "body",
                "eye"
            ]
        },
        {
            "no": 559,
            "code": "1F441-200D-1F5E8",
            "flagged": false,
            "keywords": [
                "bubble",
                "eye",
                "speech",
                "witness"
            ]
        },
        {
            "no": 560,
            "code": "1F445",
            "flagged": false,
            "keywords": [
                "body",
                "tongue"
            ]
        },
        {
            "no": 561,
            "code": "1F444",
            "flagged": false,
            "keywords": [
                "body",
                "lips",
                "mouth"
            ]
        },
        {
            "no": 562,
            "code": "1F48B",
            "flagged": false,
            "keywords": [
                "heart",
                "kiss",
                "lips",
                "mark",
                "romance"
            ]
        },
        {
            "no": 563,
            "code": "1F498",
            "flagged": false,
            "keywords": [
                "arrow",
                "cupid",
                "heart",
                "romance"
            ]
        },
        {
            "no": 564,
            "code": "2764",
            "flagged": false,
            "keywords": [
                "heart"
            ]
        },
        {
            "no": 565,
            "code": "1F493",
            "flagged": false,
            "keywords": [
                "beating",
                "heart",
                "heartbeat",
                "pulsating"
            ]
        },
        {
            "no": 566,
            "code": "1F494",
            "flagged": false,
            "keywords": [
                "break",
                "broken",
                "heart"
            ]
        },
        {
            "no": 567,
            "code": "1F495",
            "flagged": false,
            "keywords": [
                "heart",
                "love"
            ]
        },
        {
            "no": 568,
            "code": "1F496",
            "flagged": false,
            "keywords": [
                "excited",
                "heart",
                "sparkle"
            ]
        },
        {
            "no": 569,
            "code": "1F497",
            "flagged": false,
            "keywords": [
                "excited",
                "growing",
                "heart",
                "heartpulse",
                "nervous"
            ]
        },
        {
            "no": 570,
            "code": "1F499",
            "flagged": false,
            "keywords": [
                "blue",
                "heart"
            ]
        },
        {
            "no": 571,
            "code": "1F49A",
            "flagged": false,
            "keywords": [
                "green",
                "heart"
            ]
        },
        {
            "no": 572,
            "code": "1F49B",
            "flagged": false,
            "keywords": [
                "heart",
                "yellow"
            ]
        },
        {
            "no": 573,
            "code": "1F49C",
            "flagged": false,
            "keywords": [
                "heart",
                "purple"
            ]
        },
        {
            "no": 574,
            "code": "1F5A4",
            "flagged": true,
            "keywords": [
                "black",
                "evil",
                "heart",
                "wicked"
            ]
        },
        {
            "no": 575,
            "code": "1F49D",
            "flagged": false,
            "keywords": [
                "heart",
                "ribbon",
                "valentine"
            ]
        },
        {
            "no": 576,
            "code": "1F49E",
            "flagged": false,
            "keywords": [
                "heart",
                "revolving"
            ]
        },
        {
            "no": 577,
            "code": "1F49F",
            "flagged": false,
            "keywords": [
                "heart"
            ]
        },
        {
            "no": 578,
            "code": "2763",
            "flagged": false,
            "keywords": [
                "exclamation",
                "heart",
                "mark",
                "punctuation"
            ]
        },
        {
            "no": 579,
            "code": "1F48C",
            "flagged": false,
            "keywords": [
                "heart",
                "letter",
                "love",
                "mail",
                "romance"
            ]
        },
        {
            "no": 580,
            "code": "1F4A4",
            "flagged": false,
            "keywords": [
                "comic",
                "sleep",
                "zzz"
            ]
        },
        {
            "no": 581,
            "code": "1F4A2",
            "flagged": false,
            "keywords": [
                "angry",
                "comic",
                "mad"
            ]
        },
        {
            "no": 582,
            "code": "1F4A3",
            "flagged": false,
            "keywords": [
                "bomb",
                "comic"
            ]
        },
        {
            "no": 583,
            "code": "1F4A5",
            "flagged": false,
            "keywords": [
                "boom",
                "collision",
                "comic"
            ]
        },
        {
            "no": 584,
            "code": "1F4A6",
            "flagged": false,
            "keywords": [
                "comic",
                "splashing",
                "sweat"
            ]
        },
        {
            "no": 585,
            "code": "1F4A8",
            "flagged": false,
            "keywords": [
                "comic",
                "dash",
                "running"
            ]
        },
        {
            "no": 586,
            "code": "1F4AB",
            "flagged": false,
            "keywords": [
                "comic",
                "dizzy",
                "star"
            ]
        },
        {
            "no": 587,
            "code": "1F4AC",
            "flagged": false,
            "keywords": [
                "balloon",
                "bubble",
                "comic",
                "dialog",
                "speech"
            ]
        },
        {
            "no": 588,
            "code": "1F5E8",
            "flagged": false,
            "keywords": [
                "dialog",
                "speech"
            ]
        },
        {
            "no": 589,
            "code": "1F5EF",
            "flagged": false,
            "keywords": [
                "angry",
                "balloon",
                "bubble",
                "mad"
            ]
        },
        {
            "no": 590,
            "code": "1F4AD",
            "flagged": false,
            "keywords": [
                "balloon",
                "bubble",
                "comic",
                "thought"
            ]
        },
        {
            "no": 591,
            "code": "1F573",
            "flagged": false,
            "keywords": [
                "hole"
            ]
        },
        {
            "no": 592,
            "code": "1F453",
            "flagged": false,
            "keywords": [
                "clothing",
                "eye",
                "eyeglasses",
                "eyewear",
                "glasses"
            ]
        },
        {
            "no": 593,
            "code": "1F576",
            "flagged": false,
            "keywords": [
                "dark",
                "eye",
                "eyewear",
                "glasses",
                "sunglasses"
            ]
        },
        {
            "no": 594,
            "code": "1F454",
            "flagged": false,
            "keywords": [
                "clothing",
                "necktie"
            ]
        },
        {
            "no": 595,
            "code": "1F455",
            "flagged": false,
            "keywords": [
                "clothing",
                "shirt",
                "tshirt"
            ]
        },
        {
            "no": 596,
            "code": "1F456",
            "flagged": false,
            "keywords": [
                "clothing",
                "jeans",
                "pants",
                "trousers"
            ]
        },
        {
            "no": 597,
            "code": "1F457",
            "flagged": false,
            "keywords": [
                "clothing",
                "dress"
            ]
        },
        {
            "no": 598,
            "code": "1F458",
            "flagged": false,
            "keywords": [
                "clothing",
                "kimono"
            ]
        },
        {
            "no": 599,
            "code": "1F459",
            "flagged": false,
            "keywords": [
                "bikini",
                "clothing",
                "swim"
            ]
        },
        {
            "no": 600,
            "code": "1F45A",
            "flagged": false,
            "keywords": [
                "clothing",
                "woman"
            ]
        },
        {
            "no": 601,
            "code": "1F45B",
            "flagged": false,
            "keywords": [
                "clothing",
                "coin",
                "purse"
            ]
        },
        {
            "no": 602,
            "code": "1F45C",
            "flagged": false,
            "keywords": [
                "bag",
                "clothing",
                "handbag"
            ]
        },
        {
            "no": 603,
            "code": "1F45D",
            "flagged": false,
            "keywords": [
                "bag",
                "clothing",
                "pouch"
            ]
        },
        {
            "no": 604,
            "code": "1F6CD",
            "flagged": false,
            "keywords": [
                "bag",
                "hotel",
                "shopping"
            ]
        },
        {
            "no": 605,
            "code": "1F392",
            "flagged": false,
            "keywords": [
                "activity",
                "bag",
                "satchel",
                "school"
            ]
        },
        {
            "no": 606,
            "code": "1F45E",
            "flagged": false,
            "keywords": [
                "clothing",
                "man",
                "shoe"
            ]
        },
        {
            "no": 607,
            "code": "1F45F",
            "flagged": false,
            "keywords": [
                "athletic",
                "clothing",
                "shoe",
                "sneaker"
            ]
        },
        {
            "no": 608,
            "code": "1F460",
            "flagged": false,
            "keywords": [
                "clothing",
                "heel",
                "shoe",
                "woman"
            ]
        },
        {
            "no": 609,
            "code": "1F461",
            "flagged": false,
            "keywords": [
                "clothing",
                "sandal",
                "shoe",
                "woman"
            ]
        },
        {
            "no": 610,
            "code": "1F462",
            "flagged": false,
            "keywords": [
                "boot",
                "clothing",
                "shoe",
                "woman"
            ]
        },
        {
            "no": 611,
            "code": "1F451",
            "flagged": false,
            "keywords": [
                "clothing",
                "crown",
                "king",
                "queen"
            ]
        },
        {
            "no": 612,
            "code": "1F452",
            "flagged": false,
            "keywords": [
                "clothing",
                "hat",
                "woman"
            ]
        },
        {
            "no": 613,
            "code": "1F3A9",
            "flagged": false,
            "keywords": [
                "activity",
                "clothing",
                "entertainment",
                "hat",
                "top",
                "tophat"
            ]
        },
        {
            "no": 614,
            "code": "1F393",
            "flagged": false,
            "keywords": [
                "activity",
                "cap",
                "celebration",
                "clothing",
                "graduation",
                "hat"
            ]
        },
        {
            "no": 615,
            "code": "26D1",
            "flagged": false,
            "keywords": [
                "aid",
                "cross",
                "face",
                "hat",
                "helmet"
            ]
        },
        {
            "no": 616,
            "code": "1F4FF",
            "flagged": false,
            "keywords": [
                "beads",
                "clothing",
                "necklace",
                "prayer",
                "religion"
            ]
        },
        {
            "no": 617,
            "code": "1F484",
            "flagged": false,
            "keywords": [
                "cosmetics",
                "lipstick",
                "makeup"
            ]
        },
        {
            "no": 618,
            "code": "1F48D",
            "flagged": false,
            "keywords": [
                "diamond",
                "ring",
                "romance"
            ]
        },
        {
            "no": 619,
            "code": "1F48E",
            "flagged": false,
            "keywords": [
                "diamond",
                "gem",
                "jewel",
                "romance"
            ]
        }
    ],
    ANIMALS: [
        {
            "no": 620,
            "code": "1F435",
            "flagged": false,
            "keywords": [
                "face",
                "monkey"
            ]
        },
        {
            "no": 621,
            "code": "1F412",
            "flagged": false,
            "keywords": [
                "monkey"
            ]
        },
        {
            "no": 622,
            "code": "1F98D",
            "flagged": true,
            "keywords": [
                "gorilla"
            ]
        },
        {
            "no": 623,
            "code": "1F436",
            "flagged": false,
            "keywords": [
                "dog",
                "face",
                "pet"
            ]
        },
        {
            "no": 624,
            "code": "1F415",
            "flagged": false,
            "keywords": [
                "dog",
                "pet"
            ]
        },
        {
            "no": 625,
            "code": "1F429",
            "flagged": false,
            "keywords": [
                "dog",
                "poodle"
            ]
        },
        {
            "no": 626,
            "code": "1F43A",
            "flagged": false,
            "keywords": [
                "face",
                "wolf"
            ]
        },
        {
            "no": 627,
            "code": "1F98A",
            "flagged": true,
            "keywords": [
                "face",
                "fox"
            ]
        },
        {
            "no": 628,
            "code": "1F431",
            "flagged": false,
            "keywords": [
                "cat",
                "face",
                "pet"
            ]
        },
        {
            "no": 629,
            "code": "1F408",
            "flagged": false,
            "keywords": [
                "cat",
                "pet"
            ]
        },
        {
            "no": 630,
            "code": "1F981",
            "flagged": false,
            "keywords": [
                "face",
                "leo",
                "lion",
                "zodiac"
            ]
        },
        {
            "no": 631,
            "code": "1F42F",
            "flagged": false,
            "keywords": [
                "face",
                "tiger"
            ]
        },
        {
            "no": 632,
            "code": "1F405",
            "flagged": false,
            "keywords": [
                "tiger"
            ]
        },
        {
            "no": 633,
            "code": "1F406",
            "flagged": false,
            "keywords": [
                "leopard"
            ]
        },
        {
            "no": 634,
            "code": "1F434",
            "flagged": false,
            "keywords": [
                "face",
                "horse"
            ]
        },
        {
            "no": 635,
            "code": "1F40E",
            "flagged": false,
            "keywords": [
                "horse",
                "racehorse",
                "racing"
            ]
        },
        {
            "no": 636,
            "code": "1F98C",
            "flagged": true,
            "keywords": [
                "deer"
            ]
        },
        {
            "no": 637,
            "code": "1F984",
            "flagged": false,
            "keywords": [
                "face",
                "unicorn"
            ]
        },
        {
            "no": 638,
            "code": "1F42E",
            "flagged": false,
            "keywords": [
                "cow",
                "face"
            ]
        },
        {
            "no": 639,
            "code": "1F402",
            "flagged": false,
            "keywords": [
                "bull",
                "ox",
                "taurus",
                "zodiac"
            ]
        },
        {
            "no": 640,
            "code": "1F403",
            "flagged": false,
            "keywords": [
                "buffalo",
                "water"
            ]
        },
        {
            "no": 641,
            "code": "1F404",
            "flagged": false,
            "keywords": [
                "cow"
            ]
        },
        {
            "no": 642,
            "code": "1F437",
            "flagged": false,
            "keywords": [
                "face",
                "pig"
            ]
        },
        {
            "no": 643,
            "code": "1F416",
            "flagged": false,
            "keywords": [
                "pig",
                "sow"
            ]
        },
        {
            "no": 644,
            "code": "1F417",
            "flagged": false,
            "keywords": [
                "boar",
                "pig"
            ]
        },
        {
            "no": 645,
            "code": "1F43D",
            "flagged": false,
            "keywords": [
                "face",
                "nose",
                "pig"
            ]
        },
        {
            "no": 646,
            "code": "1F40F",
            "flagged": false,
            "keywords": [
                "aries",
                "ram",
                "sheep",
                "zodiac"
            ]
        },
        {
            "no": 647,
            "code": "1F411",
            "flagged": false,
            "keywords": [
                "ewe",
                "sheep"
            ]
        },
        {
            "no": 648,
            "code": "1F410",
            "flagged": false,
            "keywords": [
                "capricorn",
                "goat",
                "zodiac"
            ]
        },
        {
            "no": 649,
            "code": "1F42A",
            "flagged": false,
            "keywords": [
                "camel",
                "dromedary",
                "hump"
            ]
        },
        {
            "no": 650,
            "code": "1F42B",
            "flagged": false,
            "keywords": [
                "bactrian",
                "camel",
                "hump"
            ]
        },
        {
            "no": 651,
            "code": "1F418",
            "flagged": false,
            "keywords": [
                "elephant"
            ]
        },
        {
            "no": 652,
            "code": "1F98F",
            "flagged": true,
            "keywords": [
                "rhinoceros"
            ]
        },
        {
            "no": 653,
            "code": "1F42D",
            "flagged": false,
            "keywords": [
                "face",
                "mouse"
            ]
        },
        {
            "no": 654,
            "code": "1F401",
            "flagged": false,
            "keywords": [
                "mouse"
            ]
        },
        {
            "no": 655,
            "code": "1F400",
            "flagged": false,
            "keywords": [
                "rat"
            ]
        },
        {
            "no": 656,
            "code": "1F439",
            "flagged": false,
            "keywords": [
                "face",
                "hamster",
                "pet"
            ]
        },
        {
            "no": 657,
            "code": "1F430",
            "flagged": false,
            "keywords": [
                "bunny",
                "face",
                "pet",
                "rabbit"
            ]
        },
        {
            "no": 658,
            "code": "1F407",
            "flagged": false,
            "keywords": [
                "bunny",
                "pet",
                "rabbit"
            ]
        },
        {
            "no": 659,
            "code": "1F43F",
            "flagged": false,
            "keywords": [
                "chipmunk"
            ]
        },
        {
            "no": 660,
            "code": "1F987",
            "flagged": true,
            "keywords": [
                "bat",
                "vampire"
            ]
        },
        {
            "no": 661,
            "code": "1F43B",
            "flagged": false,
            "keywords": [
                "bear",
                "face"
            ]
        },
        {
            "no": 662,
            "code": "1F428",
            "flagged": false,
            "keywords": [
                "bear",
                "koala"
            ]
        },
        {
            "no": 663,
            "code": "1F43C",
            "flagged": false,
            "keywords": [
                "face",
                "panda"
            ]
        },
        {
            "no": 664,
            "code": "1F43E",
            "flagged": false,
            "keywords": [
                "feet",
                "paw",
                "print"
            ]
        },
        {
            "no": 665,
            "code": "1F983",
            "flagged": false,
            "keywords": [
                "turkey"
            ]
        },
        {
            "no": 666,
            "code": "1F414",
            "flagged": false,
            "keywords": [
                "chicken"
            ]
        },
        {
            "no": 667,
            "code": "1F413",
            "flagged": false,
            "keywords": [
                "rooster"
            ]
        },
        {
            "no": 668,
            "code": "1F423",
            "flagged": false,
            "keywords": [
                "baby",
                "chick",
                "hatching"
            ]
        },
        {
            "no": 669,
            "code": "1F424",
            "flagged": false,
            "keywords": [
                "baby",
                "chick"
            ]
        },
        {
            "no": 670,
            "code": "1F425",
            "flagged": false,
            "keywords": [
                "baby",
                "chick"
            ]
        },
        {
            "no": 671,
            "code": "1F426",
            "flagged": false,
            "keywords": [
                "bird"
            ]
        },
        {
            "no": 672,
            "code": "1F427",
            "flagged": false,
            "keywords": [
                "penguin"
            ]
        },
        {
            "no": 673,
            "code": "1F54A",
            "flagged": false,
            "keywords": [
                "bird",
                "dove",
                "fly",
                "peace"
            ]
        },
        {
            "no": 674,
            "code": "1F985",
            "flagged": true,
            "keywords": [
                "bird",
                "eagle"
            ]
        },
        {
            "no": 675,
            "code": "1F986",
            "flagged": true,
            "keywords": [
                "bird",
                "duck"
            ]
        },
        {
            "no": 676,
            "code": "1F989",
            "flagged": true,
            "keywords": [
                "bird",
                "owl",
                "wise"
            ]
        },
        {
            "no": 677,
            "code": "1F438",
            "flagged": false,
            "keywords": [
                "face",
                "frog"
            ]
        },
        {
            "no": 678,
            "code": "1F40A",
            "flagged": false,
            "keywords": [
                "crocodile"
            ]
        },
        {
            "no": 679,
            "code": "1F422",
            "flagged": false,
            "keywords": [
                "turtle"
            ]
        },
        {
            "no": 680,
            "code": "1F98E",
            "flagged": true,
            "keywords": [
                "lizard",
                "reptile"
            ]
        },
        {
            "no": 681,
            "code": "1F40D",
            "flagged": false,
            "keywords": [
                "bearer",
                "ophiuchus",
                "serpent",
                "snake",
                "zodiac"
            ]
        },
        {
            "no": 682,
            "code": "1F432",
            "flagged": false,
            "keywords": [
                "dragon",
                "face",
                "fairy tale"
            ]
        },
        {
            "no": 683,
            "code": "1F409",
            "flagged": false,
            "keywords": [
                "dragon",
                "fairy tale"
            ]
        },
        {
            "no": 684,
            "code": "1F433",
            "flagged": false,
            "keywords": [
                "face",
                "spouting",
                "whale"
            ]
        },
        {
            "no": 685,
            "code": "1F40B",
            "flagged": false,
            "keywords": [
                "whale"
            ]
        },
        {
            "no": 686,
            "code": "1F42C",
            "flagged": false,
            "keywords": [
                "dolphin",
                "flipper"
            ]
        },
        {
            "no": 687,
            "code": "1F41F",
            "flagged": false,
            "keywords": [
                "fish",
                "pisces",
                "zodiac"
            ]
        },
        {
            "no": 688,
            "code": "1F420",
            "flagged": false,
            "keywords": [
                "fish",
                "tropical"
            ]
        },
        {
            "no": 689,
            "code": "1F421",
            "flagged": false,
            "keywords": [
                "blowfish",
                "fish"
            ]
        },
        {
            "no": 690,
            "code": "1F988",
            "flagged": true,
            "keywords": [
                "fish",
                "shark"
            ]
        },
        {
            "no": 691,
            "code": "1F419",
            "flagged": false,
            "keywords": [
                "octopus"
            ]
        },
        {
            "no": 692,
            "code": "1F41A",
            "flagged": false,
            "keywords": [
                "shell",
                "spiral"
            ]
        },
        {
            "no": 693,
            "code": "1F980",
            "flagged": false,
            "keywords": [
                "cancer",
                "crab",
                "zodiac"
            ]
        },
        {
            "no": 694,
            "code": "1F990",
            "flagged": true,
            "keywords": [
                "shellfish",
                "shrimp",
                "small"
            ]
        },
        {
            "no": 695,
            "code": "1F991",
            "flagged": true,
            "keywords": [
                "molusc",
                "squid"
            ]
        },
        {
            "no": 696,
            "code": "1F98B",
            "flagged": true,
            "keywords": [
                "butterfly",
                "insect",
                "pretty"
            ]
        },
        {
            "no": 697,
            "code": "1F40C",
            "flagged": false,
            "keywords": [
                "snail"
            ]
        },
        {
            "no": 698,
            "code": "1F41B",
            "flagged": false,
            "keywords": [
                "bug",
                "insect"
            ]
        },
        {
            "no": 699,
            "code": "1F41C",
            "flagged": false,
            "keywords": [
                "ant",
                "insect"
            ]
        },
        {
            "no": 700,
            "code": "1F41D",
            "flagged": false,
            "keywords": [
                "bee",
                "honeybee",
                "insect"
            ]
        },
        {
            "no": 701,
            "code": "1F41E",
            "flagged": false,
            "keywords": [
                "beetle",
                "insect",
                "lady beetle",
                "ladybird",
                "ladybug"
            ]
        },
        {
            "no": 702,
            "code": "1F577",
            "flagged": false,
            "keywords": [
                "insect",
                "spider"
            ]
        },
        {
            "no": 703,
            "code": "1F578",
            "flagged": false,
            "keywords": [
                "spider",
                "web"
            ]
        },
        {
            "no": 704,
            "code": "1F982",
            "flagged": false,
            "keywords": [
                "scorpio",
                "scorpion",
                "scorpius",
                "zodiac"
            ]
        },
        {
            "no": 705,
            "code": "1F490",
            "flagged": false,
            "keywords": [
                "bouquet",
                "flower",
                "plant",
                "romance"
            ]
        },
        {
            "no": 706,
            "code": "1F338",
            "flagged": false,
            "keywords": [
                "blossom",
                "cherry",
                "flower",
                "plant"
            ]
        },
        {
            "no": 707,
            "code": "1F4AE",
            "flagged": false,
            "keywords": [
                "flower"
            ]
        },
        {
            "no": 708,
            "code": "1F3F5",
            "flagged": false,
            "keywords": [
                "plant",
                "rosette"
            ]
        },
        {
            "no": 709,
            "code": "1F339",
            "flagged": false,
            "keywords": [
                "flower",
                "plant",
                "rose"
            ]
        },
        {
            "no": 710,
            "code": "1F940",
            "flagged": true,
            "keywords": [
                "flower",
                "wilted"
            ]
        },
        {
            "no": 711,
            "code": "1F33A",
            "flagged": false,
            "keywords": [
                "flower",
                "hibiscus",
                "plant"
            ]
        },
        {
            "no": 712,
            "code": "1F33B",
            "flagged": false,
            "keywords": [
                "flower",
                "plant",
                "sun",
                "sunflower"
            ]
        },
        {
            "no": 713,
            "code": "1F33C",
            "flagged": false,
            "keywords": [
                "blossom",
                "flower",
                "plant"
            ]
        },
        {
            "no": 714,
            "code": "1F337",
            "flagged": false,
            "keywords": [
                "flower",
                "plant",
                "tulip"
            ]
        },
        {
            "no": 715,
            "code": "1F331",
            "flagged": false,
            "keywords": [
                "plant",
                "seedling",
                "young"
            ]
        },
        {
            "no": 716,
            "code": "1F332",
            "flagged": false,
            "keywords": [
                "evergreen",
                "plant",
                "tree"
            ]
        },
        {
            "no": 717,
            "code": "1F333",
            "flagged": false,
            "keywords": [
                "deciduous",
                "plant",
                "shedding",
                "tree"
            ]
        },
        {
            "no": 718,
            "code": "1F334",
            "flagged": false,
            "keywords": [
                "palm",
                "plant",
                "tree"
            ]
        },
        {
            "no": 719,
            "code": "1F335",
            "flagged": false,
            "keywords": [
                "cactus",
                "plant"
            ]
        },
        {
            "no": 720,
            "code": "1F33E",
            "flagged": false,
            "keywords": [
                "ear",
                "plant",
                "rice"
            ]
        },
        {
            "no": 721,
            "code": "1F33F",
            "flagged": false,
            "keywords": [
                "herb",
                "leaf",
                "plant"
            ]
        },
        {
            "no": 722,
            "code": "2618",
            "flagged": false,
            "keywords": [
                "plant",
                "shamrock"
            ]
        },
        {
            "no": 723,
            "code": "1F340",
            "flagged": false,
            "keywords": [
                "4",
                "clover",
                "four",
                "leaf",
                "plant"
            ]
        },
        {
            "no": 724,
            "code": "1F341",
            "flagged": false,
            "keywords": [
                "falling",
                "leaf",
                "maple",
                "plant"
            ]
        },
        {
            "no": 725,
            "code": "1F342",
            "flagged": false,
            "keywords": [
                "falling",
                "leaf",
                "plant"
            ]
        },
        {
            "no": 726,
            "code": "1F343",
            "flagged": false,
            "keywords": [
                "blow",
                "flutter",
                "leaf",
                "plant",
                "wind"
            ]
        },
        {
            "no": 727,
            "code": "1F347",
            "flagged": false,
            "keywords": [
                "fruit",
                "grape",
                "plant"
            ]
        },
        {
            "no": 728,
            "code": "1F348",
            "flagged": false,
            "keywords": [
                "fruit",
                "melon",
                "plant"
            ]
        },
        {
            "no": 729,
            "code": "1F349",
            "flagged": false,
            "keywords": [
                "fruit",
                "plant",
                "watermelon"
            ]
        },
        {
            "no": 730,
            "code": "1F34A",
            "flagged": false,
            "keywords": [
                "fruit",
                "orange",
                "plant",
                "tangerine"
            ]
        },
        {
            "no": 731,
            "code": "1F34B",
            "flagged": false,
            "keywords": [
                "citrus",
                "fruit",
                "lemon",
                "plant"
            ]
        },
        {
            "no": 732,
            "code": "1F34C",
            "flagged": false,
            "keywords": [
                "banana",
                "fruit",
                "plant"
            ]
        },
        {
            "no": 733,
            "code": "1F34D",
            "flagged": false,
            "keywords": [
                "fruit",
                "pineapple",
                "plant"
            ]
        },
        {
            "no": 734,
            "code": "1F34E",
            "flagged": false,
            "keywords": [
                "apple",
                "fruit",
                "plant",
                "red"
            ]
        },
        {
            "no": 735,
            "code": "1F34F",
            "flagged": false,
            "keywords": [
                "apple",
                "fruit",
                "green",
                "plant"
            ]
        },
        {
            "no": 736,
            "code": "1F350",
            "flagged": false,
            "keywords": [
                "fruit",
                "pear",
                "plant"
            ]
        },
        {
            "no": 737,
            "code": "1F351",
            "flagged": false,
            "keywords": [
                "fruit",
                "peach",
                "plant"
            ]
        },
        {
            "no": 738,
            "code": "1F352",
            "flagged": false,
            "keywords": [
                "cherry",
                "fruit",
                "plant"
            ]
        },
        {
            "no": 739,
            "code": "1F353",
            "flagged": false,
            "keywords": [
                "berry",
                "fruit",
                "plant",
                "strawberry"
            ]
        },
        {
            "no": 740,
            "code": "1F345",
            "flagged": false,
            "keywords": [
                "plant",
                "tomato",
                "vegetable"
            ]
        },
        {
            "no": 741,
            "code": "1F95D",
            "flagged": true,
            "keywords": [
                "fruit",
                "kiwi"
            ]
        },
        {
            "no": 742,
            "code": "1F951",
            "flagged": true,
            "keywords": [
                "avocado",
                "fruit"
            ]
        },
        {
            "no": 743,
            "code": "1F346",
            "flagged": false,
            "keywords": [
                "aubergine",
                "eggplant",
                "plant",
                "vegetable"
            ]
        },
        {
            "no": 744,
            "code": "1F954",
            "flagged": true,
            "keywords": [
                "potato",
                "vegetable"
            ]
        },
        {
            "no": 745,
            "code": "1F955",
            "flagged": true,
            "keywords": [
                "carrot",
                "vegetable"
            ]
        },
        {
            "no": 746,
            "code": "1F33D",
            "flagged": false,
            "keywords": [
                "corn",
                "ear",
                "maize",
                "maze",
                "plant"
            ]
        },
        {
            "no": 747,
            "code": "1F336",
            "flagged": false,
            "keywords": [
                "hot",
                "pepper",
                "plant"
            ]
        },
        {
            "no": 748,
            "code": "1F952",
            "flagged": true,
            "keywords": [
                "cucumber",
                "pickle",
                "vegetable"
            ]
        },
        {
            "no": 749,
            "code": "1F344",
            "flagged": false,
            "keywords": [
                "mushroom",
                "plant"
            ]
        },
        {
            "no": 750,
            "code": "1F95C",
            "flagged": false,
            "keywords": [
                "nut",
                "peanut",
                "vegetable"
            ]
        },
        {
            "no": 751,
            "code": "1F330",
            "flagged": false,
            "keywords": [
                "chestnut",
                "plant"
            ]
        },
        {
            "no": 752,
            "code": "1F35E",
            "flagged": false,
            "keywords": [
                "bread",
                "loaf"
            ]
        },
        {
            "no": 753,
            "code": "1F950",
            "flagged": true,
            "keywords": [
                "bread",
                "crescent roll",
                "croissant",
                "french"
            ]
        },
        {
            "no": 754,
            "code": "1F956",
            "flagged": true,
            "keywords": [
                "baguette",
                "bread",
                "french"
            ]
        },
        {
            "no": 755,
            "code": "1F95E",
            "flagged": true,
            "keywords": [
                "crêpe",
                "hotcake",
                "pancake"
            ]
        },
        {
            "no": 756,
            "code": "1F9C0",
            "flagged": false,
            "keywords": [
                "cheese"
            ]
        },
        {
            "no": 757,
            "code": "1F356",
            "flagged": false,
            "keywords": [
                "bone",
                "meat"
            ]
        },
        {
            "no": 758,
            "code": "1F357",
            "flagged": false,
            "keywords": [
                "bone",
                "chicken",
                "leg",
                "poultry"
            ]
        },
        {
            "no": 759,
            "code": "1F953",
            "flagged": true,
            "keywords": [
                "bacon",
                "meat"
            ]
        },
        {
            "no": 760,
            "code": "1F354",
            "flagged": false,
            "keywords": [
                "burger",
                "hamburger"
            ]
        },
        {
            "no": 761,
            "code": "1F35F",
            "flagged": false,
            "keywords": [
                "french",
                "fries"
            ]
        },
        {
            "no": 762,
            "code": "1F355",
            "flagged": false,
            "keywords": [
                "cheese",
                "pizza",
                "slice"
            ]
        },
        {
            "no": 763,
            "code": "1F32D",
            "flagged": false,
            "keywords": [
                "frankfurter",
                "hot dog",
                "hotdog",
                "sausage"
            ]
        },
        {
            "no": 764,
            "code": "1F32E",
            "flagged": false,
            "keywords": [
                "mexican",
                "taco"
            ]
        },
        {
            "no": 765,
            "code": "1F32F",
            "flagged": false,
            "keywords": [
                "burrito",
                "mexican"
            ]
        },
        {
            "no": 766,
            "code": "1F959",
            "flagged": true,
            "keywords": [
                "falafel",
                "flatbread",
                "gyro",
                "kebab",
                "stuffed"
            ]
        },
        {
            "no": 767,
            "code": "1F95A",
            "flagged": true,
            "keywords": [
                "egg"
            ]
        },
        {
            "no": 768,
            "code": "1F373",
            "flagged": false,
            "keywords": [
                "cooking",
                "egg",
                "frying",
                "pan"
            ]
        },
        {
            "no": 769,
            "code": "1F958",
            "flagged": true,
            "keywords": [
                "casserole",
                "paella",
                "pan",
                "shallow"
            ]
        },
        {
            "no": 770,
            "code": "1F372",
            "flagged": false,
            "keywords": [
                "pot",
                "stew"
            ]
        },
        {
            "no": 771,
            "code": "1F957",
            "flagged": true,
            "keywords": [
                "green",
                "salad"
            ]
        },
        {
            "no": 772,
            "code": "1F37F",
            "flagged": false,
            "keywords": [
                "popcorn"
            ]
        },
        {
            "no": 773,
            "code": "1F371",
            "flagged": false,
            "keywords": [
                "bento",
                "box"
            ]
        },
        {
            "no": 774,
            "code": "1F358",
            "flagged": false,
            "keywords": [
                "cracker",
                "rice"
            ]
        },
        {
            "no": 775,
            "code": "1F359",
            "flagged": false,
            "keywords": [
                "ball",
                "japanese",
                "rice"
            ]
        },
        {
            "no": 776,
            "code": "1F35A",
            "flagged": false,
            "keywords": [
                "cooked",
                "rice"
            ]
        },
        {
            "no": 777,
            "code": "1F35B",
            "flagged": false,
            "keywords": [
                "curry",
                "rice"
            ]
        },
        {
            "no": 778,
            "code": "1F35C",
            "flagged": false,
            "keywords": [
                "bowl",
                "noodle",
                "ramen",
                "steaming"
            ]
        },
        {
            "no": 779,
            "code": "1F35D",
            "flagged": false,
            "keywords": [
                "pasta",
                "spaghetti"
            ]
        },
        {
            "no": 780,
            "code": "1F360",
            "flagged": false,
            "keywords": [
                "potato",
                "roasted",
                "sweet"
            ]
        },
        {
            "no": 781,
            "code": "1F362",
            "flagged": false,
            "keywords": [
                "kebab",
                "oden",
                "seafood",
                "skewer",
                "stick"
            ]
        },
        {
            "no": 782,
            "code": "1F363",
            "flagged": false,
            "keywords": [
                "sushi"
            ]
        },
        {
            "no": 783,
            "code": "1F364",
            "flagged": false,
            "keywords": [
                "fried",
                "prawn",
                "shrimp",
                "tempura"
            ]
        },
        {
            "no": 784,
            "code": "1F365",
            "flagged": false,
            "keywords": [
                "cake",
                "fish",
                "pastry",
                "swirl"
            ]
        },
        {
            "no": 785,
            "code": "1F361",
            "flagged": false,
            "keywords": [
                "dango",
                "dessert",
                "japanese",
                "skewer",
                "stick",
                "sweet"
            ]
        },
        {
            "no": 786,
            "code": "1F366",
            "flagged": false,
            "keywords": [
                "cream",
                "dessert",
                "ice",
                "icecream",
                "soft",
                "sweet"
            ]
        },
        {
            "no": 787,
            "code": "1F367",
            "flagged": false,
            "keywords": [
                "dessert",
                "ice",
                "shaved",
                "sweet"
            ]
        },
        {
            "no": 788,
            "code": "1F368",
            "flagged": false,
            "keywords": [
                "cream",
                "dessert",
                "ice",
                "sweet"
            ]
        },
        {
            "no": 789,
            "code": "1F369",
            "flagged": false,
            "keywords": [
                "dessert",
                "donut",
                "doughnut",
                "sweet"
            ]
        },
        {
            "no": 790,
            "code": "1F36A",
            "flagged": false,
            "keywords": [
                "cookie",
                "dessert",
                "sweet"
            ]
        },
        {
            "no": 791,
            "code": "1F382",
            "flagged": false,
            "keywords": [
                "birthday",
                "cake",
                "celebration",
                "dessert",
                "pastry",
                "sweet"
            ]
        },
        {
            "no": 792,
            "code": "1F370",
            "flagged": false,
            "keywords": [
                "cake",
                "dessert",
                "pastry",
                "shortcake",
                "slice",
                "sweet"
            ]
        },
        {
            "no": 793,
            "code": "1F36B",
            "flagged": false,
            "keywords": [
                "bar",
                "chocolate",
                "dessert",
                "sweet"
            ]
        },
        {
            "no": 794,
            "code": "1F36C",
            "flagged": false,
            "keywords": [
                "candy",
                "dessert",
                "sweet"
            ]
        },
        {
            "no": 795,
            "code": "1F36D",
            "flagged": false,
            "keywords": [
                "candy",
                "dessert",
                "lollipop",
                "sweet"
            ]
        },
        {
            "no": 796,
            "code": "1F36E",
            "flagged": false,
            "keywords": [
                "custard",
                "dessert",
                "pudding",
                "sweet"
            ]
        },
        {
            "no": 797,
            "code": "1F36F",
            "flagged": false,
            "keywords": [
                "honey",
                "honeypot",
                "pot",
                "sweet"
            ]
        },
        {
            "no": 798,
            "code": "1F37C",
            "flagged": false,
            "keywords": [
                "baby",
                "bottle",
                "drink",
                "milk"
            ]
        },
        {
            "no": 799,
            "code": "1F95B",
            "flagged": true,
            "keywords": [
                "drink",
                "glass",
                "milk"
            ]
        },
        {
            "no": 800,
            "code": "2615",
            "flagged": false,
            "keywords": [
                "beverage",
                "coffee",
                "drink",
                "hot",
                "steaming",
                "tea"
            ]
        },
        {
            "no": 801,
            "code": "1F375",
            "flagged": false,
            "keywords": [
                "beverage",
                "cup",
                "drink",
                "tea",
                "teacup"
            ]
        },
        {
            "no": 802,
            "code": "1F376",
            "flagged": false,
            "keywords": [
                "bar",
                "beverage",
                "bottle",
                "cup",
                "drink",
                "sake"
            ]
        },
        {
            "no": 803,
            "code": "1F37E",
            "flagged": false,
            "keywords": [
                "bar",
                "bottle",
                "cork",
                "drink",
                "popping"
            ]
        },
        {
            "no": 804,
            "code": "1F377",
            "flagged": false,
            "keywords": [
                "bar",
                "beverage",
                "drink",
                "glass",
                "wine"
            ]
        },
        {
            "no": 805,
            "code": "1F378",
            "flagged": false,
            "keywords": [
                "bar",
                "cocktail",
                "drink",
                "glass"
            ]
        },
        {
            "no": 806,
            "code": "1F379",
            "flagged": false,
            "keywords": [
                "bar",
                "drink",
                "tropical"
            ]
        },
        {
            "no": 807,
            "code": "1F37A",
            "flagged": false,
            "keywords": [
                "bar",
                "beer",
                "drink",
                "mug"
            ]
        },
        {
            "no": 808,
            "code": "1F37B",
            "flagged": false,
            "keywords": [
                "bar",
                "beer",
                "clink",
                "drink",
                "mug"
            ]
        },
        {
            "no": 809,
            "code": "1F942",
            "flagged": true,
            "keywords": [
                "celebrate",
                "clink",
                "drink",
                "glass"
            ]
        },
        {
            "no": 810,
            "code": "1F943",
            "flagged": true,
            "keywords": [
                "glass",
                "liquor",
                "shot",
                "tumbler",
                "whisky"
            ]
        },
        {
            "no": 811,
            "code": "1F37D",
            "flagged": false,
            "keywords": [
                "cooking",
                "fork",
                "knife",
                "plate"
            ]
        },
        {
            "no": 812,
            "code": "1F374",
            "flagged": false,
            "keywords": [
                "cooking",
                "fork",
                "knife"
            ]
        },
        {
            "no": 813,
            "code": "1F944",
            "flagged": true,
            "keywords": [
                "spoon",
                "tableware"
            ]
        },
        {
            "no": 814,
            "code": "1F52A",
            "flagged": false,
            "keywords": [
                "cooking",
                "hocho",
                "knife",
                "tool",
                "weapon"
            ]
        },
        {
            "no": 815,
            "code": "1F3FA",
            "flagged": false,
            "keywords": [
                "amphora",
                "aquarius",
                "cooking",
                "drink",
                "jug",
                "tool",
                "weapon",
                "zodiac"
            ]
        }
    ],
    TRAVEL: [
        {
            "no": 816,
            "code": "1F30D",
            "flagged": false,
            "keywords": [
                "africa",
                "earth",
                "europe",
                "globe",
                "world"
            ]
        },
        {
            "no": 817,
            "code": "1F30E",
            "flagged": false,
            "keywords": [
                "americas",
                "earth",
                "globe",
                "world"
            ]
        },
        {
            "no": 818,
            "code": "1F30F",
            "flagged": false,
            "keywords": [
                "asia",
                "australia",
                "earth",
                "globe",
                "world"
            ]
        },
        {
            "no": 819,
            "code": "1F310",
            "flagged": false,
            "keywords": [
                "earth",
                "globe",
                "meridians",
                "world"
            ]
        },
        {
            "no": 820,
            "code": "1F5FA",
            "flagged": false,
            "keywords": [
                "map",
                "world"
            ]
        },
        {
            "no": 821,
            "code": "1F5FE",
            "flagged": false,
            "keywords": [
                "japan",
                "map"
            ]
        },
        {
            "no": 822,
            "code": "1F3D4",
            "flagged": false,
            "keywords": [
                "cold",
                "mountain",
                "snow"
            ]
        },
        {
            "no": 823,
            "code": "26F0",
            "flagged": false,
            "keywords": [
                "mountain"
            ]
        },
        {
            "no": 824,
            "code": "1F30B",
            "flagged": false,
            "keywords": [
                "eruption",
                "mountain",
                "volcano",
                "weather"
            ]
        },
        {
            "no": 825,
            "code": "1F5FB",
            "flagged": false,
            "keywords": [
                "fuji",
                "mountain"
            ]
        },
        {
            "no": 826,
            "code": "1F3D5",
            "flagged": false,
            "keywords": [
                "camping"
            ]
        },
        {
            "no": 827,
            "code": "1F3D6",
            "flagged": false,
            "keywords": [
                "beach",
                "umbrella"
            ]
        },
        {
            "no": 828,
            "code": "1F3DC",
            "flagged": false,
            "keywords": [
                "desert"
            ]
        },
        {
            "no": 829,
            "code": "1F3DD",
            "flagged": false,
            "keywords": [
                "desert",
                "island"
            ]
        },
        {
            "no": 830,
            "code": "1F3DE",
            "flagged": false,
            "keywords": [
                "national park",
                "park"
            ]
        },
        {
            "no": 831,
            "code": "1F3DF",
            "flagged": false,
            "keywords": [
                "stadium"
            ]
        },
        {
            "no": 832,
            "code": "1F3DB",
            "flagged": false,
            "keywords": [
                "building",
                "classical"
            ]
        },
        {
            "no": 833,
            "code": "1F3D7",
            "flagged": false,
            "keywords": [
                "building",
                "construction"
            ]
        },
        {
            "no": 834,
            "code": "1F3D8",
            "flagged": false,
            "keywords": [
                "building",
                "house"
            ]
        },
        {
            "no": 835,
            "code": "1F3D9",
            "flagged": false,
            "keywords": [
                "building",
                "city"
            ]
        },
        {
            "no": 836,
            "code": "1F3DA",
            "flagged": false,
            "keywords": [
                "building",
                "derelict",
                "house"
            ]
        },
        {
            "no": 837,
            "code": "1F3E0",
            "flagged": false,
            "keywords": [
                "building",
                "home",
                "house"
            ]
        },
        {
            "no": 838,
            "code": "1F3E1",
            "flagged": false,
            "keywords": [
                "building",
                "garden",
                "home",
                "house"
            ]
        },
        {
            "no": 839,
            "code": "1F3E2",
            "flagged": false,
            "keywords": [
                "building"
            ]
        },
        {
            "no": 840,
            "code": "1F3E3",
            "flagged": false,
            "keywords": [
                "building",
                "japanese",
                "post"
            ]
        },
        {
            "no": 841,
            "code": "1F3E4",
            "flagged": false,
            "keywords": [
                "building",
                "european",
                "post"
            ]
        },
        {
            "no": 842,
            "code": "1F3E5",
            "flagged": false,
            "keywords": [
                "building",
                "doctor",
                "hospital",
                "medicine"
            ]
        },
        {
            "no": 843,
            "code": "1F3E6",
            "flagged": false,
            "keywords": [
                "bank",
                "building"
            ]
        },
        {
            "no": 844,
            "code": "1F3E8",
            "flagged": false,
            "keywords": [
                "building",
                "hotel"
            ]
        },
        {
            "no": 845,
            "code": "1F3E9",
            "flagged": false,
            "keywords": [
                "building",
                "hotel",
                "love"
            ]
        },
        {
            "no": 846,
            "code": "1F3EA",
            "flagged": false,
            "keywords": [
                "building",
                "convenience",
                "store"
            ]
        },
        {
            "no": 847,
            "code": "1F3EB",
            "flagged": false,
            "keywords": [
                "building",
                "school"
            ]
        },
        {
            "no": 848,
            "code": "1F3EC",
            "flagged": false,
            "keywords": [
                "building",
                "department",
                "store"
            ]
        },
        {
            "no": 849,
            "code": "1F3ED",
            "flagged": false,
            "keywords": [
                "building",
                "factory"
            ]
        },
        {
            "no": 850,
            "code": "1F3EF",
            "flagged": false,
            "keywords": [
                "building",
                "castle",
                "japanese"
            ]
        },
        {
            "no": 851,
            "code": "1F3F0",
            "flagged": false,
            "keywords": [
                "building",
                "castle",
                "european"
            ]
        },
        {
            "no": 852,
            "code": "1F492",
            "flagged": false,
            "keywords": [
                "activity",
                "chapel",
                "romance",
                "wedding"
            ]
        },
        {
            "no": 853,
            "code": "1F5FC",
            "flagged": false,
            "keywords": [
                "tokyo",
                "tower"
            ]
        },
        {
            "no": 854,
            "code": "1F5FD",
            "flagged": false,
            "keywords": [
                "liberty",
                "statue"
            ]
        },
        {
            "no": 855,
            "code": "26EA",
            "flagged": false,
            "keywords": [
                "building",
                "christian",
                "church",
                "cross",
                "religion"
            ]
        },
        {
            "no": 856,
            "code": "1F54C",
            "flagged": false,
            "keywords": [
                "islam",
                "mosque",
                "muslim",
                "religion"
            ]
        },
        {
            "no": 857,
            "code": "1F54D",
            "flagged": false,
            "keywords": [
                "jew",
                "jewish",
                "religion",
                "synagogue",
                "temple"
            ]
        },
        {
            "no": 858,
            "code": "26E9",
            "flagged": false,
            "keywords": [
                "religion",
                "shinto",
                "shrine"
            ]
        },
        {
            "no": 859,
            "code": "1F54B",
            "flagged": false,
            "keywords": [
                "islam",
                "kaaba",
                "muslim",
                "religion"
            ]
        },
        {
            "no": 860,
            "code": "26F2",
            "flagged": false,
            "keywords": [
                "fountain"
            ]
        },
        {
            "no": 861,
            "code": "26FA",
            "flagged": false,
            "keywords": [
                "camping",
                "tent"
            ]
        },
        {
            "no": 862,
            "code": "1F301",
            "flagged": false,
            "keywords": [
                "fog",
                "weather"
            ]
        },
        {
            "no": 863,
            "code": "1F303",
            "flagged": false,
            "keywords": [
                "night",
                "star",
                "weather"
            ]
        },
        {
            "no": 864,
            "code": "1F304",
            "flagged": false,
            "keywords": [
                "morning",
                "mountain",
                "sun",
                "sunrise",
                "weather"
            ]
        },
        {
            "no": 865,
            "code": "1F305",
            "flagged": false,
            "keywords": [
                "morning",
                "sun",
                "sunrise",
                "weather"
            ]
        },
        {
            "no": 866,
            "code": "1F306",
            "flagged": false,
            "keywords": [
                "building",
                "city",
                "dusk",
                "evening",
                "landscape",
                "sun",
                "sunset",
                "weather"
            ]
        },
        {
            "no": 867,
            "code": "1F307",
            "flagged": false,
            "keywords": [
                "building",
                "dusk",
                "sun",
                "sunset",
                "weather"
            ]
        },
        {
            "no": 868,
            "code": "1F309",
            "flagged": false,
            "keywords": [
                "bridge",
                "night",
                "weather"
            ]
        },
        {
            "no": 869,
            "code": "2668",
            "flagged": false,
            "keywords": [
                "hot",
                "hotsprings",
                "springs",
                "steaming"
            ]
        },
        {
            "no": 870,
            "code": "1F30C",
            "flagged": false,
            "keywords": [
                "milky way",
                "space",
                "weather"
            ]
        },
        {
            "no": 871,
            "code": "1F3A0",
            "flagged": false,
            "keywords": [
                "activity",
                "carousel",
                "entertainment",
                "horse"
            ]
        },
        {
            "no": 872,
            "code": "1F3A1",
            "flagged": false,
            "keywords": [
                "activity",
                "amusement park",
                "entertainment",
                "ferris",
                "wheel"
            ]
        },
        {
            "no": 873,
            "code": "1F3A2",
            "flagged": false,
            "keywords": [
                "activity",
                "amusement park",
                "coaster",
                "entertainment",
                "roller"
            ]
        },
        {
            "no": 874,
            "code": "1F488",
            "flagged": false,
            "keywords": [
                "barber",
                "haircut",
                "pole"
            ]
        },
        {
            "no": 875,
            "code": "1F3AA",
            "flagged": false,
            "keywords": [
                "activity",
                "circus",
                "entertainment",
                "tent"
            ]
        },
        {
            "no": 876,
            "code": "1F3AD",
            "flagged": false,
            "keywords": [
                "activity",
                "art",
                "entertainment",
                "mask",
                "performing",
                "theater",
                "theatre"
            ]
        },
        {
            "no": 877,
            "code": "1F5BC",
            "flagged": false,
            "keywords": [
                "art",
                "frame",
                "museum",
                "painting",
                "picture"
            ]
        },
        {
            "no": 878,
            "code": "1F3A8",
            "flagged": false,
            "keywords": [
                "activity",
                "art",
                "entertainment",
                "museum",
                "painting",
                "palette"
            ]
        },
        {
            "no": 879,
            "code": "1F3B0",
            "flagged": false,
            "keywords": [
                "activity",
                "game",
                "slot"
            ]
        },
        {
            "no": 880,
            "code": "1F682",
            "flagged": false,
            "keywords": [
                "engine",
                "locomotive",
                "railway",
                "steam",
                "train",
                "vehicle"
            ]
        },
        {
            "no": 881,
            "code": "1F683",
            "flagged": false,
            "keywords": [
                "car",
                "electric",
                "railway",
                "train",
                "tram",
                "trolleybus",
                "vehicle"
            ]
        },
        {
            "no": 882,
            "code": "1F684",
            "flagged": false,
            "keywords": [
                "railway",
                "shinkansen",
                "speed",
                "train",
                "vehicle"
            ]
        },
        {
            "no": 883,
            "code": "1F685",
            "flagged": false,
            "keywords": [
                "bullet",
                "railway",
                "shinkansen",
                "speed",
                "train",
                "vehicle"
            ]
        },
        {
            "no": 884,
            "code": "1F686",
            "flagged": false,
            "keywords": [
                "railway",
                "train",
                "vehicle"
            ]
        },
        {
            "no": 885,
            "code": "1F687",
            "flagged": false,
            "keywords": [
                "metro",
                "subway",
                "vehicle"
            ]
        },
        {
            "no": 886,
            "code": "1F688",
            "flagged": false,
            "keywords": [
                "railway",
                "vehicle"
            ]
        },
        {
            "no": 887,
            "code": "1F689",
            "flagged": false,
            "keywords": [
                "railway",
                "station",
                "train",
                "vehicle"
            ]
        },
        {
            "no": 888,
            "code": "1F68A",
            "flagged": false,
            "keywords": [
                "tram",
                "trolleybus",
                "vehicle"
            ]
        },
        {
            "no": 889,
            "code": "1F69D",
            "flagged": false,
            "keywords": [
                "monorail",
                "vehicle"
            ]
        },
        {
            "no": 890,
            "code": "1F69E",
            "flagged": false,
            "keywords": [
                "car",
                "mountain",
                "railway",
                "vehicle"
            ]
        },
        {
            "no": 891,
            "code": "1F68B",
            "flagged": false,
            "keywords": [
                "car",
                "tram",
                "trolleybus",
                "vehicle"
            ]
        },
        {
            "no": 892,
            "code": "1F68C",
            "flagged": false,
            "keywords": [
                "bus",
                "vehicle"
            ]
        },
        {
            "no": 893,
            "code": "1F68D",
            "flagged": false,
            "keywords": [
                "bus",
                "oncoming",
                "vehicle"
            ]
        },
        {
            "no": 894,
            "code": "1F68E",
            "flagged": false,
            "keywords": [
                "bus",
                "tram",
                "trolley",
                "trolleybus",
                "vehicle"
            ]
        },
        {
            "no": 895,
            "code": "1F68F",
            "flagged": false,
            "keywords": [
                "bus",
                "busstop",
                "stop"
            ]
        },
        {
            "no": 896,
            "code": "1F690",
            "flagged": false,
            "keywords": [
                "bus",
                "minibus",
                "vehicle"
            ]
        },
        {
            "no": 897,
            "code": "1F691",
            "flagged": false,
            "keywords": [
                "ambulance",
                "vehicle"
            ]
        },
        {
            "no": 898,
            "code": "1F692",
            "flagged": false,
            "keywords": [
                "engine",
                "fire",
                "truck",
                "vehicle"
            ]
        },
        {
            "no": 899,
            "code": "1F693",
            "flagged": false,
            "keywords": [
                "car",
                "patrol",
                "police",
                "vehicle"
            ]
        },
        {
            "no": 900,
            "code": "1F694",
            "flagged": false,
            "keywords": [
                "car",
                "oncoming",
                "police",
                "vehicle"
            ]
        },
        {
            "no": 901,
            "code": "1F695",
            "flagged": false,
            "keywords": [
                "taxi",
                "vehicle"
            ]
        },
        {
            "no": 902,
            "code": "1F696",
            "flagged": false,
            "keywords": [
                "oncoming",
                "taxi",
                "vehicle"
            ]
        },
        {
            "no": 903,
            "code": "1F697",
            "flagged": false,
            "keywords": [
                "automobile",
                "car",
                "vehicle"
            ]
        },
        {
            "no": 904,
            "code": "1F698",
            "flagged": false,
            "keywords": [
                "automobile",
                "car",
                "oncoming",
                "vehicle"
            ]
        },
        {
            "no": 905,
            "code": "1F699",
            "flagged": false,
            "keywords": [
                "recreational",
                "rv",
                "vehicle"
            ]
        },
        {
            "no": 906,
            "code": "1F69A",
            "flagged": false,
            "keywords": [
                "delivery",
                "truck",
                "vehicle"
            ]
        },
        {
            "no": 907,
            "code": "1F69B",
            "flagged": false,
            "keywords": [
                "lorry",
                "semi",
                "truck",
                "vehicle"
            ]
        },
        {
            "no": 908,
            "code": "1F69C",
            "flagged": false,
            "keywords": [
                "tractor",
                "vehicle"
            ]
        },
        {
            "no": 909,
            "code": "1F6B2",
            "flagged": false,
            "keywords": [
                "bicycle",
                "bike",
                "vehicle"
            ]
        },
        {
            "no": 910,
            "code": "26FD",
            "flagged": false,
            "keywords": [
                "fuel",
                "fuelpump",
                "gas",
                "pump",
                "station"
            ]
        },
        {
            "no": 911,
            "code": "1F6E3",
            "flagged": false,
            "keywords": [
                "highway",
                "motorway",
                "road"
            ]
        },
        {
            "no": 912,
            "code": "1F6E4",
            "flagged": false,
            "keywords": [
                "railway",
                "train"
            ]
        },
        {
            "no": 913,
            "code": "1F6A8",
            "flagged": false,
            "keywords": [
                "beacon",
                "car",
                "light",
                "police",
                "revolving",
                "vehicle"
            ]
        },
        {
            "no": 914,
            "code": "1F6A5",
            "flagged": false,
            "keywords": [
                "light",
                "signal",
                "traffic"
            ]
        },
        {
            "no": 915,
            "code": "1F6A6",
            "flagged": false,
            "keywords": [
                "light",
                "signal",
                "traffic"
            ]
        },
        {
            "no": 916,
            "code": "1F6A7",
            "flagged": false,
            "keywords": [
                "barrier",
                "construction"
            ]
        },
        {
            "no": 917,
            "code": "1F6D1",
            "flagged": true,
            "keywords": [
                "octagonal",
                "stop"
            ]
        },
        {
            "no": 918,
            "code": "1F6F4",
            "flagged": true,
            "keywords": [
                "kick",
                "scooter"
            ]
        },
        {
            "no": 919,
            "code": "1F6F5",
            "flagged": true,
            "keywords": [
                "motor",
                "scooter"
            ]
        },
        {
            "no": 920,
            "code": "2693",
            "flagged": false,
            "keywords": [
                "anchor",
                "ship",
                "tool"
            ]
        },
        {
            "no": 921,
            "code": "26F5",
            "flagged": false,
            "keywords": [
                "boat",
                "resort",
                "sailboat",
                "sea",
                "vehicle",
                "yacht"
            ]
        },
        {
            "no": 922,
            "code": "1F6A3",
            "flagged": false,
            "keywords": [
                "boat",
                "rowboat",
                "vehicle"
            ],
            "types": [
                "1F6A3-1F3FF",
                "1F6A3-1F3FE",
                "1F6A3-1F3FD",
                "1F6A3-1F3FC",
                "1F6A3-1F3FB"
            ]
        },
        {
            "no": 928,
            "code": "1F6F6",
            "flagged": true,
            "keywords": [
                "boat",
                "canoe"
            ]
        },
        {
            "no": 929,
            "code": "1F6A4",
            "flagged": false,
            "keywords": [
                "boat",
                "speedboat",
                "vehicle"
            ]
        },
        {
            "no": 930,
            "code": "1F6F3",
            "flagged": false,
            "keywords": [
                "passenger",
                "ship",
                "vehicle"
            ]
        },
        {
            "no": 931,
            "code": "26F4",
            "flagged": false,
            "keywords": [
                "boat",
                "ferry"
            ]
        },
        {
            "no": 932,
            "code": "1F6E5",
            "flagged": false,
            "keywords": [
                "boat",
                "motorboat",
                "vehicle"
            ]
        },
        {
            "no": 933,
            "code": "1F6A2",
            "flagged": false,
            "keywords": [
                "ship",
                "vehicle"
            ]
        },
        {
            "no": 934,
            "code": "2708",
            "flagged": false,
            "keywords": [
                "airplane",
                "vehicle"
            ]
        },
        {
            "no": 935,
            "code": "1F6E9",
            "flagged": false,
            "keywords": [
                "airplane",
                "vehicle"
            ]
        },
        {
            "no": 936,
            "code": "1F6EB",
            "flagged": false,
            "keywords": [
                "airplane",
                "check-in",
                "departure",
                "departures",
                "vehicle"
            ]
        },
        {
            "no": 937,
            "code": "1F6EC",
            "flagged": false,
            "keywords": [
                "airplane",
                "arrivals",
                "arriving",
                "landing",
                "vehicle"
            ]
        },
        {
            "no": 938,
            "code": "1F4BA",
            "flagged": false,
            "keywords": [
                "chair",
                "seat"
            ]
        },
        {
            "no": 939,
            "code": "1F681",
            "flagged": false,
            "keywords": [
                "helicopter",
                "vehicle"
            ]
        },
        {
            "no": 940,
            "code": "1F69F",
            "flagged": false,
            "keywords": [
                "railway",
                "suspension",
                "vehicle"
            ]
        },
        {
            "no": 941,
            "code": "1F6A0",
            "flagged": false,
            "keywords": [
                "cable",
                "gondola",
                "mountain",
                "vehicle"
            ]
        },
        {
            "no": 942,
            "code": "1F6A1",
            "flagged": false,
            "keywords": [
                "aerial",
                "cable",
                "car",
                "gondola",
                "ropeway",
                "tramway",
                "vehicle"
            ]
        },
        {
            "no": 943,
            "code": "1F680",
            "flagged": false,
            "keywords": [
                "rocket",
                "space",
                "vehicle"
            ]
        },
        {
            "no": 944,
            "code": "1F6F0",
            "flagged": false,
            "keywords": [
                "satellite",
                "space",
                "vehicle"
            ]
        },
        {
            "no": 945,
            "code": "1F6CE",
            "flagged": false,
            "keywords": [
                "bell",
                "bellhop",
                "hotel"
            ]
        },
        {
            "no": 946,
            "code": "1F6AA",
            "flagged": false,
            "keywords": [
                "door"
            ]
        },
        {
            "no": 947,
            "code": "1F6CC",
            "flagged": false,
            "keywords": [
                "hotel",
                "sleep"
            ]
        },
        {
            "no": 948,
            "code": "1F6CF",
            "flagged": false,
            "keywords": [
                "bed",
                "hotel",
                "sleep"
            ]
        },
        {
            "no": 949,
            "code": "1F6CB",
            "flagged": false,
            "keywords": [
                "couch",
                "hotel",
                "lamp"
            ]
        },
        {
            "no": 950,
            "code": "1F6BD",
            "flagged": false,
            "keywords": [
                "toilet"
            ]
        },
        {
            "no": 951,
            "code": "1F6BF",
            "flagged": false,
            "keywords": [
                "shower",
                "water"
            ]
        },
        {
            "no": 952,
            "code": "1F6C0",
            "flagged": false,
            "keywords": [
                "bath",
                "bathtub"
            ],
            "types": [
                "1F6C0-1F3FF",
                "1F6C0-1F3FE",
                "1F6C0-1F3FD",
                "1F6C0-1F3FC",
                "1F6C0-1F3FB"
            ]
        },
        {
            "no": 958,
            "code": "1F6C1",
            "flagged": false,
            "keywords": [
                "bath",
                "bathtub"
            ]
        },
        {
            "no": 959,
            "code": "231B",
            "flagged": false,
            "keywords": [
                "hourglass",
                "sand",
                "timer"
            ]
        },
        {
            "no": 960,
            "code": "23F3",
            "flagged": false,
            "keywords": [
                "hourglass",
                "sand",
                "timer"
            ]
        },
        {
            "no": 961,
            "code": "231A",
            "flagged": false,
            "keywords": [
                "clock",
                "watch"
            ]
        },
        {
            "no": 962,
            "code": "23F0",
            "flagged": false,
            "keywords": [
                "alarm",
                "clock"
            ]
        },
        {
            "no": 963,
            "code": "23F1",
            "flagged": false,
            "keywords": [
                "clock",
                "stopwatch"
            ]
        },
        {
            "no": 964,
            "code": "23F2",
            "flagged": false,
            "keywords": [
                "clock",
                "timer"
            ]
        },
        {
            "no": 965,
            "code": "1F570",
            "flagged": false,
            "keywords": [
                "clock"
            ]
        },
        {
            "no": 966,
            "code": "1F55B",
            "flagged": false,
            "keywords": [
                "00",
                "12",
                "12:00",
                "clock",
                "o’clock",
                "twelve"
            ]
        },
        {
            "no": 967,
            "code": "1F567",
            "flagged": false,
            "keywords": [
                "12",
                "12:30",
                "30",
                "clock",
                "thirty",
                "twelve"
            ]
        },
        {
            "no": 968,
            "code": "1F550",
            "flagged": false,
            "keywords": [
                "00",
                "1",
                "1:00",
                "clock",
                "o’clock",
                "one"
            ]
        },
        {
            "no": 969,
            "code": "1F55C",
            "flagged": false,
            "keywords": [
                "1",
                "1:30",
                "30",
                "clock",
                "one",
                "thirty"
            ]
        },
        {
            "no": 970,
            "code": "1F551",
            "flagged": false,
            "keywords": [
                "00",
                "2",
                "2:00",
                "clock",
                "o’clock",
                "two"
            ]
        },
        {
            "no": 971,
            "code": "1F55D",
            "flagged": false,
            "keywords": [
                "2",
                "2:30",
                "30",
                "clock",
                "thirty",
                "two"
            ]
        },
        {
            "no": 972,
            "code": "1F552",
            "flagged": false,
            "keywords": [
                "00",
                "3",
                "3:00",
                "clock",
                "o’clock",
                "three"
            ]
        },
        {
            "no": 973,
            "code": "1F55E",
            "flagged": false,
            "keywords": [
                "3",
                "3:30",
                "30",
                "clock",
                "thirty",
                "three"
            ]
        },
        {
            "no": 974,
            "code": "1F553",
            "flagged": false,
            "keywords": [
                "00",
                "4",
                "4:00",
                "clock",
                "four",
                "o’clock"
            ]
        },
        {
            "no": 975,
            "code": "1F55F",
            "flagged": false,
            "keywords": [
                "30",
                "4",
                "4:30",
                "clock",
                "four",
                "thirty"
            ]
        },
        {
            "no": 976,
            "code": "1F554",
            "flagged": false,
            "keywords": [
                "00",
                "5",
                "5:00",
                "clock",
                "five",
                "o’clock"
            ]
        },
        {
            "no": 977,
            "code": "1F560",
            "flagged": false,
            "keywords": [
                "30",
                "5",
                "5:30",
                "clock",
                "five",
                "thirty"
            ]
        },
        {
            "no": 978,
            "code": "1F555",
            "flagged": false,
            "keywords": [
                "00",
                "6",
                "6:00",
                "clock",
                "o’clock",
                "six"
            ]
        },
        {
            "no": 979,
            "code": "1F561",
            "flagged": false,
            "keywords": [
                "30",
                "6",
                "6:30",
                "clock",
                "six",
                "thirty"
            ]
        },
        {
            "no": 980,
            "code": "1F556",
            "flagged": false,
            "keywords": [
                "00",
                "7",
                "7:00",
                "clock",
                "o’clock",
                "seven"
            ]
        },
        {
            "no": 981,
            "code": "1F562",
            "flagged": false,
            "keywords": [
                "30",
                "7",
                "7:30",
                "clock",
                "seven",
                "thirty"
            ]
        },
        {
            "no": 982,
            "code": "1F557",
            "flagged": false,
            "keywords": [
                "00",
                "8",
                "8:00",
                "clock",
                "eight",
                "o’clock"
            ]
        },
        {
            "no": 983,
            "code": "1F563",
            "flagged": false,
            "keywords": [
                "30",
                "8",
                "8:30",
                "clock",
                "eight",
                "thirty"
            ]
        },
        {
            "no": 984,
            "code": "1F558",
            "flagged": false,
            "keywords": [
                "00",
                "9",
                "9:00",
                "clock",
                "nine",
                "o’clock"
            ]
        },
        {
            "no": 985,
            "code": "1F564",
            "flagged": false,
            "keywords": [
                "30",
                "9",
                "9:30",
                "clock",
                "nine",
                "thirty"
            ]
        },
        {
            "no": 986,
            "code": "1F559",
            "flagged": false,
            "keywords": [
                "00",
                "10",
                "10:00",
                "clock",
                "o’clock",
                "ten"
            ]
        },
        {
            "no": 987,
            "code": "1F565",
            "flagged": false,
            "keywords": [
                "10",
                "10:30",
                "30",
                "clock",
                "ten",
                "thirty"
            ]
        },
        {
            "no": 988,
            "code": "1F55A",
            "flagged": false,
            "keywords": [
                "00",
                "11",
                "11:00",
                "clock",
                "eleven",
                "o’clock"
            ]
        },
        {
            "no": 989,
            "code": "1F566",
            "flagged": false,
            "keywords": [
                "11",
                "11:30",
                "30",
                "clock",
                "eleven",
                "thirty"
            ]
        },
        {
            "no": 990,
            "code": "1F311",
            "flagged": false,
            "keywords": [
                "dark",
                "moon",
                "space",
                "weather"
            ]
        },
        {
            "no": 991,
            "code": "1F312",
            "flagged": false,
            "keywords": [
                "crescent",
                "moon",
                "space",
                "waxing",
                "weather"
            ]
        },
        {
            "no": 992,
            "code": "1F313",
            "flagged": false,
            "keywords": [
                "moon",
                "quarter",
                "space",
                "weather"
            ]
        },
        {
            "no": 993,
            "code": "1F314",
            "flagged": false,
            "keywords": [
                "gibbous",
                "moon",
                "space",
                "waxing",
                "weather"
            ]
        },
        {
            "no": 994,
            "code": "1F315",
            "flagged": false,
            "keywords": [
                "full",
                "moon",
                "space",
                "weather"
            ]
        },
        {
            "no": 995,
            "code": "1F316",
            "flagged": false,
            "keywords": [
                "gibbous",
                "moon",
                "space",
                "waning",
                "weather"
            ]
        },
        {
            "no": 996,
            "code": "1F317",
            "flagged": false,
            "keywords": [
                "moon",
                "quarter",
                "space",
                "weather"
            ]
        },
        {
            "no": 997,
            "code": "1F318",
            "flagged": false,
            "keywords": [
                "crescent",
                "moon",
                "space",
                "waning",
                "weather"
            ]
        },
        {
            "no": 998,
            "code": "1F319",
            "flagged": false,
            "keywords": [
                "crescent",
                "moon",
                "space",
                "weather"
            ]
        },
        {
            "no": 999,
            "code": "1F31A",
            "flagged": false,
            "keywords": [
                "face",
                "moon",
                "space",
                "weather"
            ]
        },
        {
            "no": 1000,
            "code": "1F31B",
            "flagged": false,
            "keywords": [
                "face",
                "moon",
                "quarter",
                "space",
                "weather"
            ]
        },
        {
            "no": 1001,
            "code": "1F31C",
            "flagged": false,
            "keywords": [
                "face",
                "moon",
                "quarter",
                "space",
                "weather"
            ]
        },
        {
            "no": 1002,
            "code": "1F321",
            "flagged": false,
            "keywords": [
                "thermometer",
                "weather"
            ]
        },
        {
            "no": 1003,
            "code": "2600",
            "flagged": false,
            "keywords": [
                "bright",
                "rays",
                "space",
                "sun",
                "sunny",
                "weather"
            ]
        },
        {
            "no": 1004,
            "code": "1F31D",
            "flagged": false,
            "keywords": [
                "bright",
                "face",
                "full",
                "moon",
                "space",
                "weather"
            ]
        },
        {
            "no": 1005,
            "code": "1F31E",
            "flagged": false,
            "keywords": [
                "bright",
                "face",
                "space",
                "sun",
                "weather"
            ]
        },
        {
            "no": 1006,
            "code": "2B50",
            "flagged": false,
            "keywords": [
                "star"
            ]
        },
        {
            "no": 1007,
            "code": "1F31F",
            "flagged": false,
            "keywords": [
                "glittery",
                "glow",
                "shining",
                "sparkle",
                "star"
            ]
        },
        {
            "no": 1008,
            "code": "1F320",
            "flagged": false,
            "keywords": [
                "activity",
                "falling",
                "shooting",
                "space",
                "star"
            ]
        },
        {
            "no": 1009,
            "code": "2601",
            "flagged": false,
            "keywords": [
                "cloud",
                "weather"
            ]
        },
        {
            "no": 1010,
            "code": "26C5",
            "flagged": false,
            "keywords": [
                "cloud",
                "sun",
                "weather"
            ]
        },
        {
            "no": 1011,
            "code": "26C8",
            "flagged": false,
            "keywords": [
                "cloud",
                "rain",
                "thunder",
                "weather"
            ]
        },
        {
            "no": 1012,
            "code": "1F324",
            "flagged": false,
            "keywords": [
                "cloud",
                "sun",
                "weather"
            ]
        },
        {
            "no": 1013,
            "code": "1F325",
            "flagged": false,
            "keywords": [
                "cloud",
                "sun",
                "weather"
            ]
        },
        {
            "no": 1014,
            "code": "1F326",
            "flagged": false,
            "keywords": [
                "cloud",
                "rain",
                "sun",
                "weather"
            ]
        },
        {
            "no": 1015,
            "code": "1F327",
            "flagged": false,
            "keywords": [
                "cloud",
                "rain",
                "weather"
            ]
        },
        {
            "no": 1016,
            "code": "1F328",
            "flagged": false,
            "keywords": [
                "cloud",
                "cold",
                "snow",
                "weather"
            ]
        },
        {
            "no": 1017,
            "code": "1F329",
            "flagged": false,
            "keywords": [
                "cloud",
                "lightning",
                "weather"
            ]
        },
        {
            "no": 1018,
            "code": "1F32A",
            "flagged": false,
            "keywords": [
                "cloud",
                "tornado",
                "weather",
                "whirlwind"
            ]
        },
        {
            "no": 1019,
            "code": "1F32B",
            "flagged": false,
            "keywords": [
                "cloud",
                "fog",
                "weather"
            ]
        },
        {
            "no": 1020,
            "code": "1F32C",
            "flagged": false,
            "keywords": [
                "blow",
                "cloud",
                "face",
                "weather",
                "wind"
            ]
        },
        {
            "no": 1021,
            "code": "1F300",
            "flagged": false,
            "keywords": [
                "cyclone",
                "dizzy",
                "twister",
                "typhoon",
                "weather"
            ]
        },
        {
            "no": 1022,
            "code": "1F308",
            "flagged": false,
            "keywords": [
                "rain",
                "rainbow",
                "weather"
            ]
        },
        {
            "no": 1023,
            "code": "1F302",
            "flagged": false,
            "keywords": [
                "clothing",
                "rain",
                "umbrella",
                "weather"
            ]
        },
        {
            "no": 1024,
            "code": "2602",
            "flagged": false,
            "keywords": [
                "clothing",
                "rain",
                "umbrella",
                "weather"
            ]
        },
        {
            "no": 1025,
            "code": "2614",
            "flagged": false,
            "keywords": [
                "clothing",
                "drop",
                "rain",
                "umbrella",
                "weather"
            ]
        },
        {
            "no": 1026,
            "code": "26F1",
            "flagged": false,
            "keywords": [
                "rain",
                "sun",
                "umbrella",
                "weather"
            ]
        },
        {
            "no": 1027,
            "code": "26A1",
            "flagged": false,
            "keywords": [
                "danger",
                "electric",
                "electricity",
                "lightning",
                "voltage",
                "zap"
            ]
        },
        {
            "no": 1028,
            "code": "2744",
            "flagged": false,
            "keywords": [
                "cold",
                "snow",
                "snowflake",
                "weather"
            ]
        },
        {
            "no": 1029,
            "code": "2603",
            "flagged": false,
            "keywords": [
                "cold",
                "snow",
                "snowman",
                "weather"
            ]
        },
        {
            "no": 1030,
            "code": "26C4",
            "flagged": false,
            "keywords": [
                "cold",
                "snow",
                "snowman",
                "weather"
            ]
        },
        {
            "no": 1031,
            "code": "2604",
            "flagged": false,
            "keywords": [
                "comet",
                "space"
            ]
        },
        {
            "no": 1032,
            "code": "1F525",
            "flagged": false,
            "keywords": [
                "fire",
                "flame",
                "tool"
            ]
        },
        {
            "no": 1033,
            "code": "1F4A7",
            "flagged": false,
            "keywords": [
                "cold",
                "comic",
                "drop",
                "sweat",
                "weather"
            ]
        },
        {
            "no": 1034,
            "code": "1F30A",
            "flagged": false,
            "keywords": [
                "ocean",
                "water",
                "wave",
                "weather"
            ]
        }
    ],
    ACTIVITIES: [
        {
            "no": 1035,
            "code": "1F383",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "entertainment",
                "halloween",
                "jack",
                "lantern"
            ]
        },
        {
            "no": 1036,
            "code": "1F384",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "christmas",
                "entertainment",
                "tree"
            ]
        },
        {
            "no": 1037,
            "code": "1F386",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "entertainment",
                "fireworks"
            ]
        },
        {
            "no": 1038,
            "code": "1F387",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "entertainment",
                "fireworks",
                "sparkle"
            ]
        },
        {
            "no": 1039,
            "code": "2728",
            "flagged": false,
            "keywords": [
                "entertainment",
                "sparkle",
                "star"
            ]
        },
        {
            "no": 1040,
            "code": "1F388",
            "flagged": false,
            "keywords": [
                "activity",
                "balloon",
                "celebration",
                "entertainment"
            ]
        },
        {
            "no": 1041,
            "code": "1F389",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "entertainment",
                "party",
                "popper",
                "tada"
            ]
        },
        {
            "no": 1042,
            "code": "1F38A",
            "flagged": false,
            "keywords": [
                "activity",
                "ball",
                "celebration",
                "confetti",
                "entertainment"
            ]
        },
        {
            "no": 1043,
            "code": "1F38B",
            "flagged": false,
            "keywords": [
                "activity",
                "banner",
                "celebration",
                "entertainment",
                "japanese",
                "tree"
            ]
        },
        {
            "no": 1044,
            "code": "1F38D",
            "flagged": false,
            "keywords": [
                "activity",
                "bamboo",
                "celebration",
                "japanese",
                "pine",
                "plant"
            ]
        },
        {
            "no": 1045,
            "code": "1F38E",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "doll",
                "entertainment",
                "festival",
                "japanese"
            ]
        },
        {
            "no": 1046,
            "code": "1F38F",
            "flagged": false,
            "keywords": [
                "activity",
                "carp",
                "celebration",
                "entertainment",
                "flag",
                "streamer"
            ]
        },
        {
            "no": 1047,
            "code": "1F390",
            "flagged": false,
            "keywords": [
                "activity",
                "bell",
                "celebration",
                "chime",
                "entertainment",
                "wind"
            ]
        },
        {
            "no": 1048,
            "code": "1F391",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "ceremony",
                "entertainment",
                "moon"
            ]
        },
        {
            "no": 1049,
            "code": "1F380",
            "flagged": false,
            "keywords": [
                "celebration",
                "ribbon"
            ]
        },
        {
            "no": 1050,
            "code": "1F381",
            "flagged": false,
            "keywords": [
                "box",
                "celebration",
                "entertainment",
                "gift",
                "present",
                "wrapped"
            ]
        },
        {
            "no": 1051,
            "code": "1F397",
            "flagged": false,
            "keywords": [
                "celebration",
                "reminder",
                "ribbon"
            ]
        },
        {
            "no": 1052,
            "code": "1F39F",
            "flagged": false,
            "keywords": [
                "admission",
                "entertainment",
                "ticket"
            ]
        },
        {
            "no": 1053,
            "code": "1F3AB",
            "flagged": false,
            "keywords": [
                "activity",
                "admission",
                "entertainment",
                "ticket"
            ]
        },
        {
            "no": 1054,
            "code": "1F396",
            "flagged": false,
            "keywords": [
                "celebration",
                "medal",
                "military"
            ]
        },
        {
            "no": 1055,
            "code": "1F3C6",
            "flagged": false,
            "keywords": [
                "prize",
                "trophy"
            ]
        },
        {
            "no": 1056,
            "code": "1F3C5",
            "flagged": false,
            "keywords": [
                "medal"
            ]
        },
        {
            "no": 1057,
            "code": "1F947",
            "flagged": true,
            "keywords": [
                "first",
                "gold",
                "medal"
            ]
        },
        {
            "no": 1058,
            "code": "1F948",
            "flagged": true,
            "keywords": [
                "medal",
                "second",
                "silver"
            ]
        },
        {
            "no": 1059,
            "code": "1F949",
            "flagged": true,
            "keywords": [
                "bronze",
                "medal",
                "third"
            ]
        },
        {
            "no": 1060,
            "code": "26BD",
            "flagged": false,
            "keywords": [
                "ball",
                "soccer"
            ]
        },
        {
            "no": 1061,
            "code": "26BE",
            "flagged": false,
            "keywords": [
                "ball",
                "baseball"
            ]
        },
        {
            "no": 1062,
            "code": "1F3C0",
            "flagged": false,
            "keywords": [
                "ball",
                "basketball",
                "hoop"
            ]
        },
        {
            "no": 1063,
            "code": "1F3D0",
            "flagged": false,
            "keywords": [
                "ball",
                "game",
                "volleyball"
            ]
        },
        {
            "no": 1064,
            "code": "1F3C8",
            "flagged": false,
            "keywords": [
                "american",
                "ball",
                "football"
            ]
        },
        {
            "no": 1065,
            "code": "1F3C9",
            "flagged": false,
            "keywords": [
                "ball",
                "football",
                "rugby"
            ]
        },
        {
            "no": 1066,
            "code": "1F3BE",
            "flagged": false,
            "keywords": [
                "ball",
                "racquet",
                "tennis"
            ]
        },
        {
            "no": 1067,
            "code": "1F3B1",
            "flagged": false,
            "keywords": [
                "8",
                "8 ball",
                "ball",
                "billiard",
                "eight",
                "game"
            ]
        },
        {
            "no": 1068,
            "code": "1F3B3",
            "flagged": false,
            "keywords": [
                "ball",
                "bowling",
                "game"
            ]
        },
        {
            "no": 1069,
            "code": "1F3CF",
            "flagged": false,
            "keywords": [
                "ball",
                "bat",
                "cricket",
                "game"
            ]
        },
        {
            "no": 1070,
            "code": "1F3D1",
            "flagged": false,
            "keywords": [
                "ball",
                "field",
                "game",
                "hockey",
                "stick"
            ]
        },
        {
            "no": 1071,
            "code": "1F3D2",
            "flagged": false,
            "keywords": [
                "game",
                "hockey",
                "ice",
                "puck",
                "stick"
            ]
        },
        {
            "no": 1072,
            "code": "1F3D3",
            "flagged": false,
            "keywords": [
                "ball",
                "bat",
                "game",
                "paddle",
                "table tennis"
            ]
        },
        {
            "no": 1073,
            "code": "1F3F8",
            "flagged": false,
            "keywords": [
                "badminton",
                "birdie",
                "game",
                "racquet",
                "shuttlecock"
            ]
        },
        {
            "no": 1074,
            "code": "1F94A",
            "flagged": true,
            "keywords": [
                "boxing",
                "glove"
            ]
        },
        {
            "no": 1075,
            "code": "1F94B",
            "flagged": true,
            "keywords": [
                "judo",
                "karate",
                "martial arts",
                "taekwondo",
                "uniform"
            ]
        },
        {
            "no": 1076,
            "code": "26F3",
            "flagged": false,
            "keywords": [
                "flag",
                "golf",
                "hole"
            ]
        },
        {
            "no": 1077,
            "code": "1F3CC",
            "flagged": false,
            "keywords": [
                "ball",
                "golf"
            ]
        },
        {
            "no": 1078,
            "code": "26F8",
            "flagged": false,
            "keywords": [
                "ice",
                "skate"
            ]
        },
        {
            "no": 1079,
            "code": "1F3A3",
            "flagged": false,
            "keywords": [
                "entertainment",
                "fish",
                "pole"
            ]
        },
        {
            "no": 1080,
            "code": "1F3BD",
            "flagged": false,
            "keywords": [
                "running",
                "sash",
                "shirt"
            ]
        },
        {
            "no": 1081,
            "code": "1F3BF",
            "flagged": false,
            "keywords": [
                "ski",
                "snow"
            ]
        },
        {
            "no": 1082,
            "code": "26F7",
            "flagged": false,
            "keywords": [
                "ski",
                "snow"
            ]
        },
        {
            "no": 1083,
            "code": "1F3C2",
            "flagged": false,
            "keywords": [
                "ski",
                "snow",
                "snowboard"
            ]
        },
        {
            "no": 1084,
            "code": "1F3C4",
            "flagged": false,
            "keywords": [
                "surfer",
                "surfing"
            ],
            "types": [
                "1F3C4-1F3FF",
                "1F3C4-1F3FE",
                "1F3C4-1F3FD",
                "1F3C4-1F3FC",
                "1F3C4-1F3FB"
            ]
        },
        {
            "no": 1090,
            "code": "1F3C7",
            "flagged": false,
            "keywords": [
                "horse",
                "jockey",
                "racehorse",
                "racing"
            ]
        },
        {
            "no": 1091,
            "code": "1F3CA",
            "flagged": false,
            "keywords": [
                "swim",
                "swimmer"
            ],
            "types": [
                "1F3CA-1F3FF",
                "1F3CA-1F3FE",
                "1F3CA-1F3FD",
                "1F3CA-1F3FC",
                "1F3CA-1F3FB"
            ]
        },
        {
            "no": 1097,
            "code": "26F9",
            "flagged": false,
            "keywords": [
                "ball"
            ],
            "types": [
                "26F9-1F3FF",
                "26F9-1F3FE",
                "26F9-1F3FD",
                "26F9-1F3FC",
                "26F9-1F3FB"
            ]
        },
        {
            "no": 1103,
            "code": "1F3CB",
            "flagged": false,
            "keywords": [
                "lifter",
                "weight"
            ],
            "types": [
                "1F3CB-1F3FF",
                "1F3CB-1F3FE",
                "1F3CB-1F3FD",
                "1F3CB-1F3FC",
                "1F3CB-1F3FB"
            ]
        },
        {
            "no": 1109,
            "code": "1F6B4",
            "flagged": false,
            "keywords": [
                "bicycle",
                "bicyclist",
                "bike",
                "cyclist"
            ],
            "types": [
                "1F6B4-1F3FF",
                "1F6B4-1F3FE",
                "1F6B4-1F3FD",
                "1F6B4-1F3FC",
                "1F6B4-1F3FB"
            ]
        },
        {
            "no": 1115,
            "code": "1F6B5",
            "flagged": false,
            "keywords": [
                "bicycle",
                "bicyclist",
                "bike",
                "cyclist",
                "mountain"
            ],
            "types": [
                "1F6B5-1F3FF",
                "1F6B5-1F3FE",
                "1F6B5-1F3FD",
                "1F6B5-1F3FC",
                "1F6B5-1F3FB"
            ]
        },
        {
            "no": 1121,
            "code": "1F3CE",
            "flagged": false,
            "keywords": [
                "car",
                "racing"
            ]
        },
        {
            "no": 1122,
            "code": "1F3CD",
            "flagged": false,
            "keywords": [
                "motorcycle",
                "racing"
            ]
        },
        {
            "no": 1123,
            "code": "1F938",
            "flagged": true,
            "keywords": [
                "cartwheel",
                "gymnastics"
            ],
            "types": [
                "1F938-1F3FF",
                "1F938-1F3FE",
                "1F938-1F3FD",
                "1F938-1F3FC",
                "1F938-1F3FB"
            ]
        },
        {
            "no": 1129,
            "code": "1F93C",
            "flagged": true,
            "keywords": [
                "wrestle",
                "wrestler"
            ],
            "types": [
                "1F93C-1F3FF",
                "1F93C-1F3FE",
                "1F93C-1F3FD",
                "1F93C-1F3FC",
                "1F93C-1F3FB"
            ]
        },
        {
            "no": 1135,
            "code": "1F93D",
            "flagged": true,
            "keywords": [
                "polo",
                "water"
            ],
            "types": [
                "1F93D-1F3FF",
                "1F93D-1F3FE",
                "1F93D-1F3FD",
                "1F93D-1F3FC",
                "1F93D-1F3FB"
            ]
        },
        {
            "no": 1141,
            "code": "1F93E",
            "flagged": true,
            "keywords": [
                "ball",
                "handball"
            ],
            "types": [
                "1F93E-1F3FF",
                "1F93E-1F3FE",
                "1F93E-1F3FD",
                "1F93E-1F3FC",
                "1F93E-1F3FB"
            ]
        },
        {
            "no": 1147,
            "code": "1F93A",
            "flagged": true,
            "keywords": [
                "fencer",
                "fencing",
                "sword"
            ]
        },
        {
            "no": 1148,
            "code": "1F945",
            "flagged": true,
            "keywords": [
                "goal",
                "net"
            ]
        },
        {
            "no": 1149,
            "code": "1F939",
            "flagged": true,
            "keywords": [
                "balance",
                "juggle",
                "multitask",
                "skill"
            ],
            "types": [
                "1F939-1F3FF",
                "1F939-1F3FE",
                "1F939-1F3FD",
                "1F939-1F3FC",
                "1F939-1F3FB"
            ]
        },
        {
            "no": 1155,
            "code": "1F3AF",
            "flagged": false,
            "keywords": [
                "activity",
                "bull",
                "bullseye",
                "dart",
                "entertainment",
                "eye",
                "game",
                "hit",
                "target"
            ]
        },
        {
            "no": 1156,
            "code": "1F3AE",
            "flagged": false,
            "keywords": [
                "controller",
                "entertainment",
                "game",
                "video game"
            ]
        },
        {
            "no": 1157,
            "code": "1F579",
            "flagged": false,
            "keywords": [
                "entertainment",
                "game",
                "joystick",
                "video game"
            ]
        },
        {
            "no": 1158,
            "code": "1F3B2",
            "flagged": false,
            "keywords": [
                "dice",
                "die",
                "entertainment",
                "game"
            ]
        },
        {
            "no": 1159,
            "code": "2660",
            "flagged": false,
            "keywords": [
                "card",
                "game",
                "spade",
                "suit"
            ]
        },
        {
            "no": 1160,
            "code": "2665",
            "flagged": false,
            "keywords": [
                "card",
                "game",
                "heart",
                "hearts",
                "suit"
            ]
        },
        {
            "no": 1161,
            "code": "2666",
            "flagged": false,
            "keywords": [
                "card",
                "diamond",
                "diamonds",
                "game",
                "suit"
            ]
        },
        {
            "no": 1162,
            "code": "2663",
            "flagged": false,
            "keywords": [
                "card",
                "club",
                "clubs",
                "game",
                "suit"
            ]
        },
        {
            "no": 1163,
            "code": "1F0CF",
            "flagged": false,
            "keywords": [
                "card",
                "entertainment",
                "game",
                "joker",
                "playing"
            ]
        },
        {
            "no": 1164,
            "code": "1F004",
            "flagged": false,
            "keywords": [
                "game",
                "mahjong",
                "red"
            ]
        },
        {
            "no": 1165,
            "code": "1F3B4",
            "flagged": false,
            "keywords": [
                "activity",
                "card",
                "entertainment",
                "flower",
                "game",
                "japanese",
                "playing"
            ]
        }
    ],
    OBJECTS: [
        {
            "no": 1166,
            "code": "1F507",
            "flagged": false,
            "keywords": [
                "mute",
                "quiet",
                "silent",
                "speaker",
                "volume"
            ]
        },
        {
            "no": 1167,
            "code": "1F508",
            "flagged": false,
            "keywords": [
                "speaker",
                "volume"
            ]
        },
        {
            "no": 1168,
            "code": "1F509",
            "flagged": false,
            "keywords": [
                "low",
                "speaker",
                "volume",
                "wave"
            ]
        },
        {
            "no": 1169,
            "code": "1F50A",
            "flagged": false,
            "keywords": [
                "3",
                "entertainment",
                "high",
                "loud",
                "speaker",
                "three",
                "volume"
            ]
        },
        {
            "no": 1170,
            "code": "1F4E2",
            "flagged": false,
            "keywords": [
                "communication",
                "loud",
                "loudspeaker",
                "public address"
            ]
        },
        {
            "no": 1171,
            "code": "1F4E3",
            "flagged": false,
            "keywords": [
                "cheering",
                "communication",
                "megaphone"
            ]
        },
        {
            "no": 1172,
            "code": "1F4EF",
            "flagged": false,
            "keywords": [
                "communication",
                "entertainment",
                "horn",
                "post",
                "postal"
            ]
        },
        {
            "no": 1173,
            "code": "1F514",
            "flagged": false,
            "keywords": [
                "bell"
            ]
        },
        {
            "no": 1174,
            "code": "1F515",
            "flagged": false,
            "keywords": [
                "bell",
                "forbidden",
                "mute",
                "no",
                "not",
                "prohibited",
                "quiet",
                "silent"
            ]
        },
        {
            "no": 1175,
            "code": "1F3BC",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "music",
                "score"
            ]
        },
        {
            "no": 1176,
            "code": "1F3B5",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "music",
                "note"
            ]
        },
        {
            "no": 1177,
            "code": "1F3B6",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "music",
                "note",
                "notes"
            ]
        },
        {
            "no": 1178,
            "code": "1F399",
            "flagged": false,
            "keywords": [
                "mic",
                "microphone",
                "music",
                "studio"
            ]
        },
        {
            "no": 1179,
            "code": "1F39A",
            "flagged": false,
            "keywords": [
                "level",
                "music",
                "slider"
            ]
        },
        {
            "no": 1180,
            "code": "1F39B",
            "flagged": false,
            "keywords": [
                "control",
                "knobs",
                "music"
            ]
        },
        {
            "no": 1181,
            "code": "1F3A4",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "karaoke",
                "mic",
                "microphone"
            ]
        },
        {
            "no": 1182,
            "code": "1F3A7",
            "flagged": false,
            "keywords": [
                "activity",
                "earbud",
                "entertainment",
                "headphone"
            ]
        },
        {
            "no": 1183,
            "code": "1F4FB",
            "flagged": false,
            "keywords": [
                "entertainment",
                "radio",
                "video"
            ]
        },
        {
            "no": 1184,
            "code": "1F3B7",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "instrument",
                "music",
                "sax",
                "saxophone"
            ]
        },
        {
            "no": 1185,
            "code": "1F3B8",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "guitar",
                "instrument",
                "music"
            ]
        },
        {
            "no": 1186,
            "code": "1F3B9",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "instrument",
                "keyboard",
                "music",
                "piano"
            ]
        },
        {
            "no": 1187,
            "code": "1F3BA",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "instrument",
                "music",
                "trumpet"
            ]
        },
        {
            "no": 1188,
            "code": "1F3BB",
            "flagged": false,
            "keywords": [
                "activity",
                "entertainment",
                "instrument",
                "music",
                "violin"
            ]
        },
        {
            "no": 1189,
            "code": "1F941",
            "flagged": true,
            "keywords": [
                "drum",
                "drumsticks",
                "music"
            ]
        },
        {
            "no": 1190,
            "code": "1F4F1",
            "flagged": false,
            "keywords": [
                "cell",
                "communication",
                "mobile",
                "phone",
                "telephone"
            ]
        },
        {
            "no": 1191,
            "code": "1F4F2",
            "flagged": false,
            "keywords": [
                "arrow",
                "call",
                "cell",
                "communication",
                "mobile",
                "phone",
                "receive",
                "telephone"
            ]
        },
        {
            "no": 1192,
            "code": "260E",
            "flagged": false,
            "keywords": [
                "phone",
                "telephone"
            ]
        },
        {
            "no": 1193,
            "code": "1F4DE",
            "flagged": false,
            "keywords": [
                "communication",
                "phone",
                "receiver",
                "telephone"
            ]
        },
        {
            "no": 1194,
            "code": "1F4DF",
            "flagged": false,
            "keywords": [
                "communication",
                "pager"
            ]
        },
        {
            "no": 1195,
            "code": "1F4E0",
            "flagged": false,
            "keywords": [
                "communication",
                "fax"
            ]
        },
        {
            "no": 1196,
            "code": "1F50B",
            "flagged": false,
            "keywords": [
                "battery"
            ]
        },
        {
            "no": 1197,
            "code": "1F50C",
            "flagged": false,
            "keywords": [
                "electric",
                "electricity",
                "plug"
            ]
        },
        {
            "no": 1198,
            "code": "1F4BB",
            "flagged": false,
            "keywords": [
                "computer",
                "pc",
                "personal"
            ]
        },
        {
            "no": 1199,
            "code": "1F5A5",
            "flagged": false,
            "keywords": [
                "computer",
                "desktop"
            ]
        },
        {
            "no": 1200,
            "code": "1F5A8",
            "flagged": false,
            "keywords": [
                "computer",
                "printer"
            ]
        },
        {
            "no": 1201,
            "code": "2328",
            "flagged": false,
            "keywords": [
                "computer",
                "keyboard"
            ]
        },
        {
            "no": 1202,
            "code": "1F5B1",
            "flagged": false,
            "keywords": [
                "3",
                "button",
                "computer",
                "mouse",
                "three"
            ]
        },
        {
            "no": 1203,
            "code": "1F5B2",
            "flagged": false,
            "keywords": [
                "computer",
                "trackball"
            ]
        },
        {
            "no": 1204,
            "code": "1F4BD",
            "flagged": false,
            "keywords": [
                "computer",
                "disk",
                "entertainment",
                "minidisk",
                "optical"
            ]
        },
        {
            "no": 1205,
            "code": "1F4BE",
            "flagged": false,
            "keywords": [
                "computer",
                "disk",
                "floppy"
            ]
        },
        {
            "no": 1206,
            "code": "1F4BF",
            "flagged": false,
            "keywords": [
                "blu-ray",
                "cd",
                "computer",
                "disk",
                "dvd",
                "optical"
            ]
        },
        {
            "no": 1207,
            "code": "1F4C0",
            "flagged": false,
            "keywords": [
                "blu-ray",
                "cd",
                "computer",
                "disk",
                "dvd",
                "entertainment",
                "optical"
            ]
        },
        {
            "no": 1208,
            "code": "1F3A5",
            "flagged": false,
            "keywords": [
                "activity",
                "camera",
                "cinema",
                "entertainment",
                "movie"
            ]
        },
        {
            "no": 1209,
            "code": "1F39E",
            "flagged": false,
            "keywords": [
                "cinema",
                "entertainment",
                "film",
                "frames",
                "movie"
            ]
        },
        {
            "no": 1210,
            "code": "1F4FD",
            "flagged": false,
            "keywords": [
                "cinema",
                "entertainment",
                "film",
                "movie",
                "projector",
                "video"
            ]
        },
        {
            "no": 1211,
            "code": "1F3AC",
            "flagged": false,
            "keywords": [
                "activity",
                "clapper",
                "entertainment",
                "movie"
            ]
        },
        {
            "no": 1212,
            "code": "1F4FA",
            "flagged": false,
            "keywords": [
                "entertainment",
                "television",
                "tv",
                "video"
            ]
        },
        {
            "no": 1213,
            "code": "1F4F7",
            "flagged": false,
            "keywords": [
                "camera",
                "entertainment",
                "video"
            ]
        },
        {
            "no": 1214,
            "code": "1F4F8",
            "flagged": false,
            "keywords": [
                "camera",
                "flash",
                "video"
            ]
        },
        {
            "no": 1215,
            "code": "1F4F9",
            "flagged": false,
            "keywords": [
                "camera",
                "entertainment",
                "video"
            ]
        },
        {
            "no": 1216,
            "code": "1F4FC",
            "flagged": false,
            "keywords": [
                "entertainment",
                "tape",
                "vhs",
                "video",
                "videocassette"
            ]
        },
        {
            "no": 1217,
            "code": "1F50D",
            "flagged": false,
            "keywords": [
                "glass",
                "magnifying",
                "search",
                "tool"
            ]
        },
        {
            "no": 1218,
            "code": "1F50E",
            "flagged": false,
            "keywords": [
                "glass",
                "magnifying",
                "search",
                "tool"
            ]
        },
        {
            "no": 1219,
            "code": "1F52C",
            "flagged": false,
            "keywords": [
                "microscope",
                "tool"
            ]
        },
        {
            "no": 1220,
            "code": "1F52D",
            "flagged": false,
            "keywords": [
                "telescope",
                "tool"
            ]
        },
        {
            "no": 1221,
            "code": "1F4E1",
            "flagged": false,
            "keywords": [
                "antenna",
                "communication",
                "dish",
                "satellite"
            ]
        },
        {
            "no": 1222,
            "code": "1F56F",
            "flagged": false,
            "keywords": [
                "candle",
                "light"
            ]
        },
        {
            "no": 1223,
            "code": "1F4A1",
            "flagged": false,
            "keywords": [
                "bulb",
                "comic",
                "electric",
                "idea",
                "light"
            ]
        },
        {
            "no": 1224,
            "code": "1F526",
            "flagged": false,
            "keywords": [
                "electric",
                "flashlight",
                "light",
                "tool",
                "torch"
            ]
        },
        {
            "no": 1225,
            "code": "1F3EE",
            "flagged": false,
            "keywords": [
                "bar",
                "japanese",
                "lantern",
                "light",
                "red"
            ]
        },
        {
            "no": 1226,
            "code": "1F4D4",
            "flagged": false,
            "keywords": [
                "book",
                "cover",
                "decorated",
                "notebook"
            ]
        },
        {
            "no": 1227,
            "code": "1F4D5",
            "flagged": false,
            "keywords": [
                "book",
                "closed"
            ]
        },
        {
            "no": 1228,
            "code": "1F4D6",
            "flagged": false,
            "keywords": [
                "book",
                "open"
            ]
        },
        {
            "no": 1229,
            "code": "1F4D7",
            "flagged": false,
            "keywords": [
                "book",
                "green"
            ]
        },
        {
            "no": 1230,
            "code": "1F4D8",
            "flagged": false,
            "keywords": [
                "blue",
                "book"
            ]
        },
        {
            "no": 1231,
            "code": "1F4D9",
            "flagged": false,
            "keywords": [
                "book",
                "orange"
            ]
        },
        {
            "no": 1232,
            "code": "1F4DA",
            "flagged": false,
            "keywords": [
                "book",
                "books"
            ]
        },
        {
            "no": 1233,
            "code": "1F4D3",
            "flagged": false,
            "keywords": [
                "notebook"
            ]
        },
        {
            "no": 1234,
            "code": "1F4D2",
            "flagged": false,
            "keywords": [
                "ledger",
                "notebook"
            ]
        },
        {
            "no": 1235,
            "code": "1F4C3",
            "flagged": false,
            "keywords": [
                "curl",
                "document",
                "page"
            ]
        },
        {
            "no": 1236,
            "code": "1F4DC",
            "flagged": false,
            "keywords": [
                "paper",
                "scroll"
            ]
        },
        {
            "no": 1237,
            "code": "1F4C4",
            "flagged": false,
            "keywords": [
                "document",
                "page"
            ]
        },
        {
            "no": 1238,
            "code": "1F4F0",
            "flagged": false,
            "keywords": [
                "communication",
                "news",
                "newspaper",
                "paper"
            ]
        },
        {
            "no": 1239,
            "code": "1F5DE",
            "flagged": false,
            "keywords": [
                "news",
                "newspaper",
                "paper",
                "rolled"
            ]
        },
        {
            "no": 1240,
            "code": "1F4D1",
            "flagged": false,
            "keywords": [
                "bookmark",
                "mark",
                "marker",
                "tabs"
            ]
        },
        {
            "no": 1241,
            "code": "1F516",
            "flagged": false,
            "keywords": [
                "bookmark",
                "mark"
            ]
        },
        {
            "no": 1242,
            "code": "1F3F7",
            "flagged": false,
            "keywords": [
                "label"
            ]
        },
        {
            "no": 1243,
            "code": "1F4B0",
            "flagged": false,
            "keywords": [
                "bag",
                "dollar",
                "money",
                "moneybag"
            ]
        },
        {
            "no": 1244,
            "code": "1F4B4",
            "flagged": false,
            "keywords": [
                "bank",
                "banknote",
                "bill",
                "currency",
                "money",
                "note",
                "yen"
            ]
        },
        {
            "no": 1245,
            "code": "1F4B5",
            "flagged": false,
            "keywords": [
                "bank",
                "banknote",
                "bill",
                "currency",
                "dollar",
                "money",
                "note"
            ]
        },
        {
            "no": 1246,
            "code": "1F4B6",
            "flagged": false,
            "keywords": [
                "bank",
                "banknote",
                "bill",
                "currency",
                "euro",
                "money",
                "note"
            ]
        },
        {
            "no": 1247,
            "code": "1F4B7",
            "flagged": false,
            "keywords": [
                "bank",
                "banknote",
                "bill",
                "currency",
                "money",
                "note",
                "pound"
            ]
        },
        {
            "no": 1248,
            "code": "1F4B8",
            "flagged": false,
            "keywords": [
                "bank",
                "banknote",
                "bill",
                "dollar",
                "fly",
                "money",
                "note",
                "wings"
            ]
        },
        {
            "no": 1249,
            "code": "1F4B3",
            "flagged": false,
            "keywords": [
                "bank",
                "card",
                "credit",
                "money"
            ]
        },
        {
            "no": 1250,
            "code": "1F4B9",
            "flagged": false,
            "keywords": [
                "bank",
                "chart",
                "currency",
                "graph",
                "growth",
                "market",
                "money",
                "rise",
                "trend",
                "upward",
                "yen"
            ]
        },
        {
            "no": 1251,
            "code": "1F4B1",
            "flagged": false,
            "keywords": [
                "bank",
                "currency",
                "exchange",
                "money"
            ]
        },
        {
            "no": 1252,
            "code": "1F4B2",
            "flagged": false,
            "keywords": [
                "currency",
                "dollar",
                "money"
            ]
        },
        {
            "no": 1253,
            "code": "2709",
            "flagged": false,
            "keywords": [
                "e-mail",
                "email",
                "envelope"
            ]
        },
        {
            "no": 1254,
            "code": "1F4E7",
            "flagged": false,
            "keywords": [
                "communication",
                "e-mail",
                "email",
                "letter",
                "mail"
            ]
        },
        {
            "no": 1255,
            "code": "1F4E8",
            "flagged": false,
            "keywords": [
                "communication",
                "e-mail",
                "email",
                "envelope",
                "incoming",
                "letter",
                "mail",
                "receive"
            ]
        },
        {
            "no": 1256,
            "code": "1F4E9",
            "flagged": false,
            "keywords": [
                "arrow",
                "communication",
                "down",
                "e-mail",
                "email",
                "envelope",
                "letter",
                "mail",
                "outgoing",
                "sent"
            ]
        },
        {
            "no": 1257,
            "code": "1F4E4",
            "flagged": false,
            "keywords": [
                "box",
                "communication",
                "letter",
                "mail",
                "outbox",
                "sent",
                "tray"
            ]
        },
        {
            "no": 1258,
            "code": "1F4E5",
            "flagged": false,
            "keywords": [
                "box",
                "communication",
                "inbox",
                "letter",
                "mail",
                "receive",
                "tray"
            ]
        },
        {
            "no": 1259,
            "code": "1F4E6",
            "flagged": false,
            "keywords": [
                "box",
                "communication",
                "package",
                "parcel"
            ]
        },
        {
            "no": 1260,
            "code": "1F4EB",
            "flagged": false,
            "keywords": [
                "closed",
                "communication",
                "flag",
                "mail",
                "mailbox",
                "postbox"
            ]
        },
        {
            "no": 1261,
            "code": "1F4EA",
            "flagged": false,
            "keywords": [
                "closed",
                "communication",
                "flag",
                "lowered",
                "mail",
                "mailbox",
                "postbox"
            ]
        },
        {
            "no": 1262,
            "code": "1F4EC",
            "flagged": false,
            "keywords": [
                "communication",
                "flag",
                "mail",
                "mailbox",
                "open",
                "postbox"
            ]
        },
        {
            "no": 1263,
            "code": "1F4ED",
            "flagged": false,
            "keywords": [
                "communication",
                "flag",
                "lowered",
                "mail",
                "mailbox",
                "open",
                "postbox"
            ]
        },
        {
            "no": 1264,
            "code": "1F4EE",
            "flagged": false,
            "keywords": [
                "communication",
                "mail",
                "mailbox",
                "postbox"
            ]
        },
        {
            "no": 1265,
            "code": "1F5F3",
            "flagged": false,
            "keywords": [
                "ballot",
                "box"
            ]
        },
        {
            "no": 1266,
            "code": "270F",
            "flagged": false,
            "keywords": [
                "pencil"
            ]
        },
        {
            "no": 1267,
            "code": "2712",
            "flagged": false,
            "keywords": [
                "nib",
                "pen"
            ]
        },
        {
            "no": 1268,
            "code": "1F58B",
            "flagged": false,
            "keywords": [
                "communication",
                "fountain",
                "pen"
            ]
        },
        {
            "no": 1269,
            "code": "1F58A",
            "flagged": false,
            "keywords": [
                "ballpoint",
                "communication",
                "pen"
            ]
        },
        {
            "no": 1270,
            "code": "1F58C",
            "flagged": false,
            "keywords": [
                "communication",
                "paintbrush",
                "painting"
            ]
        },
        {
            "no": 1271,
            "code": "1F58D",
            "flagged": false,
            "keywords": [
                "communication",
                "crayon"
            ]
        },
        {
            "no": 1272,
            "code": "1F4DD",
            "flagged": false,
            "keywords": [
                "communication",
                "memo",
                "pencil"
            ]
        },
        {
            "no": 1273,
            "code": "1F4BC",
            "flagged": false,
            "keywords": [
                "briefcase"
            ]
        },
        {
            "no": 1274,
            "code": "1F4C1",
            "flagged": false,
            "keywords": [
                "file",
                "folder"
            ]
        },
        {
            "no": 1275,
            "code": "1F4C2",
            "flagged": false,
            "keywords": [
                "file",
                "folder",
                "open"
            ]
        },
        {
            "no": 1276,
            "code": "1F5C2",
            "flagged": false,
            "keywords": [
                "card",
                "dividers",
                "index"
            ]
        },
        {
            "no": 1277,
            "code": "1F4C5",
            "flagged": false,
            "keywords": [
                "calendar",
                "date"
            ]
        },
        {
            "no": 1278,
            "code": "1F4C6",
            "flagged": false,
            "keywords": [
                "calendar"
            ]
        },
        {
            "no": 1279,
            "code": "1F5D2",
            "flagged": false,
            "keywords": [
                "note",
                "pad",
                "spiral"
            ]
        },
        {
            "no": 1280,
            "code": "1F5D3",
            "flagged": false,
            "keywords": [
                "calendar",
                "pad",
                "spiral"
            ]
        },
        {
            "no": 1281,
            "code": "1F4C7",
            "flagged": false,
            "keywords": [
                "card",
                "index",
                "rolodex"
            ]
        },
        {
            "no": 1282,
            "code": "1F4C8",
            "flagged": false,
            "keywords": [
                "chart",
                "graph",
                "growth",
                "trend",
                "upward"
            ]
        },
        {
            "no": 1283,
            "code": "1F4C9",
            "flagged": false,
            "keywords": [
                "chart",
                "down",
                "graph",
                "trend"
            ]
        },
        {
            "no": 1284,
            "code": "1F4CA",
            "flagged": false,
            "keywords": [
                "bar",
                "chart",
                "graph"
            ]
        },
        {
            "no": 1285,
            "code": "1F4CB",
            "flagged": false,
            "keywords": [
                "clipboard"
            ]
        },
        {
            "no": 1286,
            "code": "1F4CC",
            "flagged": false,
            "keywords": [
                "pin",
                "pushpin"
            ]
        },
        {
            "no": 1287,
            "code": "1F4CD",
            "flagged": false,
            "keywords": [
                "pin",
                "pushpin"
            ]
        },
        {
            "no": 1288,
            "code": "1F4CE",
            "flagged": false,
            "keywords": [
                "paperclip"
            ]
        },
        {
            "no": 1289,
            "code": "1F587",
            "flagged": false,
            "keywords": [
                "communication",
                "link",
                "paperclip"
            ]
        },
        {
            "no": 1290,
            "code": "1F4CF",
            "flagged": false,
            "keywords": [
                "ruler",
                "straight edge"
            ]
        },
        {
            "no": 1291,
            "code": "1F4D0",
            "flagged": false,
            "keywords": [
                "ruler",
                "set",
                "triangle"
            ]
        },
        {
            "no": 1292,
            "code": "2702",
            "flagged": false,
            "keywords": [
                "scissors",
                "tool"
            ]
        },
        {
            "no": 1293,
            "code": "1F5C3",
            "flagged": false,
            "keywords": [
                "box",
                "card",
                "file"
            ]
        },
        {
            "no": 1294,
            "code": "1F5C4",
            "flagged": false,
            "keywords": [
                "cabinet",
                "file"
            ]
        },
        {
            "no": 1295,
            "code": "1F5D1",
            "flagged": false,
            "keywords": [
                "wastebasket"
            ]
        },
        {
            "no": 1296,
            "code": "1F512",
            "flagged": false,
            "keywords": [
                "closed",
                "lock"
            ]
        },
        {
            "no": 1297,
            "code": "1F513",
            "flagged": false,
            "keywords": [
                "lock",
                "open",
                "unlock"
            ]
        },
        {
            "no": 1298,
            "code": "1F50F",
            "flagged": false,
            "keywords": [
                "ink",
                "lock",
                "nib",
                "pen",
                "privacy"
            ]
        },
        {
            "no": 1299,
            "code": "1F510",
            "flagged": false,
            "keywords": [
                "closed",
                "key",
                "lock",
                "secure"
            ]
        },
        {
            "no": 1300,
            "code": "1F511",
            "flagged": false,
            "keywords": [
                "key",
                "lock",
                "password"
            ]
        },
        {
            "no": 1301,
            "code": "1F5DD",
            "flagged": false,
            "keywords": [
                "clue",
                "key",
                "lock",
                "old"
            ]
        },
        {
            "no": 1302,
            "code": "1F528",
            "flagged": false,
            "keywords": [
                "hammer",
                "tool"
            ]
        },
        {
            "no": 1303,
            "code": "26CF",
            "flagged": false,
            "keywords": [
                "mining",
                "pick",
                "tool"
            ]
        },
        {
            "no": 1304,
            "code": "2692",
            "flagged": false,
            "keywords": [
                "hammer",
                "pick",
                "tool"
            ]
        },
        {
            "no": 1305,
            "code": "1F6E0",
            "flagged": false,
            "keywords": [
                "hammer",
                "tool",
                "wrench"
            ]
        },
        {
            "no": 1306,
            "code": "1F5E1",
            "flagged": false,
            "keywords": [
                "dagger",
                "knife",
                "weapon"
            ]
        },
        {
            "no": 1307,
            "code": "2694",
            "flagged": false,
            "keywords": [
                "crossed",
                "swords",
                "weapon"
            ]
        },
        {
            "no": 1308,
            "code": "1F52B",
            "flagged": false,
            "keywords": [
                "gun",
                "handgun",
                "pistol",
                "revolver",
                "tool",
                "weapon"
            ]
        },
        {
            "no": 1309,
            "code": "1F3F9",
            "flagged": false,
            "keywords": [
                "archer",
                "arrow",
                "bow",
                "sagittarius",
                "tool",
                "weapon",
                "zodiac"
            ]
        },
        {
            "no": 1310,
            "code": "1F6E1",
            "flagged": false,
            "keywords": [
                "shield",
                "weapon"
            ]
        },
        {
            "no": 1311,
            "code": "1F527",
            "flagged": false,
            "keywords": [
                "tool",
                "wrench"
            ]
        },
        {
            "no": 1312,
            "code": "1F529",
            "flagged": false,
            "keywords": [
                "bolt",
                "nut",
                "tool"
            ]
        },
        {
            "no": 1313,
            "code": "2699",
            "flagged": false,
            "keywords": [
                "gear",
                "tool"
            ]
        },
        {
            "no": 1314,
            "code": "1F5DC",
            "flagged": false,
            "keywords": [
                "compression",
                "tool",
                "vice"
            ]
        },
        {
            "no": 1315,
            "code": "2697",
            "flagged": false,
            "keywords": [
                "alembic",
                "chemistry",
                "tool"
            ]
        },
        {
            "no": 1316,
            "code": "2696",
            "flagged": false,
            "keywords": [
                "balance",
                "justice",
                "libra",
                "scales",
                "tool",
                "weight",
                "zodiac"
            ]
        },
        {
            "no": 1317,
            "code": "1F517",
            "flagged": false,
            "keywords": [
                "link"
            ]
        },
        {
            "no": 1318,
            "code": "26D3",
            "flagged": false,
            "keywords": [
                "chain"
            ]
        },
        {
            "no": 1319,
            "code": "1F489",
            "flagged": false,
            "keywords": [
                "doctor",
                "medicine",
                "needle",
                "shot",
                "sick",
                "syringe",
                "tool"
            ]
        },
        {
            "no": 1320,
            "code": "1F48A",
            "flagged": false,
            "keywords": [
                "doctor",
                "medicine",
                "pill",
                "sick"
            ]
        },
        {
            "no": 1321,
            "code": "1F6AC",
            "flagged": false,
            "keywords": [
                "activity",
                "smoking"
            ]
        },
        {
            "no": 1322,
            "code": "26B0",
            "flagged": false,
            "keywords": [
                "coffin",
                "death"
            ]
        },
        {
            "no": 1323,
            "code": "26B1",
            "flagged": false,
            "keywords": [
                "death",
                "funeral",
                "urn"
            ]
        },
        {
            "no": 1324,
            "code": "1F5FF",
            "flagged": false,
            "keywords": [
                "face",
                "moyai",
                "statue"
            ]
        },
        {
            "no": 1325,
            "code": "1F6E2",
            "flagged": false,
            "keywords": [
                "drum",
                "oil"
            ]
        },
        {
            "no": 1326,
            "code": "1F52E",
            "flagged": false,
            "keywords": [
                "ball",
                "crystal",
                "fairy tale",
                "fantasy",
                "fortune",
                "tool"
            ]
        },
        {
            "no": 1327,
            "code": "1F6D2",
            "flagged": true,
            "keywords": [
                "cart",
                "shopping",
                "trolley"
            ]
        }
    ],
    SYMBOLS: [
        {
            "no": 1328,
            "code": "1F3E7",
            "flagged": false,
            "keywords": [
                "atm",
                "automated",
                "bank",
                "teller"
            ]
        },
        {
            "no": 1329,
            "code": "1F6AE",
            "flagged": false,
            "keywords": [
                "litter",
                "litterbox"
            ]
        },
        {
            "no": 1330,
            "code": "1F6B0",
            "flagged": false,
            "keywords": [
                "drink",
                "potable",
                "water"
            ]
        },
        {
            "no": 1331,
            "code": "267F",
            "flagged": false,
            "keywords": [
                "access",
                "wheelchair"
            ]
        },
        {
            "no": 1332,
            "code": "1F6B9",
            "flagged": false,
            "keywords": [
                "lavatory",
                "man",
                "restroom",
                "wc"
            ]
        },
        {
            "no": 1333,
            "code": "1F6BA",
            "flagged": false,
            "keywords": [
                "lavatory",
                "restroom",
                "wc",
                "woman"
            ]
        },
        {
            "no": 1334,
            "code": "1F6BB",
            "flagged": false,
            "keywords": [
                "lavatory",
                "restroom",
                "wc"
            ]
        },
        {
            "no": 1335,
            "code": "1F6BC",
            "flagged": false,
            "keywords": [
                "baby",
                "changing"
            ]
        },
        {
            "no": 1336,
            "code": "1F6BE",
            "flagged": false,
            "keywords": [
                "closet",
                "lavatory",
                "restroom",
                "water",
                "wc"
            ]
        },
        {
            "no": 1337,
            "code": "1F6C2",
            "flagged": false,
            "keywords": [
                "control",
                "passport"
            ]
        },
        {
            "no": 1338,
            "code": "1F6C3",
            "flagged": false,
            "keywords": [
                "customs"
            ]
        },
        {
            "no": 1339,
            "code": "1F6C4",
            "flagged": false,
            "keywords": [
                "baggage",
                "claim"
            ]
        },
        {
            "no": 1340,
            "code": "1F6C5",
            "flagged": false,
            "keywords": [
                "baggage",
                "left luggage",
                "locker",
                "luggage"
            ]
        },
        {
            "no": 1341,
            "code": "26A0",
            "flagged": false,
            "keywords": [
                "warning"
            ]
        },
        {
            "no": 1342,
            "code": "1F6B8",
            "flagged": false,
            "keywords": [
                "child",
                "crossing",
                "pedestrian",
                "traffic"
            ]
        },
        {
            "no": 1343,
            "code": "26D4",
            "flagged": false,
            "keywords": [
                "entry",
                "forbidden",
                "no",
                "not",
                "prohibited",
                "traffic"
            ]
        },
        {
            "no": 1344,
            "code": "1F6AB",
            "flagged": false,
            "keywords": [
                "entry",
                "forbidden",
                "no",
                "not",
                "prohibited"
            ]
        },
        {
            "no": 1345,
            "code": "1F6B3",
            "flagged": false,
            "keywords": [
                "bicycle",
                "bike",
                "forbidden",
                "no",
                "not",
                "prohibited",
                "vehicle"
            ]
        },
        {
            "no": 1346,
            "code": "1F6AD",
            "flagged": false,
            "keywords": [
                "forbidden",
                "no",
                "not",
                "prohibited",
                "smoking"
            ]
        },
        {
            "no": 1347,
            "code": "1F6AF",
            "flagged": false,
            "keywords": [
                "forbidden",
                "litter",
                "no",
                "not",
                "prohibited"
            ]
        },
        {
            "no": 1348,
            "code": "1F6B1",
            "flagged": false,
            "keywords": [
                "drink",
                "forbidden",
                "no",
                "not",
                "potable",
                "prohibited",
                "water"
            ]
        },
        {
            "no": 1349,
            "code": "1F6B7",
            "flagged": false,
            "keywords": [
                "forbidden",
                "no",
                "not",
                "pedestrian",
                "prohibited"
            ]
        },
        {
            "no": 1350,
            "code": "1F4F5",
            "flagged": false,
            "keywords": [
                "cell",
                "communication",
                "forbidden",
                "mobile",
                "no",
                "not",
                "phone",
                "prohibited",
                "telephone"
            ]
        },
        {
            "no": 1351,
            "code": "1F51E",
            "flagged": false,
            "keywords": [
                "18",
                "age restriction",
                "eighteen",
                "forbidden",
                "no",
                "not",
                "prohibited",
                "underage"
            ]
        },
        {
            "no": 1352,
            "code": "2622",
            "flagged": false,
            "keywords": [
                "radioactive"
            ]
        },
        {
            "no": 1353,
            "code": "2623",
            "flagged": false,
            "keywords": [
                "biohazard"
            ]
        },
        {
            "no": 1354,
            "code": "2B06",
            "flagged": false,
            "keywords": [
                "arrow",
                "cardinal",
                "direction",
                "north"
            ]
        },
        {
            "no": 1355,
            "code": "2197",
            "flagged": false,
            "keywords": [
                "arrow",
                "direction",
                "intercardinal",
                "northeast"
            ]
        },
        {
            "no": 1356,
            "code": "27A1",
            "flagged": false,
            "keywords": [
                "arrow",
                "cardinal",
                "direction",
                "east"
            ]
        },
        {
            "no": 1357,
            "code": "2198",
            "flagged": false,
            "keywords": [
                "arrow",
                "direction",
                "intercardinal",
                "southeast"
            ]
        },
        {
            "no": 1358,
            "code": "2B07",
            "flagged": false,
            "keywords": [
                "arrow",
                "cardinal",
                "direction",
                "down",
                "south"
            ]
        },
        {
            "no": 1359,
            "code": "2199",
            "flagged": false,
            "keywords": [
                "arrow",
                "direction",
                "intercardinal",
                "southwest"
            ]
        },
        {
            "no": 1360,
            "code": "2B05",
            "flagged": false,
            "keywords": [
                "arrow",
                "cardinal",
                "direction",
                "west"
            ]
        },
        {
            "no": 1361,
            "code": "2196",
            "flagged": false,
            "keywords": [
                "arrow",
                "direction",
                "intercardinal",
                "northwest"
            ]
        },
        {
            "no": 1362,
            "code": "2195",
            "flagged": false,
            "keywords": [
                "arrow"
            ]
        },
        {
            "no": 1363,
            "code": "2194",
            "flagged": false,
            "keywords": [
                "arrow"
            ]
        },
        {
            "no": 1364,
            "code": "21A9",
            "flagged": false,
            "keywords": [
                "arrow"
            ]
        },
        {
            "no": 1365,
            "code": "21AA",
            "flagged": false,
            "keywords": [
                "arrow"
            ]
        },
        {
            "no": 1366,
            "code": "2934",
            "flagged": false,
            "keywords": [
                "arrow"
            ]
        },
        {
            "no": 1367,
            "code": "2935",
            "flagged": false,
            "keywords": [
                "arrow",
                "down"
            ]
        },
        {
            "no": 1368,
            "code": "1F503",
            "flagged": false,
            "keywords": [
                "arrow",
                "clockwise",
                "reload"
            ]
        },
        {
            "no": 1369,
            "code": "1F504",
            "flagged": false,
            "keywords": [
                "anticlockwise",
                "arrow",
                "counterclockwise",
                "withershins"
            ]
        },
        {
            "no": 1370,
            "code": "1F519",
            "flagged": false,
            "keywords": [
                "arrow",
                "back"
            ]
        },
        {
            "no": 1371,
            "code": "1F51A",
            "flagged": false,
            "keywords": [
                "arrow",
                "end"
            ]
        },
        {
            "no": 1372,
            "code": "1F51B",
            "flagged": false,
            "keywords": [
                "arrow",
                "mark",
                "on"
            ]
        },
        {
            "no": 1373,
            "code": "1F51C",
            "flagged": false,
            "keywords": [
                "arrow",
                "soon"
            ]
        },
        {
            "no": 1374,
            "code": "1F51D",
            "flagged": false,
            "keywords": [
                "arrow",
                "top",
                "up"
            ]
        },
        {
            "no": 1375,
            "code": "1F6D0",
            "flagged": false,
            "keywords": [
                "religion",
                "worship"
            ]
        },
        {
            "no": 1376,
            "code": "269B",
            "flagged": false,
            "keywords": [
                "atheist",
                "atom"
            ]
        },
        {
            "no": 1377,
            "code": "1F549",
            "flagged": false,
            "keywords": [
                "hindu",
                "om",
                "religion"
            ]
        },
        {
            "no": 1378,
            "code": "2721",
            "flagged": false,
            "keywords": [
                "david",
                "jew",
                "jewish",
                "religion",
                "star"
            ]
        },
        {
            "no": 1379,
            "code": "2638",
            "flagged": false,
            "keywords": [
                "buddhist",
                "dharma",
                "religion",
                "wheel"
            ]
        },
        {
            "no": 1380,
            "code": "262F",
            "flagged": false,
            "keywords": [
                "religion",
                "tao",
                "taoist",
                "yang",
                "yin"
            ]
        },
        {
            "no": 1381,
            "code": "271D",
            "flagged": false,
            "keywords": [
                "christian",
                "cross",
                "religion"
            ]
        },
        {
            "no": 1382,
            "code": "2626",
            "flagged": false,
            "keywords": [
                "christian",
                "cross",
                "religion"
            ]
        },
        {
            "no": 1383,
            "code": "262A",
            "flagged": false,
            "keywords": [
                "islam",
                "muslim",
                "religion"
            ]
        },
        {
            "no": 1384,
            "code": "262E",
            "flagged": false,
            "keywords": [
                "peace"
            ]
        },
        {
            "no": 1385,
            "code": "1F54E",
            "flagged": false,
            "keywords": [
                "candelabrum",
                "candlestick",
                "menorah",
                "religion"
            ]
        },
        {
            "no": 1386,
            "code": "1F52F",
            "flagged": false,
            "keywords": [
                "fortune",
                "star"
            ]
        },
        {
            "no": 1387,
            "code": "267B",
            "flagged": false,
            "keywords": [
                "recycle"
            ]
        },
        {
            "no": 1388,
            "code": "1F4DB",
            "flagged": false,
            "keywords": [
                "badge",
                "name"
            ]
        },
        {
            "no": 1389,
            "code": "269C",
            "flagged": false,
            "keywords": [
                "fleur-de-lis"
            ]
        },
        {
            "no": 1390,
            "code": "1F530",
            "flagged": false,
            "keywords": [
                "beginner",
                "chevron",
                "green",
                "japanese",
                "leaf",
                "tool",
                "yellow"
            ]
        },
        {
            "no": 1391,
            "code": "1F531",
            "flagged": false,
            "keywords": [
                "anchor",
                "emblem",
                "ship",
                "tool",
                "trident"
            ]
        },
        {
            "no": 1392,
            "code": "2B55",
            "flagged": false,
            "keywords": [
                "circle",
                "o"
            ]
        },
        {
            "no": 1393,
            "code": "2705",
            "flagged": false,
            "keywords": [
                "check",
                "mark"
            ]
        },
        {
            "no": 1394,
            "code": "2611",
            "flagged": false,
            "keywords": [
                "ballot",
                "box",
                "check"
            ]
        },
        {
            "no": 1395,
            "code": "2714",
            "flagged": false,
            "keywords": [
                "check",
                "mark"
            ]
        },
        {
            "no": 1396,
            "code": "2716",
            "flagged": false,
            "keywords": [
                "cancel",
                "multiplication",
                "multiply",
                "x"
            ]
        },
        {
            "no": 1397,
            "code": "274C",
            "flagged": false,
            "keywords": [
                "cancel",
                "mark",
                "multiplication",
                "multiply",
                "x"
            ]
        },
        {
            "no": 1398,
            "code": "274E",
            "flagged": false,
            "keywords": [
                "mark",
                "square"
            ]
        },
        {
            "no": 1399,
            "code": "2795",
            "flagged": false,
            "keywords": [
                "math",
                "plus"
            ]
        },
        {
            "no": 1400,
            "code": "2796",
            "flagged": false,
            "keywords": [
                "math",
                "minus"
            ]
        },
        {
            "no": 1401,
            "code": "2797",
            "flagged": false,
            "keywords": [
                "division",
                "math"
            ]
        },
        {
            "no": 1402,
            "code": "27B0",
            "flagged": false,
            "keywords": [
                "curl",
                "loop"
            ]
        },
        {
            "no": 1403,
            "code": "27BF",
            "flagged": false,
            "keywords": [
                "curl",
                "double",
                "loop"
            ]
        },
        {
            "no": 1404,
            "code": "303D",
            "flagged": false,
            "keywords": [
                "mark",
                "part"
            ]
        },
        {
            "no": 1405,
            "code": "2733",
            "flagged": false,
            "keywords": [
                "asterisk"
            ]
        },
        {
            "no": 1406,
            "code": "2734",
            "flagged": false,
            "keywords": [
                "star"
            ]
        },
        {
            "no": 1407,
            "code": "2747",
            "flagged": false,
            "keywords": [
                "sparkle"
            ]
        },
        {
            "no": 1408,
            "code": "203C",
            "flagged": false,
            "keywords": [
                "bangbang",
                "exclamation",
                "mark",
                "punctuation"
            ]
        },
        {
            "no": 1409,
            "code": "2049",
            "flagged": false,
            "keywords": [
                "exclamation",
                "interrobang",
                "mark",
                "punctuation",
                "question"
            ]
        },
        {
            "no": 1410,
            "code": "2753",
            "flagged": false,
            "keywords": [
                "mark",
                "punctuation",
                "question"
            ]
        },
        {
            "no": 1411,
            "code": "2754",
            "flagged": false,
            "keywords": [
                "mark",
                "outlined",
                "punctuation",
                "question"
            ]
        },
        {
            "no": 1412,
            "code": "2755",
            "flagged": false,
            "keywords": [
                "exclamation",
                "mark",
                "outlined",
                "punctuation"
            ]
        },
        {
            "no": 1413,
            "code": "2757",
            "flagged": false,
            "keywords": [
                "exclamation",
                "mark",
                "punctuation"
            ]
        },
        {
            "no": 1414,
            "code": "3030",
            "flagged": false,
            "keywords": [
                "dash",
                "punctuation",
                "wavy"
            ]
        },
        {
            "no": 1417,
            "code": "2122",
            "flagged": false,
            "keywords": [
                "mark",
                "tm",
                "trademark"
            ]
        },
        {
            "no": 1418,
            "code": "2648",
            "flagged": false,
            "keywords": [
                "aries",
                "ram",
                "zodiac"
            ]
        },
        {
            "no": 1419,
            "code": "2649",
            "flagged": false,
            "keywords": [
                "bull",
                "ox",
                "taurus",
                "zodiac"
            ]
        },
        {
            "no": 1420,
            "code": "264A",
            "flagged": false,
            "keywords": [
                "gemini",
                "twins",
                "zodiac"
            ]
        },
        {
            "no": 1421,
            "code": "264B",
            "flagged": false,
            "keywords": [
                "cancer",
                "crab",
                "zodiac"
            ]
        },
        {
            "no": 1422,
            "code": "264C",
            "flagged": false,
            "keywords": [
                "leo",
                "lion",
                "zodiac"
            ]
        },
        {
            "no": 1423,
            "code": "264D",
            "flagged": false,
            "keywords": [
                "maiden",
                "virgin",
                "virgo",
                "zodiac"
            ]
        },
        {
            "no": 1424,
            "code": "264E",
            "flagged": false,
            "keywords": [
                "balance",
                "justice",
                "libra",
                "scales",
                "zodiac"
            ]
        },
        {
            "no": 1425,
            "code": "264F",
            "flagged": false,
            "keywords": [
                "scorpio",
                "scorpion",
                "scorpius",
                "zodiac"
            ]
        },
        {
            "no": 1426,
            "code": "2650",
            "flagged": false,
            "keywords": [
                "archer",
                "sagittarius",
                "zodiac"
            ]
        },
        {
            "no": 1427,
            "code": "2651",
            "flagged": false,
            "keywords": [
                "capricorn",
                "goat",
                "zodiac"
            ]
        },
        {
            "no": 1428,
            "code": "2652",
            "flagged": false,
            "keywords": [
                "aquarius",
                "bearer",
                "water",
                "zodiac"
            ]
        },
        {
            "no": 1429,
            "code": "2653",
            "flagged": false,
            "keywords": [
                "fish",
                "pisces",
                "zodiac"
            ]
        },
        {
            "no": 1430,
            "code": "26CE",
            "flagged": false,
            "keywords": [
                "bearer",
                "ophiuchus",
                "serpent",
                "snake",
                "zodiac"
            ]
        },
        {
            "no": 1431,
            "code": "1F500",
            "flagged": false,
            "keywords": [
                "arrow",
                "crossed"
            ]
        },
        {
            "no": 1432,
            "code": "1F501",
            "flagged": false,
            "keywords": [
                "arrow",
                "clockwise",
                "repeat"
            ]
        },
        {
            "no": 1433,
            "code": "1F502",
            "flagged": false,
            "keywords": [
                "arrow",
                "clockwise",
                "once"
            ]
        },
        {
            "no": 1434,
            "code": "25B6",
            "flagged": false,
            "keywords": [
                "arrow",
                "play",
                "right",
                "triangle"
            ]
        },
        {
            "no": 1435,
            "code": "23E9",
            "flagged": false,
            "keywords": [
                "arrow",
                "double",
                "fast",
                "forward"
            ]
        },
        {
            "no": 1436,
            "code": "23ED",
            "flagged": false,
            "keywords": [
                "arrow",
                "next scene",
                "next track",
                "triangle"
            ]
        },
        {
            "no": 1437,
            "code": "23EF",
            "flagged": false,
            "keywords": [
                "arrow",
                "pause",
                "play",
                "right",
                "triangle"
            ]
        },
        {
            "no": 1438,
            "code": "25C0",
            "flagged": false,
            "keywords": [
                "arrow",
                "left",
                "reverse",
                "triangle"
            ]
        },
        {
            "no": 1439,
            "code": "23EA",
            "flagged": false,
            "keywords": [
                "arrow",
                "double",
                "rewind"
            ]
        },
        {
            "no": 1440,
            "code": "23EE",
            "flagged": false,
            "keywords": [
                "arrow",
                "previous scene",
                "previous track",
                "triangle"
            ]
        },
        {
            "no": 1441,
            "code": "1F53C",
            "flagged": false,
            "keywords": [
                "arrow",
                "button",
                "red"
            ]
        },
        {
            "no": 1442,
            "code": "23EB",
            "flagged": false,
            "keywords": [
                "arrow",
                "double"
            ]
        },
        {
            "no": 1443,
            "code": "1F53D",
            "flagged": false,
            "keywords": [
                "arrow",
                "button",
                "down",
                "red"
            ]
        },
        {
            "no": 1444,
            "code": "23EC",
            "flagged": false,
            "keywords": [
                "arrow",
                "double",
                "down"
            ]
        },
        {
            "no": 1445,
            "code": "23F8",
            "flagged": false,
            "keywords": [
                "bar",
                "double",
                "pause",
                "vertical"
            ]
        },
        {
            "no": 1446,
            "code": "23F9",
            "flagged": false,
            "keywords": [
                "square",
                "stop"
            ]
        },
        {
            "no": 1447,
            "code": "23FA",
            "flagged": false,
            "keywords": [
                "circle",
                "record"
            ]
        },
        {
            "no": 1448,
            "code": "23CF",
            "flagged": true,
            "keywords": [
                "eject"
            ]
        },
        {
            "no": 1449,
            "code": "1F3A6",
            "flagged": false,
            "keywords": [
                "activity",
                "camera",
                "cinema",
                "entertainment",
                "film",
                "movie"
            ]
        },
        {
            "no": 1450,
            "code": "1F505",
            "flagged": false,
            "keywords": [
                "brightness",
                "dim",
                "low"
            ]
        },
        {
            "no": 1451,
            "code": "1F506",
            "flagged": false,
            "keywords": [
                "bright",
                "brightness"
            ]
        },
        {
            "no": 1452,
            "code": "1F4F6",
            "flagged": false,
            "keywords": [
                "antenna",
                "bar",
                "cell",
                "communication",
                "mobile",
                "phone",
                "signal",
                "telephone"
            ]
        },
        {
            "no": 1453,
            "code": "1F4F3",
            "flagged": false,
            "keywords": [
                "cell",
                "communication",
                "mobile",
                "mode",
                "phone",
                "telephone",
                "vibration"
            ]
        },
        {
            "no": 1454,
            "code": "1F4F4",
            "flagged": false,
            "keywords": [
                "cell",
                "communication",
                "mobile",
                "off",
                "phone",
                "telephone"
            ]
        },
        {
            "no": 1467,
            "code": "1F51F",
            "flagged": false,
            "keywords": [
                "10",
                "keycap",
                "ten"
            ]
        },
        {
            "no": 1468,
            "code": "1F4AF",
            "flagged": false,
            "keywords": [
                "100",
                "full",
                "hundred",
                "score"
            ]
        },
        {
            "no": 1469,
            "code": "1F520",
            "flagged": false,
            "keywords": [
                "input",
                "latin",
                "letters",
                "uppercase"
            ]
        },
        {
            "no": 1470,
            "code": "1F521",
            "flagged": false,
            "keywords": [
                "abcd",
                "input",
                "latin",
                "letters",
                "lowercase"
            ]
        },
        {
            "no": 1471,
            "code": "1F522",
            "flagged": false,
            "keywords": [
                "1234",
                "input",
                "numbers"
            ]
        },
        {
            "no": 1472,
            "code": "1F523",
            "flagged": false,
            "keywords": [
                "input"
            ]
        },
        {
            "no": 1473,
            "code": "1F524",
            "flagged": false,
            "keywords": [
                "abc",
                "alphabet",
                "input",
                "latin",
                "letters"
            ]
        },
        {
            "no": 1474,
            "code": "1F170",
            "flagged": false,
            "keywords": [
                "a",
                "blood"
            ]
        },
        {
            "no": 1475,
            "code": "1F18E",
            "flagged": false,
            "keywords": [
                "ab",
                "blood"
            ]
        },
        {
            "no": 1476,
            "code": "1F171",
            "flagged": false,
            "keywords": [
                "b",
                "blood"
            ]
        },
        {
            "no": 1477,
            "code": "1F191",
            "flagged": false,
            "keywords": [
                "cl"
            ]
        },
        {
            "no": 1478,
            "code": "1F192",
            "flagged": false,
            "keywords": [
                "cool"
            ]
        },
        {
            "no": 1479,
            "code": "1F193",
            "flagged": false,
            "keywords": [
                "free"
            ]
        },
        {
            "no": 1480,
            "code": "2139",
            "flagged": false,
            "keywords": [
                "i",
                "information"
            ]
        },
        {
            "no": 1481,
            "code": "1F194",
            "flagged": false,
            "keywords": [
                "id",
                "identity"
            ]
        },
        {
            "no": 1482,
            "code": "24C2",
            "flagged": false,
            "keywords": [
                "circle",
                "m"
            ]
        },
        {
            "no": 1483,
            "code": "1F195",
            "flagged": false,
            "keywords": [
                "new"
            ]
        },
        {
            "no": 1484,
            "code": "1F196",
            "flagged": false,
            "keywords": [
                "ng"
            ]
        },
        {
            "no": 1485,
            "code": "1F17E",
            "flagged": false,
            "keywords": [
                "blood",
                "o"
            ]
        },
        {
            "no": 1486,
            "code": "1F197",
            "flagged": false,
            "keywords": [
                "ok"
            ]
        },
        {
            "no": 1487,
            "code": "1F17F",
            "flagged": false,
            "keywords": [
                "parking"
            ]
        },
        {
            "no": 1488,
            "code": "1F198",
            "flagged": false,
            "keywords": [
                "help",
                "sos"
            ]
        },
        {
            "no": 1489,
            "code": "1F199",
            "flagged": false,
            "keywords": [
                "mark",
                "up"
            ]
        },
        {
            "no": 1490,
            "code": "1F19A",
            "flagged": false,
            "keywords": [
                "versus",
                "vs"
            ]
        },
        {
            "no": 1491,
            "code": "1F201",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1492,
            "code": "1F202",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1493,
            "code": "1F237",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1494,
            "code": "1F236",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1495,
            "code": "1F22F",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1496,
            "code": "1F250",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1497,
            "code": "1F239",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1498,
            "code": "1F21A",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1499,
            "code": "1F232",
            "flagged": false,
            "keywords": [
                "japanese"
            ]
        },
        {
            "no": 1500,
            "code": "1F251",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1501,
            "code": "1F238",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1502,
            "code": "1F234",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1503,
            "code": "1F233",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1504,
            "code": "3297",
            "flagged": false,
            "keywords": [
                "chinese",
                "congratulation",
                "congratulations",
                "ideograph"
            ]
        },
        {
            "no": 1505,
            "code": "3299",
            "flagged": false,
            "keywords": [
                "chinese",
                "ideograph",
                "secret"
            ]
        },
        {
            "no": 1506,
            "code": "1F23A",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1507,
            "code": "1F235",
            "flagged": false,
            "keywords": [
                "chinese"
            ]
        },
        {
            "no": 1508,
            "code": "25AA",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1509,
            "code": "25AB",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1510,
            "code": "25FB",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1511,
            "code": "25FC",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1512,
            "code": "25FD",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1513,
            "code": "25FE",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1514,
            "code": "2B1B",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1515,
            "code": "2B1C",
            "flagged": false,
            "keywords": [
                "geometric",
                "square"
            ]
        },
        {
            "no": 1516,
            "code": "1F536",
            "flagged": false,
            "keywords": [
                "diamond",
                "geometric",
                "orange"
            ]
        },
        {
            "no": 1517,
            "code": "1F537",
            "flagged": false,
            "keywords": [
                "blue",
                "diamond",
                "geometric"
            ]
        },
        {
            "no": 1518,
            "code": "1F538",
            "flagged": false,
            "keywords": [
                "diamond",
                "geometric",
                "orange"
            ]
        },
        {
            "no": 1519,
            "code": "1F539",
            "flagged": false,
            "keywords": [
                "blue",
                "diamond",
                "geometric"
            ]
        },
        {
            "no": 1520,
            "code": "1F53A",
            "flagged": false,
            "keywords": [
                "geometric",
                "red"
            ]
        },
        {
            "no": 1521,
            "code": "1F53B",
            "flagged": false,
            "keywords": [
                "down",
                "geometric",
                "red"
            ]
        },
        {
            "no": 1522,
            "code": "1F4A0",
            "flagged": false,
            "keywords": [
                "comic",
                "diamond",
                "geometric",
                "inside"
            ]
        },
        {
            "no": 1523,
            "code": "1F518",
            "flagged": false,
            "keywords": [
                "button",
                "geometric",
                "radio"
            ]
        },
        {
            "no": 1524,
            "code": "1F532",
            "flagged": false,
            "keywords": [
                "button",
                "geometric",
                "square"
            ]
        },
        {
            "no": 1525,
            "code": "1F533",
            "flagged": false,
            "keywords": [
                "button",
                "geometric",
                "outlined",
                "square"
            ]
        },
        {
            "no": 1526,
            "code": "26AA",
            "flagged": false,
            "keywords": [
                "circle",
                "geometric"
            ]
        },
        {
            "no": 1527,
            "code": "26AB",
            "flagged": false,
            "keywords": [
                "circle",
                "geometric"
            ]
        },
        {
            "no": 1528,
            "code": "1F534",
            "flagged": false,
            "keywords": [
                "circle",
                "geometric",
                "red"
            ]
        },
        {
            "no": 1529,
            "code": "1F535",
            "flagged": false,
            "keywords": [
                "blue",
                "circle",
                "geometric"
            ]
        }
    ],
    FLAGS: [
        {
            "no": 1530,
            "code": "1F3C1",
            "flagged": false,
            "keywords": [
                "checkered",
                "chequered",
                "flag",
                "racing"
            ]
        },
        {
            "no": 1531,
            "code": "1F6A9",
            "flagged": false,
            "keywords": [
                "flag",
                "post"
            ]
        },
        {
            "no": 1532,
            "code": "1F38C",
            "flagged": false,
            "keywords": [
                "activity",
                "celebration",
                "cross",
                "crossed",
                "flag",
                "japanese"
            ]
        },
        {
            "no": 1533,
            "code": "1F3F4",
            "flagged": false,
            "keywords": [
                "flag",
                "waving"
            ]
        },
        {
            "no": 1534,
            "code": "1F3F3",
            "flagged": false,
            "keywords": [
                "flag",
                "waving"
            ]
        },
        {
            "no": 1535,
            "code": "1F1E6-1F1E8",
            "flagged": false,
            "keywords": [
                "ascension",
                "flag",
                "island"
            ]
        },
        {
            "no": 1536,
            "code": "1F1E6-1F1E9",
            "flagged": false,
            "keywords": [
                "andorra",
                "flag"
            ]
        },
        {
            "no": 1537,
            "code": "1F1E6-1F1EA",
            "flagged": false,
            "keywords": [
                "emirates",
                "flag",
                "uae",
                "united"
            ]
        },
        {
            "no": 1538,
            "code": "1F1E6-1F1EB",
            "flagged": false,
            "keywords": [
                "afghanistan",
                "flag"
            ]
        },
        {
            "no": 1539,
            "code": "1F1E6-1F1EC",
            "flagged": false,
            "keywords": [
                "antigua",
                "barbuda",
                "flag"
            ]
        },
        {
            "no": 1540,
            "code": "1F1E6-1F1EE",
            "flagged": false,
            "keywords": [
                "anguilla",
                "flag"
            ]
        },
        {
            "no": 1541,
            "code": "1F1E6-1F1F1",
            "flagged": false,
            "keywords": [
                "albania",
                "flag"
            ]
        },
        {
            "no": 1542,
            "code": "1F1E6-1F1F2",
            "flagged": false,
            "keywords": [
                "armenia",
                "flag"
            ]
        },
        {
            "no": 1543,
            "code": "1F1E6-1F1F4",
            "flagged": false,
            "keywords": [
                "angola",
                "flag"
            ]
        },
        {
            "no": 1544,
            "code": "1F1E6-1F1F6",
            "flagged": false,
            "keywords": [
                "antarctica",
                "flag"
            ]
        },
        {
            "no": 1545,
            "code": "1F1E6-1F1F7",
            "flagged": false,
            "keywords": [
                "argentina",
                "flag"
            ]
        },
        {
            "no": 1546,
            "code": "1F1E6-1F1F8",
            "flagged": false,
            "keywords": [
                "american",
                "flag",
                "samoa"
            ]
        },
        {
            "no": 1547,
            "code": "1F1E6-1F1F9",
            "flagged": false,
            "keywords": [
                "austria",
                "flag"
            ]
        },
        {
            "no": 1548,
            "code": "1F1E6-1F1FA",
            "flagged": false,
            "keywords": [
                "australia",
                "flag"
            ]
        },
        {
            "no": 1549,
            "code": "1F1E6-1F1FC",
            "flagged": false,
            "keywords": [
                "aruba",
                "flag"
            ]
        },
        {
            "no": 1550,
            "code": "1F1E6-1F1FD",
            "flagged": false,
            "keywords": [
                "åland",
                "flag"
            ]
        },
        {
            "no": 1551,
            "code": "1F1E6-1F1FF",
            "flagged": false,
            "keywords": [
                "azerbaijan",
                "flag"
            ]
        },
        {
            "no": 1552,
            "code": "1F1E7-1F1E6",
            "flagged": false,
            "keywords": [
                "bosnia",
                "flag",
                "herzegovina"
            ]
        },
        {
            "no": 1553,
            "code": "1F1E7-1F1E7",
            "flagged": false,
            "keywords": [
                "barbados",
                "flag"
            ]
        },
        {
            "no": 1554,
            "code": "1F1E7-1F1E9",
            "flagged": false,
            "keywords": [
                "bangladesh",
                "flag"
            ]
        },
        {
            "no": 1555,
            "code": "1F1E7-1F1EA",
            "flagged": false,
            "keywords": [
                "belgium",
                "flag"
            ]
        },
        {
            "no": 1556,
            "code": "1F1E7-1F1EB",
            "flagged": false,
            "keywords": [
                "burkina faso",
                "flag"
            ]
        },
        {
            "no": 1557,
            "code": "1F1E7-1F1EC",
            "flagged": false,
            "keywords": [
                "bulgaria",
                "flag"
            ]
        },
        {
            "no": 1558,
            "code": "1F1E7-1F1ED",
            "flagged": false,
            "keywords": [
                "bahrain",
                "flag"
            ]
        },
        {
            "no": 1559,
            "code": "1F1E7-1F1EE",
            "flagged": false,
            "keywords": [
                "burundi",
                "flag"
            ]
        },
        {
            "no": 1560,
            "code": "1F1E7-1F1EF",
            "flagged": false,
            "keywords": [
                "benin",
                "flag"
            ]
        },
        {
            "no": 1561,
            "code": "1F1E7-1F1F1",
            "flagged": false,
            "keywords": [
                "barthelemy",
                "barthélemy",
                "flag",
                "saint"
            ]
        },
        {
            "no": 1562,
            "code": "1F1E7-1F1F2",
            "flagged": false,
            "keywords": [
                "bermuda",
                "flag"
            ]
        },
        {
            "no": 1563,
            "code": "1F1E7-1F1F3",
            "flagged": false,
            "keywords": [
                "brunei",
                "darussalam",
                "flag"
            ]
        },
        {
            "no": 1564,
            "code": "1F1E7-1F1F4",
            "flagged": false,
            "keywords": [
                "bolivia",
                "flag"
            ]
        },
        {
            "no": 1565,
            "code": "1F1E7-1F1F6",
            "flagged": false,
            "keywords": [
                "bonaire",
                "caribbean",
                "eustatius",
                "flag",
                "netherlands",
                "saba",
                "sint"
            ]
        },
        {
            "no": 1566,
            "code": "1F1E7-1F1F7",
            "flagged": false,
            "keywords": [
                "brazil",
                "flag"
            ]
        },
        {
            "no": 1567,
            "code": "1F1E7-1F1F8",
            "flagged": false,
            "keywords": [
                "bahamas",
                "flag"
            ]
        },
        {
            "no": 1568,
            "code": "1F1E7-1F1F9",
            "flagged": false,
            "keywords": [
                "bhutan",
                "flag"
            ]
        },
        {
            "no": 1569,
            "code": "1F1E7-1F1FB",
            "flagged": false,
            "keywords": [
                "bouvet",
                "flag",
                "island"
            ]
        },
        {
            "no": 1570,
            "code": "1F1E7-1F1FC",
            "flagged": false,
            "keywords": [
                "botswana",
                "flag"
            ]
        },
        {
            "no": 1571,
            "code": "1F1E7-1F1FE",
            "flagged": false,
            "keywords": [
                "belarus",
                "flag"
            ]
        },
        {
            "no": 1572,
            "code": "1F1E7-1F1FF",
            "flagged": false,
            "keywords": [
                "belize",
                "flag"
            ]
        },
        {
            "no": 1573,
            "code": "1F1E8-1F1E6",
            "flagged": false,
            "keywords": [
                "canada",
                "flag"
            ]
        },
        {
            "no": 1574,
            "code": "1F1E8-1F1E8",
            "flagged": false,
            "keywords": [
                "cocos",
                "flag",
                "island",
                "keeling"
            ]
        },
        {
            "no": 1575,
            "code": "1F1E8-1F1E9",
            "flagged": false,
            "keywords": [
                "congo",
                "congo-kinshasa",
                "democratic republic of congo",
                "drc",
                "flag",
                "kinshasa",
                "republic"
            ]
        },
        {
            "no": 1576,
            "code": "1F1E8-1F1EB",
            "flagged": false,
            "keywords": [
                "central african republic",
                "flag",
                "republic"
            ]
        },
        {
            "no": 1577,
            "code": "1F1E8-1F1EC",
            "flagged": false,
            "keywords": [
                "brazzaville",
                "congo",
                "congo republic",
                "congo-brazzaville",
                "flag",
                "republic",
                "republic of the congo"
            ]
        },
        {
            "no": 1578,
            "code": "1F1E8-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "switzerland"
            ]
        },
        {
            "no": 1579,
            "code": "1F1E8-1F1EE",
            "flagged": false,
            "keywords": [
                "cote ivoire",
                "côte ivoire",
                "flag",
                "ivory coast"
            ]
        },
        {
            "no": 1580,
            "code": "1F1E8-1F1F0",
            "flagged": false,
            "keywords": [
                "cook",
                "flag",
                "island"
            ]
        },
        {
            "no": 1581,
            "code": "1F1E8-1F1F1",
            "flagged": false,
            "keywords": [
                "chile",
                "flag"
            ]
        },
        {
            "no": 1582,
            "code": "1F1E8-1F1F2",
            "flagged": false,
            "keywords": [
                "cameroon",
                "flag"
            ]
        },
        {
            "no": 1583,
            "code": "1F1E8-1F1F3",
            "flagged": false,
            "keywords": [
                "china",
                "flag"
            ]
        },
        {
            "no": 1584,
            "code": "1F1E8-1F1F4",
            "flagged": false,
            "keywords": [
                "colombia",
                "flag"
            ]
        },
        {
            "no": 1585,
            "code": "1F1E8-1F1F5",
            "flagged": false,
            "keywords": [
                "clipperton",
                "flag",
                "island"
            ]
        },
        {
            "no": 1586,
            "code": "1F1E8-1F1F7",
            "flagged": false,
            "keywords": [
                "costa rica",
                "flag"
            ]
        },
        {
            "no": 1587,
            "code": "1F1E8-1F1FA",
            "flagged": false,
            "keywords": [
                "cuba",
                "flag"
            ]
        },
        {
            "no": 1588,
            "code": "1F1E8-1F1FB",
            "flagged": false,
            "keywords": [
                "cabo",
                "cape",
                "flag",
                "verde"
            ]
        },
        {
            "no": 1589,
            "code": "1F1E8-1F1FC",
            "flagged": false,
            "keywords": [
                "antilles",
                "curacao",
                "curaçao",
                "flag"
            ]
        },
        {
            "no": 1590,
            "code": "1F1E8-1F1FD",
            "flagged": false,
            "keywords": [
                "christmas",
                "flag",
                "island"
            ]
        },
        {
            "no": 1591,
            "code": "1F1E8-1F1FE",
            "flagged": false,
            "keywords": [
                "cyprus",
                "flag"
            ]
        },
        {
            "no": 1592,
            "code": "1F1E8-1F1FF",
            "flagged": false,
            "keywords": [
                "czech republic",
                "flag"
            ]
        },
        {
            "no": 1593,
            "code": "1F1E9-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "germany"
            ]
        },
        {
            "no": 1594,
            "code": "1F1E9-1F1EC",
            "flagged": false,
            "keywords": [
                "diego garcia",
                "flag"
            ]
        },
        {
            "no": 1595,
            "code": "1F1E9-1F1EF",
            "flagged": false,
            "keywords": [
                "djibouti",
                "flag"
            ]
        },
        {
            "no": 1596,
            "code": "1F1E9-1F1F0",
            "flagged": false,
            "keywords": [
                "denmark",
                "flag"
            ]
        },
        {
            "no": 1597,
            "code": "1F1E9-1F1F2",
            "flagged": false,
            "keywords": [
                "dominica",
                "flag"
            ]
        },
        {
            "no": 1598,
            "code": "1F1E9-1F1F4",
            "flagged": false,
            "keywords": [
                "dominican republic",
                "flag"
            ]
        },
        {
            "no": 1599,
            "code": "1F1E9-1F1FF",
            "flagged": false,
            "keywords": [
                "algeria",
                "flag"
            ]
        },
        {
            "no": 1600,
            "code": "1F1EA-1F1E6",
            "flagged": false,
            "keywords": [
                "ceuta",
                "flag",
                "melilla"
            ]
        },
        {
            "no": 1601,
            "code": "1F1EA-1F1E8",
            "flagged": false,
            "keywords": [
                "ecuador",
                "flag"
            ]
        },
        {
            "no": 1602,
            "code": "1F1EA-1F1EA",
            "flagged": false,
            "keywords": [
                "estonia",
                "flag"
            ]
        },
        {
            "no": 1603,
            "code": "1F1EA-1F1EC",
            "flagged": false,
            "keywords": [
                "egypt",
                "flag"
            ]
        },
        {
            "no": 1604,
            "code": "1F1EA-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "sahara",
                "west",
                "western sahara"
            ]
        },
        {
            "no": 1605,
            "code": "1F1EA-1F1F7",
            "flagged": false,
            "keywords": [
                "eritrea",
                "flag"
            ]
        },
        {
            "no": 1606,
            "code": "1F1EA-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "spain"
            ]
        },
        {
            "no": 1607,
            "code": "1F1EA-1F1F9",
            "flagged": false,
            "keywords": [
                "ethiopia",
                "flag"
            ]
        },
        {
            "no": 1608,
            "code": "1F1EA-1F1FA",
            "flagged": false,
            "keywords": [
                "european union",
                "flag"
            ]
        },
        {
            "no": 1609,
            "code": "1F1EB-1F1EE",
            "flagged": false,
            "keywords": [
                "finland",
                "flag"
            ]
        },
        {
            "no": 1610,
            "code": "1F1EB-1F1EF",
            "flagged": false,
            "keywords": [
                "fiji",
                "flag"
            ]
        },
        {
            "no": 1611,
            "code": "1F1EB-1F1F0",
            "flagged": false,
            "keywords": [
                "falkland",
                "falklands",
                "flag",
                "island",
                "islas",
                "malvinas"
            ]
        },
        {
            "no": 1612,
            "code": "1F1EB-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "micronesia"
            ]
        },
        {
            "no": 1613,
            "code": "1F1EB-1F1F4",
            "flagged": false,
            "keywords": [
                "faroe",
                "flag",
                "island"
            ]
        },
        {
            "no": 1614,
            "code": "1F1EB-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "france"
            ]
        },
        {
            "no": 1615,
            "code": "1F1EC-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "gabon"
            ]
        },
        {
            "no": 1616,
            "code": "1F1EC-1F1E7",
            "flagged": false,
            "keywords": [
                "britain",
                "british",
                "cornwall",
                "england",
                "flag",
                "great britain",
                "ireland",
                "northern ireland",
                "scotland",
                "uk",
                "union jack",
                "united",
                "united kingdom",
                "wales"
            ]
        },
        {
            "no": 1617,
            "code": "1F1EC-1F1E9",
            "flagged": false,
            "keywords": [
                "flag",
                "grenada"
            ]
        },
        {
            "no": 1618,
            "code": "1F1EC-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "georgia"
            ]
        },
        {
            "no": 1619,
            "code": "1F1EC-1F1EB",
            "flagged": false,
            "keywords": [
                "flag",
                "french",
                "guiana"
            ]
        },
        {
            "no": 1620,
            "code": "1F1EC-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "guernsey"
            ]
        },
        {
            "no": 1621,
            "code": "1F1EC-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "ghana"
            ]
        },
        {
            "no": 1622,
            "code": "1F1EC-1F1EE",
            "flagged": false,
            "keywords": [
                "flag",
                "gibraltar"
            ]
        },
        {
            "no": 1623,
            "code": "1F1EC-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "greenland"
            ]
        },
        {
            "no": 1624,
            "code": "1F1EC-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "gambia"
            ]
        },
        {
            "no": 1625,
            "code": "1F1EC-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "guinea"
            ]
        },
        {
            "no": 1626,
            "code": "1F1EC-1F1F5",
            "flagged": false,
            "keywords": [
                "flag",
                "guadeloupe"
            ]
        },
        {
            "no": 1627,
            "code": "1F1EC-1F1F6",
            "flagged": false,
            "keywords": [
                "equatorial guinea",
                "flag",
                "guinea"
            ]
        },
        {
            "no": 1628,
            "code": "1F1EC-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "greece"
            ]
        },
        {
            "no": 1629,
            "code": "1F1EC-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "georgia",
                "island",
                "south",
                "south georgia",
                "south sandwich"
            ]
        },
        {
            "no": 1630,
            "code": "1F1EC-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "guatemala"
            ]
        },
        {
            "no": 1631,
            "code": "1F1EC-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "guam"
            ]
        },
        {
            "no": 1632,
            "code": "1F1EC-1F1FC",
            "flagged": false,
            "keywords": [
                "bissau",
                "flag",
                "guinea"
            ]
        },
        {
            "no": 1633,
            "code": "1F1EC-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "guyana"
            ]
        },
        {
            "no": 1634,
            "code": "1F1ED-1F1F0",
            "flagged": false,
            "keywords": [
                "china",
                "flag",
                "hong kong"
            ]
        },
        {
            "no": 1635,
            "code": "1F1ED-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "heard",
                "island",
                "mcdonald"
            ]
        },
        {
            "no": 1636,
            "code": "1F1ED-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "honduras"
            ]
        },
        {
            "no": 1637,
            "code": "1F1ED-1F1F7",
            "flagged": false,
            "keywords": [
                "croatia",
                "flag"
            ]
        },
        {
            "no": 1638,
            "code": "1F1ED-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "haiti"
            ]
        },
        {
            "no": 1639,
            "code": "1F1ED-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "hungary"
            ]
        },
        {
            "no": 1640,
            "code": "1F1EE-1F1E8",
            "flagged": false,
            "keywords": [
                "canary",
                "flag",
                "island"
            ]
        },
        {
            "no": 1641,
            "code": "1F1EE-1F1E9",
            "flagged": false,
            "keywords": [
                "flag",
                "indonesia"
            ]
        },
        {
            "no": 1642,
            "code": "1F1EE-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "ireland"
            ]
        },
        {
            "no": 1643,
            "code": "1F1EE-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "israel"
            ]
        },
        {
            "no": 1644,
            "code": "1F1EE-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "isle of man"
            ]
        },
        {
            "no": 1645,
            "code": "1F1EE-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "india"
            ]
        },
        {
            "no": 1646,
            "code": "1F1EE-1F1F4",
            "flagged": false,
            "keywords": [
                "british",
                "chagos",
                "flag",
                "indian ocean",
                "island"
            ]
        },
        {
            "no": 1647,
            "code": "1F1EE-1F1F6",
            "flagged": false,
            "keywords": [
                "flag",
                "iraq"
            ]
        },
        {
            "no": 1648,
            "code": "1F1EE-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "iran"
            ]
        },
        {
            "no": 1649,
            "code": "1F1EE-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "iceland"
            ]
        },
        {
            "no": 1650,
            "code": "1F1EE-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "italy"
            ]
        },
        {
            "no": 1651,
            "code": "1F1EF-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "jersey"
            ]
        },
        {
            "no": 1652,
            "code": "1F1EF-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "jamaica"
            ]
        },
        {
            "no": 1653,
            "code": "1F1EF-1F1F4",
            "flagged": false,
            "keywords": [
                "flag",
                "jordan"
            ]
        },
        {
            "no": 1654,
            "code": "1F1EF-1F1F5",
            "flagged": false,
            "keywords": [
                "flag",
                "japan"
            ]
        },
        {
            "no": 1655,
            "code": "1F1F0-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "kenya"
            ]
        },
        {
            "no": 1656,
            "code": "1F1F0-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "kyrgyzstan"
            ]
        },
        {
            "no": 1657,
            "code": "1F1F0-1F1ED",
            "flagged": false,
            "keywords": [
                "cambodia",
                "flag"
            ]
        },
        {
            "no": 1658,
            "code": "1F1F0-1F1EE",
            "flagged": false,
            "keywords": [
                "flag",
                "kiribati"
            ]
        },
        {
            "no": 1659,
            "code": "1F1F0-1F1F2",
            "flagged": false,
            "keywords": [
                "comoros",
                "flag"
            ]
        },
        {
            "no": 1660,
            "code": "1F1F0-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "kitts",
                "nevis",
                "saint"
            ]
        },
        {
            "no": 1661,
            "code": "1F1F0-1F1F5",
            "flagged": false,
            "keywords": [
                "flag",
                "korea",
                "north",
                "north korea"
            ]
        },
        {
            "no": 1662,
            "code": "1F1F0-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "korea",
                "south",
                "south korea"
            ]
        },
        {
            "no": 1663,
            "code": "1F1F0-1F1FC",
            "flagged": false,
            "keywords": [
                "flag",
                "kuwait"
            ]
        },
        {
            "no": 1664,
            "code": "1F1F0-1F1FE",
            "flagged": false,
            "keywords": [
                "cayman",
                "flag",
                "island"
            ]
        },
        {
            "no": 1665,
            "code": "1F1F0-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "kazakhstan"
            ]
        },
        {
            "no": 1666,
            "code": "1F1F1-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "laos"
            ]
        },
        {
            "no": 1667,
            "code": "1F1F1-1F1E7",
            "flagged": false,
            "keywords": [
                "flag",
                "lebanon"
            ]
        },
        {
            "no": 1668,
            "code": "1F1F1-1F1E8",
            "flagged": false,
            "keywords": [
                "flag",
                "lucia",
                "saint"
            ]
        },
        {
            "no": 1669,
            "code": "1F1F1-1F1EE",
            "flagged": false,
            "keywords": [
                "flag",
                "liechtenstein"
            ]
        },
        {
            "no": 1670,
            "code": "1F1F1-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "sri lanka"
            ]
        },
        {
            "no": 1671,
            "code": "1F1F1-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "liberia"
            ]
        },
        {
            "no": 1672,
            "code": "1F1F1-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "lesotho"
            ]
        },
        {
            "no": 1673,
            "code": "1F1F1-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "lithuania"
            ]
        },
        {
            "no": 1674,
            "code": "1F1F1-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "luxembourg"
            ]
        },
        {
            "no": 1675,
            "code": "1F1F1-1F1FB",
            "flagged": false,
            "keywords": [
                "flag",
                "latvia"
            ]
        },
        {
            "no": 1676,
            "code": "1F1F1-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "libya"
            ]
        },
        {
            "no": 1677,
            "code": "1F1F2-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "morocco"
            ]
        },
        {
            "no": 1678,
            "code": "1F1F2-1F1E8",
            "flagged": false,
            "keywords": [
                "flag",
                "monaco"
            ]
        },
        {
            "no": 1679,
            "code": "1F1F2-1F1E9",
            "flagged": false,
            "keywords": [
                "flag",
                "moldova"
            ]
        },
        {
            "no": 1680,
            "code": "1F1F2-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "montenegro"
            ]
        },
        {
            "no": 1681,
            "code": "1F1F2-1F1EB",
            "flagged": false,
            "keywords": [
                "flag",
                "french",
                "martin",
                "saint"
            ]
        },
        {
            "no": 1682,
            "code": "1F1F2-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "madagascar"
            ]
        },
        {
            "no": 1683,
            "code": "1F1F2-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "island",
                "marshall"
            ]
        },
        {
            "no": 1684,
            "code": "1F1F2-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "macedonia"
            ]
        },
        {
            "no": 1685,
            "code": "1F1F2-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "mali"
            ]
        },
        {
            "no": 1686,
            "code": "1F1F2-1F1F2",
            "flagged": false,
            "keywords": [
                "burma",
                "flag",
                "myanmar"
            ]
        },
        {
            "no": 1687,
            "code": "1F1F2-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "mongolia"
            ]
        },
        {
            "no": 1688,
            "code": "1F1F2-1F1F4",
            "flagged": false,
            "keywords": [
                "china",
                "flag",
                "macao",
                "macau"
            ]
        },
        {
            "no": 1689,
            "code": "1F1F2-1F1F5",
            "flagged": false,
            "keywords": [
                "flag",
                "island",
                "mariana",
                "north",
                "northern mariana"
            ]
        },
        {
            "no": 1690,
            "code": "1F1F2-1F1F6",
            "flagged": false,
            "keywords": [
                "flag",
                "martinique"
            ]
        },
        {
            "no": 1691,
            "code": "1F1F2-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "mauritania"
            ]
        },
        {
            "no": 1692,
            "code": "1F1F2-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "montserrat"
            ]
        },
        {
            "no": 1693,
            "code": "1F1F2-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "malta"
            ]
        },
        {
            "no": 1694,
            "code": "1F1F2-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "mauritius"
            ]
        },
        {
            "no": 1695,
            "code": "1F1F2-1F1FB",
            "flagged": false,
            "keywords": [
                "flag",
                "maldives"
            ]
        },
        {
            "no": 1696,
            "code": "1F1F2-1F1FC",
            "flagged": false,
            "keywords": [
                "flag",
                "malawi"
            ]
        },
        {
            "no": 1697,
            "code": "1F1F2-1F1FD",
            "flagged": false,
            "keywords": [
                "flag",
                "mexico"
            ]
        },
        {
            "no": 1698,
            "code": "1F1F2-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "malaysia"
            ]
        },
        {
            "no": 1699,
            "code": "1F1F2-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "mozambique"
            ]
        },
        {
            "no": 1700,
            "code": "1F1F3-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "namibia"
            ]
        },
        {
            "no": 1701,
            "code": "1F1F3-1F1E8",
            "flagged": false,
            "keywords": [
                "flag",
                "new",
                "new caledonia"
            ]
        },
        {
            "no": 1702,
            "code": "1F1F3-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "niger"
            ]
        },
        {
            "no": 1703,
            "code": "1F1F3-1F1EB",
            "flagged": false,
            "keywords": [
                "flag",
                "island",
                "norfolk"
            ]
        },
        {
            "no": 1704,
            "code": "1F1F3-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "nigeria"
            ]
        },
        {
            "no": 1705,
            "code": "1F1F3-1F1EE",
            "flagged": false,
            "keywords": [
                "flag",
                "nicaragua"
            ]
        },
        {
            "no": 1706,
            "code": "1F1F3-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "netherlands"
            ]
        },
        {
            "no": 1707,
            "code": "1F1F3-1F1F4",
            "flagged": false,
            "keywords": [
                "flag",
                "norway"
            ]
        },
        {
            "no": 1708,
            "code": "1F1F3-1F1F5",
            "flagged": false,
            "keywords": [
                "flag",
                "nepal"
            ]
        },
        {
            "no": 1709,
            "code": "1F1F3-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "nauru"
            ]
        },
        {
            "no": 1710,
            "code": "1F1F3-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "niue"
            ]
        },
        {
            "no": 1711,
            "code": "1F1F3-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "new",
                "new zealand"
            ]
        },
        {
            "no": 1712,
            "code": "1F1F4-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "oman"
            ]
        },
        {
            "no": 1713,
            "code": "1F1F5-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "panama"
            ]
        },
        {
            "no": 1714,
            "code": "1F1F5-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "peru"
            ]
        },
        {
            "no": 1715,
            "code": "1F1F5-1F1EB",
            "flagged": false,
            "keywords": [
                "flag",
                "french",
                "polynesia"
            ]
        },
        {
            "no": 1716,
            "code": "1F1F5-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "guinea",
                "new",
                "papua new guinea"
            ]
        },
        {
            "no": 1717,
            "code": "1F1F5-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "philippines"
            ]
        },
        {
            "no": 1718,
            "code": "1F1F5-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "pakistan"
            ]
        },
        {
            "no": 1719,
            "code": "1F1F5-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "poland"
            ]
        },
        {
            "no": 1720,
            "code": "1F1F5-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "miquelon",
                "pierre",
                "saint"
            ]
        },
        {
            "no": 1721,
            "code": "1F1F5-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "island",
                "pitcairn"
            ]
        },
        {
            "no": 1722,
            "code": "1F1F5-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "puerto rico"
            ]
        },
        {
            "no": 1723,
            "code": "1F1F5-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "palestine"
            ]
        },
        {
            "no": 1724,
            "code": "1F1F5-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "portugal"
            ]
        },
        {
            "no": 1725,
            "code": "1F1F5-1F1FC",
            "flagged": false,
            "keywords": [
                "flag",
                "palau"
            ]
        },
        {
            "no": 1726,
            "code": "1F1F5-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "paraguay"
            ]
        },
        {
            "no": 1727,
            "code": "1F1F6-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "qatar"
            ]
        },
        {
            "no": 1728,
            "code": "1F1F7-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "reunion",
                "réunion"
            ]
        },
        {
            "no": 1729,
            "code": "1F1F7-1F1F4",
            "flagged": false,
            "keywords": [
                "flag",
                "romania"
            ]
        },
        {
            "no": 1730,
            "code": "1F1F7-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "serbia"
            ]
        },
        {
            "no": 1731,
            "code": "1F1F7-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "russia"
            ]
        },
        {
            "no": 1732,
            "code": "1F1F7-1F1FC",
            "flagged": false,
            "keywords": [
                "flag",
                "rwanda"
            ]
        },
        {
            "no": 1733,
            "code": "1F1F8-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "saudi arabia"
            ]
        },
        {
            "no": 1734,
            "code": "1F1F8-1F1E7",
            "flagged": false,
            "keywords": [
                "flag",
                "island",
                "solomon"
            ]
        },
        {
            "no": 1735,
            "code": "1F1F8-1F1E8",
            "flagged": false,
            "keywords": [
                "flag",
                "seychelles"
            ]
        },
        {
            "no": 1736,
            "code": "1F1F8-1F1E9",
            "flagged": false,
            "keywords": [
                "flag",
                "sudan"
            ]
        },
        {
            "no": 1737,
            "code": "1F1F8-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "sweden"
            ]
        },
        {
            "no": 1738,
            "code": "1F1F8-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "singapore"
            ]
        },
        {
            "no": 1739,
            "code": "1F1F8-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "helena",
                "saint"
            ]
        },
        {
            "no": 1740,
            "code": "1F1F8-1F1EE",
            "flagged": false,
            "keywords": [
                "flag",
                "slovenia"
            ]
        },
        {
            "no": 1741,
            "code": "1F1F8-1F1EF",
            "flagged": false,
            "keywords": [
                "flag",
                "jan mayen",
                "svalbard"
            ]
        },
        {
            "no": 1742,
            "code": "1F1F8-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "slovakia"
            ]
        },
        {
            "no": 1743,
            "code": "1F1F8-1F1F1",
            "flagged": false,
            "keywords": [
                "flag",
                "sierra leone"
            ]
        },
        {
            "no": 1744,
            "code": "1F1F8-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "san marino"
            ]
        },
        {
            "no": 1745,
            "code": "1F1F8-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "senegal"
            ]
        },
        {
            "no": 1746,
            "code": "1F1F8-1F1F4",
            "flagged": false,
            "keywords": [
                "flag",
                "somalia"
            ]
        },
        {
            "no": 1747,
            "code": "1F1F8-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "suriname"
            ]
        },
        {
            "no": 1748,
            "code": "1F1F8-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "south",
                "south sudan",
                "sudan"
            ]
        },
        {
            "no": 1749,
            "code": "1F1F8-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "principe",
                "príncipe",
                "sao tome",
                "são tomé"
            ]
        },
        {
            "no": 1750,
            "code": "1F1F8-1F1FB",
            "flagged": false,
            "keywords": [
                "el salvador",
                "flag"
            ]
        },
        {
            "no": 1751,
            "code": "1F1F8-1F1FD",
            "flagged": false,
            "keywords": [
                "flag",
                "maarten",
                "sint"
            ]
        },
        {
            "no": 1752,
            "code": "1F1F8-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "syria"
            ]
        },
        {
            "no": 1753,
            "code": "1F1F8-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "swaziland"
            ]
        },
        {
            "no": 1754,
            "code": "1F1F9-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "tristan da cunha"
            ]
        },
        {
            "no": 1755,
            "code": "1F1F9-1F1E8",
            "flagged": false,
            "keywords": [
                "caicos",
                "flag",
                "island",
                "turks"
            ]
        },
        {
            "no": 1756,
            "code": "1F1F9-1F1E9",
            "flagged": false,
            "keywords": [
                "chad",
                "flag"
            ]
        },
        {
            "no": 1757,
            "code": "1F1F9-1F1EB",
            "flagged": false,
            "keywords": [
                "antarctic",
                "flag",
                "french"
            ]
        },
        {
            "no": 1758,
            "code": "1F1F9-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "togo"
            ]
        },
        {
            "no": 1759,
            "code": "1F1F9-1F1ED",
            "flagged": false,
            "keywords": [
                "flag",
                "thailand"
            ]
        },
        {
            "no": 1760,
            "code": "1F1F9-1F1EF",
            "flagged": false,
            "keywords": [
                "flag",
                "tajikistan"
            ]
        },
        {
            "no": 1761,
            "code": "1F1F9-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "tokelau"
            ]
        },
        {
            "no": 1762,
            "code": "1F1F9-1F1F1",
            "flagged": false,
            "keywords": [
                "east",
                "east timor",
                "flag",
                "timor-leste"
            ]
        },
        {
            "no": 1763,
            "code": "1F1F9-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "turkmenistan"
            ]
        },
        {
            "no": 1764,
            "code": "1F1F9-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "tunisia"
            ]
        },
        {
            "no": 1765,
            "code": "1F1F9-1F1F4",
            "flagged": false,
            "keywords": [
                "flag",
                "tonga"
            ]
        },
        {
            "no": 1766,
            "code": "1F1F9-1F1F7",
            "flagged": false,
            "keywords": [
                "flag",
                "turkey"
            ]
        },
        {
            "no": 1767,
            "code": "1F1F9-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "tobago",
                "trinidad"
            ]
        },
        {
            "no": 1768,
            "code": "1F1F9-1F1FB",
            "flagged": false,
            "keywords": [
                "flag",
                "tuvalu"
            ]
        },
        {
            "no": 1769,
            "code": "1F1F9-1F1FC",
            "flagged": false,
            "keywords": [
                "china",
                "flag",
                "taiwan"
            ]
        },
        {
            "no": 1770,
            "code": "1F1F9-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "tanzania"
            ]
        },
        {
            "no": 1771,
            "code": "1F1FA-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "ukraine"
            ]
        },
        {
            "no": 1772,
            "code": "1F1FA-1F1EC",
            "flagged": false,
            "keywords": [
                "flag",
                "uganda"
            ]
        },
        {
            "no": 1773,
            "code": "1F1FA-1F1F2",
            "flagged": false,
            "keywords": [
                "america",
                "flag",
                "island",
                "minor outlying",
                "united",
                "united states",
                "us",
                "usa"
            ]
        },
        {
            "no": 1774,
            "code": "1F1FA-1F1F8",
            "flagged": false,
            "keywords": [
                "america",
                "flag",
                "stars and stripes",
                "united",
                "united states"
            ]
        },
        {
            "no": 1775,
            "code": "1F1FA-1F1FE",
            "flagged": false,
            "keywords": [
                "flag",
                "uruguay"
            ]
        },
        {
            "no": 1776,
            "code": "1F1FA-1F1FF",
            "flagged": false,
            "keywords": [
                "flag",
                "uzbekistan"
            ]
        },
        {
            "no": 1777,
            "code": "1F1FB-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "vatican"
            ]
        },
        {
            "no": 1778,
            "code": "1F1FB-1F1E8",
            "flagged": false,
            "keywords": [
                "flag",
                "grenadines",
                "saint",
                "vincent"
            ]
        },
        {
            "no": 1779,
            "code": "1F1FB-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "venezuela"
            ]
        },
        {
            "no": 1780,
            "code": "1F1FB-1F1EC",
            "flagged": false,
            "keywords": [
                "british",
                "flag",
                "island",
                "virgin"
            ]
        },
        {
            "no": 1781,
            "code": "1F1FB-1F1EE",
            "flagged": false,
            "keywords": [
                "america",
                "american",
                "flag",
                "island",
                "united",
                "united states",
                "us",
                "usa",
                "virgin"
            ]
        },
        {
            "no": 1782,
            "code": "1F1FB-1F1F3",
            "flagged": false,
            "keywords": [
                "flag",
                "viet nam",
                "vietnam"
            ]
        },
        {
            "no": 1783,
            "code": "1F1FB-1F1FA",
            "flagged": false,
            "keywords": [
                "flag",
                "vanuatu"
            ]
        },
        {
            "no": 1784,
            "code": "1F1FC-1F1EB",
            "flagged": false,
            "keywords": [
                "flag",
                "futuna",
                "wallis"
            ]
        },
        {
            "no": 1785,
            "code": "1F1FC-1F1F8",
            "flagged": false,
            "keywords": [
                "flag",
                "samoa"
            ]
        },
        {
            "no": 1786,
            "code": "1F1FD-1F1F0",
            "flagged": false,
            "keywords": [
                "flag",
                "kosovo"
            ]
        },
        {
            "no": 1787,
            "code": "1F1FE-1F1EA",
            "flagged": false,
            "keywords": [
                "flag",
                "yemen"
            ]
        },
        {
            "no": 1788,
            "code": "1F1FE-1F1F9",
            "flagged": false,
            "keywords": [
                "flag",
                "mayotte"
            ]
        },
        {
            "no": 1789,
            "code": "1F1FF-1F1E6",
            "flagged": false,
            "keywords": [
                "flag",
                "south",
                "south africa"
            ]
        },
        {
            "no": 1790,
            "code": "1F1FF-1F1F2",
            "flagged": false,
            "keywords": [
                "flag",
                "zambia"
            ]
        },
        {
            "no": 1791,
            "code": "1F1FF-1F1FC",
            "flagged": false,
            "keywords": [
                "flag",
                "zimbabwe"
            ]
        }
    ]
}